/**
 * for vendor customize
 * @module vendorCustom/customize
 */
define('vendorCustom/customize',['uni-e-fi/$efi', 'uni-e-approval/$ewf'], function(){
    return function(){
        // $u
        var _renderUIComponents = $u.renderUIComponents;
        $u.renderUIComponents = function ($scope, subGroup, customParam) {
            _renderUIComponents($scope, subGroup, customParam);
            $efi.currencyEventAfterRender($scope)
        };

        $u.customizeView(window.viewCustomize, [
            'unidocu-ui/view/main2018',
            'uni-e-fi/view/UD_0202_001',
            'uni-e-fi/view/UD_0201_001',
            'uni-e-fi/view/UD_0201_011',
            'uni-e-fi/view/UD_0204_100',
            'uni-e-fi/view/UD_0201_031',
            'uni-e-fi/view/UD_0203_001',
            'unidocu-ui/view/UD_0702_000'
        ]);

        $u.customizeView(window.baseCustomize, [
            'uni-e-fi/view/UniDocu001/UD_0201_000',
            'uni-e-fi/view/UniDocu001/UD_0201_010',
            'uni-e-fi/view/UniDocu001/UD_0201_100',
            'uni-e-fi/view/UniDocu001/UD_0302_000',
            'uni-e-fi/view/UniDocu001/UD_0601_030'
        ]);

        $u.customizeTemplate(window.templateCustomize, [
        ]);

        $.extend($mlsCode, {
            "M_empInsuranceDialog_month": "신고월을 입력해주세요.",
            "M_inputOnlyNumber": "숫자만 입력가능합니다.",
            "M_inputDigitCheck": "$rowIndex$자리를 입력해 주세요.",
            "M_check_empInsuranceDialog": "예술인 고용보험 입력 대상인가요?",
            "M_artistDuplicateCheck": "아티스트 중복 불가",
            "M_addData_advanceCost_FROM": "시작일은 종료일과 같거나 작아야합니다.",
            "M_InputLIFNR": "공급업체를 입력해주세요.",
            "M_EmpInsurance_LIFNR": "해당 거래처는 예술인 고용보험 입력 대상이 아닙니다.",
            "M_UD_0302_000_Max_checkbox": "최대 한 건만 선택 가능합니다. (법인카드 제외)",
            "M_loginRetry": "아이디/비밀번호를 확인해주세요.",
            "M_CPUDT_BLDAT_diff": "발생일자와 증빙일자가 다릅니다.\n전표생성 하시겠습니까?",
            "M_InvalidCharIncluded": "입력 불가한 문자가 포함되어 있습니다.",
            "M_SWSTE_Exceed": "소득세 수정 범위 초과",
            "M_JWSTE_Exceed": "주민세 수정 범위 초과",
            "M_SWSTE_jWSTE_Exceed": "소득세/주민세 중복 수정 불가"
        });

        $u.templateLayout.bindLayoutElementClick = function () {
            function getUniDocuTablePadding() {
                return Number($('.unidocu-table .unidocu-th').css('padding-top').replace('px', ''));
            }

            function setUniDocuTablePadding(padding) {
                if (padding > 10) return;
                var $unidocuTableElement = $('.unidocu-table .unidocu-th, .unidocu-table .unidocu-td');
                $unidocuTableElement.css('padding-top', padding + 'px');
                $unidocuTableElement.css('padding-bottom', padding + 'px');
                $(window).trigger('resize');
            }

            $('.logoff').click(function () {
                location.href = $u.getUrlFromRoot('/cas/logout.do');
            });
            $('#top-logo').click($u.moveToHome);
            $('#my-page').click($u.moveToHome);
            $('#wider-screen').click(function () {
                setUniDocuTablePadding(getUniDocuTablePadding() + 1);
            });
            $('#narrow-screen').click(function () {
                setUniDocuTablePadding(getUniDocuTablePadding() - 1);
            });
            $('.unidocu-button[data-action=excelDownload]').click($u.excelDownload);
            $('.user-id').click(function () {
                $u.dialog.userInfoDialog.open();
            });
            $('#clear-all-cache').click(function () {
                $u.locationReload();
            });
            $('#unidocu-page').click(function() {
                location.href = $u.getUrlFromRoot('/unidocu/view.do#UD_0703_000');
            });
            $('.guide-user-id').click(function() {
                $u.dialog.jsonDialog.open("Development User : " + staticProperties.user.GNAME + "<br>" + "Unidocu User : " + staticProperties.user.SNAME ,'UserInfo')
            });
            $('#layout-wrapper i').click(function (event) {
                var targetId = $(event.target).attr("id");
                var $layoutWrapper = $('#layout-wrapper');
                $layoutWrapper.find('i').removeClass('selected');
                $layoutWrapper.find('#' + targetId).addClass('selected');

                $u.util.localStorage.set('menu-layout', targetId);
                $u.locationReload();
            });
            $('#change-pw-before-login').click(function(){
                var $destination_alias = $('#DESTINATION_ALIAS');
                var $dialog = $($u.mustache.changePasswordBeforeLoginDialogTemplate());
                var $id = $dialog.find('#dialog-ID');
                var $pw_old = $dialog.find('#dialog-PW_OLD');
                var $pw_new = $dialog.find('#dialog-PW_NEW');
                var $pw_new_confirm = $dialog.find('#dialog-PW_NEW_CONFIRM');
                $id.val(staticProperties.user.ID);
                $dialog.find('input').keypress(function (e) {
                    if (e.which === 13) changePassword();
                });
                $id.val($id.val());
                $id.attr("readonly",true);
                $($pw_old,$pw_new,$pw_new_confirm).attr("autocomplete", "new-password")
                $id.keyup(function () {
                    if (/[a-z]/.test($(this).val())) $(this).val($(this).val().toUpperCase());
                }).focus();
                function changePassword() {
                    var id = $id.val();
                    var pw_old = $pw_old.val();
                    var pw = $pw_new.val();
                    var checkPW = $pw_new_confirm.val();
                    $u.buttons.runCustomHandler('changePasswordByUser', id, pw_old, pw, checkPW, $dialog);
                }
                $u.baseDialog.openModalDialog($dialog, {
                    title: $mls.getByCode('DLT_changeUserPassword'),
                    buttons: [
                        $u.baseDialog.getButton($mls.getByCode('DLB_cancel'), function () {
                            $dialog.dialog('close')
                        }),
                        $u.baseDialog.getButton($mls.getByCode('DLB_save'), changePassword, 'unidocu-button dialogBlack')
                    ]
                });
                $u.buttons.addCustomHandler({
                    changePasswordByUser: function (id, pw_old, pw, checkPW, $dialog) {
                        if (!pw_old) throw $mls.getByCode('M_enterPassword');
                        $u.buttons.runCustomHandler('chanePasswordValidation', pw, checkPW);
                        var paramMap = {
                            ID: id,
                            PW2_OLD: $u.thirdParty.sha256(pw_old),
                            PW2_NEW: $u.thirdParty.sha256(pw),
                            __DEST: $destination_alias.val()
                        };
                        $nst.is_data_returnMessage('ZUNIECM_9002', paramMap, function (message) {
                            unidocuAlert(message, function () {
                                $dialog.dialog('close');
                            });
                        });
                    },
                    chanePasswordValidation: function(pw, checkPW){
                        if(!pw || !checkPW) throw $mls.getByCode('M_enterPassword');
                        if(pw !== checkPW) throw($mls.getByCode('M_incorrectPassword'));
                    }});
            });

            if(!staticProperties.serverAlias.startsWith('sment_prd')){ // 개발서버인 경우 로고 추가
                var secondLogoDiv = $('<div>', { id: 'dev-logo' });
                $('#top-logo').after(secondLogoDiv);
            }

        };

        $u.dialog.f4CodeDialog.open = function (dialogParams) {
            const gridObj = $u.gridWrapper.getGrid();
            if ($u.util.contains(dialogParams['popupKey'], ['PROJK', 'PROJK2'])) dialogParams['dialogWidth'] = 900;
            // 대량 일괄적용에 있는 내부오더 제어를 위해 AUFNR__DIALOG 로 함
            if ($sment.useGridAUNFRPopupProgramId() && (dialogParams['popupKey'] === 'AUFNR' || dialogParams['popupKey'] === 'AUFNR__DIALOG')) {
                const isMassStatement = dialogParams['popupKey'] === 'AUFNR__DIALOG';
                if (isMassStatement) {
                    dialogParams['readonlyInfo'] = { key : 'PROJK', value : $u.get('PROJK__DIALOG').getValue(), useGridAUNFRPopup : true };
                    dialogParams['popupKey'] = 'AUFNR';
                } else {
                    const currentPROJK = gridObj.$V('PROJK', gridObj.getActiveRowIndex());
                    dialogParams['readonlyInfo'] = { key : 'PROJK', value : currentPROJK, useGridAUNFRPopup : true };
                }
            }
            var dialogData = $u.dialog.f4CodeDialog._initialize(dialogParams);

            $u.dialog.f4CodeDialog._bindEvent(dialogData);
            $u.dialog.f4CodeDialog._bindButtonEvent(dialogData);
            $u.buttons.triggerFormTableButtonClick('f4-search-condition');

            return dialogData.$dialog;
        };

        $u.dialog.f4CodeDialog._bindEvent = function (dialogData) {
            dialogData.gridObj.onCellClick(function (columnKey, rowIndex) {
                if (columnKey === 'SELECTED' || columnKey !== dialogData.gridColumnListData.codeKey) return;
                var rowData = dialogData.gridObj.getJSONDataByRowIndex(rowIndex);
                $u.dialog.f4CodeDialog._runCallback(dialogData, rowData);
            });
            dialogData.gridObj.onCellDblClick(function (columnKey, rowIndex) {
                if (columnKey === 'SELECTED' || columnKey !== dialogData.gridColumnListData.textKey) return;
                var rowData = dialogData.gridObj.getJSONDataByRowIndex(rowIndex);
                $u.dialog.f4CodeDialog._runCallback(dialogData, rowData);
            });

            if (dialogData.gridObj.getGridHeader('TT_DESC')) {
                dialogData.gridObj.useColumnTooltip(dialogData.gridColumnListData.codeKey, true);
                dialogData.gridObj.onShowTooltip(function (columnKey, rowIndex) {
                    if (!dialogData.gridObj.$V('TT_DESC', rowIndex)) return true;
                    var width = $($u.gridWrapper.getGrid('dialog-unidocu-grid')).width();
                    var wrapper_preFix = $u.util.formatString('<div style="background-color: #FFF2AB; width: {0}; white-space: normal;">', [width + 100]);
                    var wrapper_postFix = '</div>';
                    return wrapper_preFix + dialogData.gridObj.$V('TT_DESC', rowIndex) + wrapper_postFix;
                });
            }

            dialogData.$u_searchCondition.$el.change(function () {
                dialogData.$u_searchWord.setEmptyValue();
                dialogData.$u_searchWord.$el.find('input').focus();
            });

            dialogData.$u_searchWord.$el.keydown(function (e) {
                if (e.which === 13) {
                    e.preventDefault();
                    e.stopPropagation();
                    $u.buttons.triggerFormTableButtonClick('f4-search-condition');
                }
            });

            // 브라우저 자동완성으로 해당 Input 이 ReadOnly 여도 값을 넣을 수 있어서 추가함.
            if ($sment.useGridAUNFRPopupProgramId()) {
                if (dialogData.readonlyInfo && dialogData.readonlyInfo.useGridAUNFRPopup) {

                    dialogData.$u_searchWord.$el.change(function () {
                        dialogData.$u_searchWord.setValue(dialogData.readonlyInfo.value);
                    });
                }
            }

            dialogData.$u_FAVOR.$el.change(function () {
                $u.dialog.f4CodeDialog._handleFavoriteButtonVisible(dialogData.$dialog, dialogData.$u_FAVOR);
                $u.buttons.triggerFormTableButtonClick('f4-search-condition');
            });
        };

        function nsReturnToCodeData(nsReturn, popupKey) {
            var codeInfo = $u.f4Data.getCodeInfo(popupKey);
            var columnMap = {};
            $.each(codeInfo['outputFields'], function (index, outputField) {
                columnMap['F' + outputField['position']] = outputField['id'];
            });
            var codeData = [];
            $.each(nsReturn.getTableReturn('OT_DATA'), function (index, item) {
                var map = {};
                $.each(columnMap, function (position, id) {
                    map[id] = item[position];
                });
                codeData.push(map);
            });
            return codeData;
        }

        $u.f4Data.getCodeDataWithParams = function (popupKey, params, callback) {

            var gridObj = $u.gridWrapper.getGrid();
            var importParam = {FOBJ: popupKey};
            $.extend(importParam, params);
            var it_data = [];
            $.each(importParam, function (key, value) {
                it_data.push({KEY: key, VALUE: value});
            });

            if (importParam['FOBJ'] === 'HKONT') {
                if ($u.util.contains($u.page.getPROGRAM_ID(),['DRAFT_A01', 'DRAFT_A02', 'DRAFT_P01', 'DRAFT_C01', 'DRAFT_D01'])) {
                    it_data.push({KEY: 'PROJK', VALUE: $u.get('ZPSPNR_F').getValue()});
                } else if ($u.util.contains($u.page.getPROGRAM_ID(),['UD_0601_070'])) {
                    it_data.push({KEY: 'PROJK', VALUE: $u.get('PSPNR').getValue()});
                } else if ($u.util.contains($u.page.getPROGRAM_ID(), ['UD_0802_021'])) {
                    it_data.push({KEY: 'PROJK', VALUE: $u.get('PROJK').getValue()});
                } else {
                    if ($u.get('HKONT__DIALOG')) it_data.push({KEY: 'PROJK', VALUE: $u.get('PROJK__DIALOG').getValue()});
                    else it_data.push({KEY: 'PROJK', VALUE: gridObj.$V('PROJK', gridObj.getActiveRowIndex())});
                }

                if ($u.get('AUFNR__DIALOG')) {
                    it_data.push({KEY: 'AUFNR', VALUE: $u.get('AUFNR__DIALOG').getValue()});
                } else if (gridObj.getGridHeader('AUFNR')) {
                    it_data.push({KEY: 'AUFNR', VALUE: gridObj.$V('AUFNR', gridObj.getActiveRowIndex())});
                }
            }

            if (importParam['FOBJ'] === 'KOSTL') {
                if ($u.util.contains($u.page.getPROGRAM_ID(),['DRAFT_A01', 'DRAFT_A02', 'DRAFT_P01', 'DRAFT_C01', 'DRAFT_D01'])) {
                    it_data.push({KEY: 'PROJK', VALUE: $u.get('ZPSPNR_F').getValue()});
                } else if ($u.util.contains($u.page.getPROGRAM_ID(),['UD_0601_070'])) {
                    it_data.push({KEY: 'PROJK', VALUE: $u.get('PSPNR').getValue()});
                } else if ($u.util.contains($u.page.getPROGRAM_ID(),['UD_0201_010', 'UD_SM_5000', 'UD_0302_010', 'UD_0801_020'])) {
                    it_data.push({KEY: 'PROJK', VALUE: ''});
                } else {
                    if ($u.get('KOSTL__DIALOG')) it_data.push({KEY: 'PROJK', VALUE: $u.get('PROJK__DIALOG').getValue()});
                    else it_data.push({KEY: 'PROJK', VALUE: gridObj.$V('PROJK', gridObj.getActiveRowIndex())});
                }

                if ($u.get('AUFNR__DIALOG')) {
                    it_data.push({KEY: 'AUFNR', VALUE: $u.get('AUFNR__DIALOG').getValue()});
                } else if (gridObj.getGridHeader('AUFNR')) {
                    it_data.push({KEY: 'AUFNR', VALUE: gridObj.$V('AUFNR', gridObj.getActiveRowIndex())});
                }
            }

            if (importParam['FOBJ'] === 'ZTERM') {
                if (!$u.util.contains($u.page.getPROGRAM_ID(),['UD_SM_2000'])) {
                    if ($u.get('BUDAT')) {
                        it_data.push({KEY: 'BUDAT', VALUE: $u.get('BUDAT').getValue()});
                    } else if (gridObj.getGridHeader('BUDAT')) {
                        it_data.push({KEY: 'BUDAT', VALUE: gridObj.$V('BUDAT', gridObj.getActiveRowIndex())});
                    }
                    if ($u.get('BLDAT')) {
                        it_data.push({KEY: 'BLDAT', VALUE: $u.get('BLDAT').getValue()});
                    } else if (gridObj.getGridHeader('BLDAT')) {
                        it_data.push({KEY: 'BLDAT', VALUE: gridObj.$V('BLDAT', gridObj.getActiveRowIndex())});
                    }
                }
            }

            if (callback) {
                $nst.is_data_it_data_nsReturn('ZUNIECM_3001', importParam, it_data, function (nsReturn) {
                    callback(nsReturnToCodeData(nsReturn, popupKey))
                });
            } else {
                return nsReturnToCodeData($nst.is_data_it_data_nsReturn('ZUNIECM_3001', importParam, it_data), popupKey);
            }
        };

        // $efi
        $efi.createStatement.bindEvent.bindCommonFormEvent = function (){
            if (!$u.programSetting.getTemplate()['onFormBeforeOpenF4DialogParams']) {
                $u.programSetting.appendTemplate('onFormBeforeOpenF4DialogParams', {
                    defaultValue: {},
                    type: 'json',
                    description: 'form codePopup F4 조회시 추가 파라미터 설정'
                });
            }

            $sment.handleLIFNR();
            $sment.handleWT_WITHCD();
            $efi.createStatement.bindEvent.bindVendorCodeChange();
            $efi.createStatement.bindEvent.bindWRBTRChange();
            $efi.createStatement.bindEvent.bindWMWSTChange();
            $efi.createStatement.bindEvent.bindWMWSTDblClick();
            $efi.createStatement.bindEvent.bindBUDATChange();
            $efi.createStatement.bindEvent.bindZTERM_BUDATChange();
            $efi.createStatement.bindEvent.bindMWSKZChange();
            $efi.createStatement.bindEvent.bindEMPFBChange();
            $efi.createStatement.bindEvent.onFormF4QueryParams();
            $efi.createStatement.bindEvent.bindGL_ALIASChange();
        }

        $efi.createStatementCommon.bindFormButton = function () {
            var gridObj = $u.gridWrapper.getGrid();
            const PROGRAM_ID = $u.page.getPROGRAM_ID();
            $u.buttons.addHandler({
                addRow: $efi.createStatementCommon.addRow,
                deleteRow: function () { //
                    gridObj.deleteSelectedRows();
                    $efi.createStatementCommon.changeWRBTRExpense('WRBTR');
                    if ($u.buttons.getCustomHandler('changeWRBTR_AMOUNT')) $u.buttons.runCustomHandler('changeWRBTR_AMOUNT');
                    $sment.deleteRow_setMWSKZ_By_HKONT_F4();
                    $sment.setTaxAndNonDeduction();
                },
                initPage: $efi.createStatementCommon.initPage,
                templateDownload: function () {
                    $u.excel.templateDownload(gridObj, $efi.createStatementCommon.addRow);
                },
                "adjustWMWST": function () {
                    var $u_WMWST_READ_ONLY = $u.get('WMWST_READ_ONLY');
                    var $u_WMWST = $u.get('WMWST');

                    if (!$u_WMWST_READ_ONLY) throw 'WMWST_READ_ONLY form field required';
                    if (!$u_WMWST) throw 'WMWST form field required';

                    var wmwst_read_only = $u_WMWST_READ_ONLY.getValue();
                    var wmwst = $u_WMWST.getValue();
                    if (Math.abs(wmwst_read_only - wmwst) === 0) throw '계산된 세액과 증빙 세액이 동일합니다.';
                    if (Math.abs(wmwst_read_only - wmwst) >= 10) throw '계산된 세액과 증빙 세액의 차이가 10원 미만인 경우만 수행 가능 합니다.';

                    $u_WMWST.setValue(wmwst_read_only);
                    $u_WMWST.$el.change();
                },
                "addCopyRow": function(artistItem) { // 행 복사 버튼
                    const PROGRAM_ID = $u.page.getPROGRAM_ID();
                    const addCopyRowFunction = (item) => {
                        delete item['SELECTED'];
                        if (artistItem) {
                            const { AUCOD, AUNAM, ATCOD, ATNAM, WRBTR } = artistItem;
                            Object.assign(item, { AUCOD, AUNAM, ATCOD, ATNAM, WRBTR });
                            // ARTISTDATA 에는 WRBTR 이 들어가면 안되서 이렇게 처리함.
                            delete artistItem['WRBTR'];
                            Object.assign(item, { ARTISTDATA: JSON.stringify([artistItem]) });
                        }
                        gridObj.addRowByJSONData(item);
                        var f4Data = $u.f4Data.getCodeMapWithParams('HKONT', 'WEB_EVENT', {HKONT: item['HKONT']});
                        const f4Data_GLTYPE = $u.f4Data.getCodeMapWithParams('HKONT', 'GLTYPE', {HKONT: item['HKONT']});
                        var activeRowIndex = gridObj.getActiveRowIndex();
                        //의상비 메뉴
                        if ($sment.useCSTProgramId()) {
                            if (f4Data[item['HKONT']] === 'X') {
                                $.each(['CST_NUM', 'CST_BUY_DATE', 'CST_BRAND_NAME', 'CST_ITEM_NAME', 'CST_ITEM_CODE', 'CST_WEAR', 'PARTNER'], function(_, item) {
                                    if (/CST_NUM|PARTNER/.test(item)) {
                                        gridObj.makeCellEditable(item, activeRowIndex);
                                        gridObj.setCellBgColor(item, activeRowIndex, '255|252|209');
                                        gridObj.makeCellRequired(item, activeRowIndex);
                                    }
                                    if (/CST_BUY_DATE|CST_BRAND_NAME|CST_ITEM_NAME|CST_ITEM_CODE|CST_WEAR/.test(item)) {
                                        if (gridObj.$V('CST_NUM', activeRowIndex) === 'Y') {
                                            gridObj.makeCellEditable(item, activeRowIndex);
                                            gridObj.setCellBgColor(item, activeRowIndex, '255|252|209');
                                            gridObj.makeCellRequired(item, activeRowIndex);
                                        } else {
                                            gridObj.makeCellReadOnly(item, activeRowIndex);
                                            gridObj.$V(item, activeRowIndex, '');
                                        }
                                    }
                                });
                            }
                        }
                        //계정대체 메뉴
                        if ($sment.useAccountSubstitutionProgramId()) {
                            gridObj.$V('SEARCH_FLAG', activeRowIndex, '');

                            if (f4Data_GLTYPE[item['HKONT']] === 'X') {
                                gridObj.makeCellReadOnly('LIFNR', activeRowIndex);
                                gridObj.$V('LIFNR', activeRowIndex, '');
                                gridObj.$V('LIFNR_TXT', activeRowIndex, '');
                            } else {
                                gridObj.makeCellEditable('LIFNR', activeRowIndex);
                            }
                        }

                        if(item.HKONT) {
                            var hkontF4 = $sment.getCodeDataWithParams('HKONT', {HKONT : item.HKONT});
                            if(hkontF4.length > 0){ // 해당 라인 조회 후 나오는 hkont 의 0번쨰 값 mwskz2 값 기준 설정
                                $sment.setVATFromHKONTFlag(activeRowIndex, hkontF4[0]);
                                $sment.setCARNOFromHKONTFlag(activeRowIndex, hkontF4[0]);
                                $sment.handleTaxAndNonDeduction(activeRowIndex, hkontF4[0]);
                            }
                        }
                        gridObj.triggerChangeCell('WRBTR', activeRowIndex);
                        if ($u.get('WT_WITHCD') && $u.get('WT_WITHCD').getValue()) gridObj.makeCellReadOnly('MWSKZ', activeRowIndex);

                        $sment.checkColumns_addCopyRows_OR_excelupload(activeRowIndex, item);
                    }

                    // artistItem 이 있다는 건 아티스트 분할 복사를 사용
                    if (artistItem) {
                        const currentRowIndex = gridObj.getActiveRowIndex();
                        addCopyRowFunction(gridObj.getJSONDataByRowIndex(currentRowIndex));
                    } else {
                        gridObj.asserts.rowSelected();
                        $.each(gridObj.getSELECTEDJSONData(), function(index, item) {
                            addCopyRowFunction(item);
                        });
                    }
                }
            });

            $u.excel.bindExcelUploadHandler(gridObj, function(gridData){
                var startColumnKey = gridObj.getGridHeaders()[0].key;
                var endColumnKey = gridObj.getGridHeaders()[gridObj.getGridHeaders().length - 1].key;
                var startRowIndex = 0;
                var endRowIndex = gridData.length - 1;
                $efi.createStatement.afterMultiCellChange(startColumnKey, startRowIndex, endColumnKey, endRowIndex, '', gridData);

                $nst.is_data_ot_data('ZUNIEFI_U1200', {}, function(ot_data) {
                    // useTaxAndNonDeductionProgramId 에서는 NON_FLAG 로 세금코드 제어, readOnly 처리 하는 부분 존재
                    let hasNonFlag = false;
                    if ($sment.useTaxAndNonDeductionProgramId()) hasNonFlag = gridObj.getJSONData().some(gridItem => gridItem['NON_FLAG'] !== '');
                    $.each(gridData, function(index, data) {
                        if (!hasNonFlag || MWSKZ === 'X2') {
                            if ($u.get('WT_WITHCD') && gridObj.getGridHeader('MWSKZ')) {
                                if ($u.get('MWSKZ').isReadOnly()) {
                                    gridObj.$V('MWSKZ', index, '');
                                    gridObj.makeCellReadOnly('MWSKZ', index);
                                }
                            }
                        }
                        data = $sment.checkColumns_addCopyRows_OR_excelupload(index, data, true);

                        $sment.gridWBS_callRFC(index, ot_data);
                        $sment.setGridExcelUpload(index, data, ot_data);
                        $sment.setGrid_HKONTbyGLTYPEorWEBEVENT(index, data);
                        $sment.setGrid_PARTNER_TXT(index, data);
                        $sment.removeARTISTDATA(gridObj);
                    });
                });
            });
        };

        $efi.createStatementCommon.addRow = function () {
            var gridObj = $u.gridWrapper.getGrid();
            const PROGRAM_ID = $u.page.getPROGRAM_ID();
            const PROGRAMID_SPECIAL = ['UD_0202_021Z', 'UD_0202_021Z_1', 'UD_0202_021Y','UD_0202_021Y_1'];

            gridObj.addRowWithGridPopupIcon();
            var activeRowIndex = gridObj.getActiveRowIndex();
            if ($efi.createStatementCommon.isEvidenceAmountNegative()) gridObj.$V('SHKZG', activeRowIndex, 'H');
            else gridObj.$V('SHKZG', activeRowIndex, 'S');

            if ($u.util.contains(PROGRAM_ID, PROGRAMID_SPECIAL)) {
                gridObj.makeCellReadOnly('SHKZG', activeRowIndex);
                gridObj.makeCellReadOnly('AKONT', activeRowIndex);
                gridObj.makeCellReadOnly('SPECIAL', activeRowIndex);
            }
            if (PROGRAM_ID === 'UD_0201_001C') { //법인카드(건별)-개인사용분
                gridObj.$V('MWSKZ', activeRowIndex, 'AA');
            } else if (!$u.util.contains(PROGRAM_ID, PROGRAMID_SPECIAL)) {
                if ($u.get('MWSKZ') && gridObj.getGridHeader('MWSKZ')) {
                    gridObj.$V('MWSKZ', activeRowIndex, $u.get('MWSKZ').getValue());
                }
            }
            if ($u.get('WT_WITHCD') && $u.get('WT_WITHCD').getValue()) gridObj.makeCellReadOnly('MWSKZ', activeRowIndex);
            $efi.createStatementCommon.setDefaultGridValues(activeRowIndex);

            // #2106 선급비용 그리드에 사업영역 default 값지정 ( 사용자요구 )
            if (gridObj.getGridHeader('GSBER') && staticProperties.user['GSBER']) gridObj.$V('GSBER', activeRowIndex, staticProperties.user['GSBER']);
            if (gridObj.getGridHeader('GSBER_TXT') && staticProperties.user['GSBER_TXT']) gridObj.$V('GSBER_TXT', activeRowIndex, staticProperties.user['GSBER_TXT']);
            $efi.createStatementCommon.changeWRBTRExpense('addRow');
            $efi.addDataHandler.handleADD_DATAKeyChange(activeRowIndex);
        };

        $u.unidocuCurrency.bind_setKRUSF_onWAERS_BUDAT_change = function () {
            if ($u.get('WAERS')) $u.get('WAERS').$el.change($u.unidocuCurrency.setKRUSF).change();
            if ($u.get('BUDAT')) $u.get('BUDAT').$el.change($u.unidocuCurrency.setKRUSF).change();
        };

        $u.unidocuCurrency.setKRUSF = function () {
            var $deferred = $.Deferred();

            var $u_kursf = $u.get('KURSF');
            var $u_budat = $u.get('BUDAT');
            var $u_waers = $u.get('WAERS');

            if (!$u_waers) return;
            if (!$u_budat) return;
            if (!$u_kursf) return;

            var isWAERS_codeComboType = $u_waers.getType() === 'Uni_CodeCombo';
            var params = {
                BUDAT: $u_budat.getValue(),
                WAERS: $u_waers.getValue()
            };

            if (!params['WAERS'] || params['WAERS'] === 'KRW') {
                $u_kursf.setValue(1);
                $u_kursf.setReadOnly(true);
                if (isWAERS_codeComboType) $u_waers.setOldValue($u_waers.getValue());
                $efi.createStatement.calculateWithcdTax();
                $deferred.resolve();
            } else {
                $u_kursf.setReadOnly(false);
                $nst.is_data_stringReturns('ZUNIECM_7008', params, function (stringReturns) {
                    $u_kursf.setValue(Number(stringReturns['O_KURSF']));
                    if (isWAERS_codeComboType) $u_waers.setOldValue($u_waers.getValue());
                    $efi.createStatement.calculateWithcdTax();
                    $deferred.resolve();
                }, function () {
                    if (isWAERS_codeComboType) {
                        $u_waers.setOldValue($u_waers.getOldValue());
                        $u_waers.setValue($u_waers.getOldValue());
                    }

                    $deferred.resolve();
                });
            }
            return $deferred;
        };

        $efi.createStatement.callCreateStatementFn = function (params) {
            function callFunction() {
                var paramMap = params['paramMap'];
                var gridData = params['gridData'];
                var useReload = params['useReload'];
                const PAGE_PARAMS = $u.page.getPageParams();

                $efi.createStatement.koart_newko.handleGridData(gridData);

                if (PAGE_PARAMS['isEditStatement']) {
                    paramMap['BELNR'] = PAGE_PARAMS['BELNR'];
                    paramMap['GJAHR'] = PAGE_PARAMS['GJAHR'];
                    paramMap['BUKRS'] = PAGE_PARAMS['BUKRS'];
                }

                var tableParams = {IT_DATA: gridData};
                if (/^UD_0201_011$|^UD_0202_021$|^UD_0202_021_2$|^UD_0208_021$|^UD_SM_6000$/.test($u.page.getPROGRAM_ID())) {
                    if ($u.buttons.getCustomHandler('getEmpInsurance')) {
                        var empInsurance = $u.buttons.runCustomHandler('getEmpInsurance');
                        $.extend(tableParams, empInsurance);
                    } else if (!$u.page.getCustomParam()['editstatementInitialLoad'] && $u.page.getPageParams()['isEditStatement']) {
                        const {emp_insurance_A, emp_insurance_B} = $u.page.getPageParams();
                        const emp_insurance = {};

                        if (emp_insurance_A.length) emp_insurance['IT_DATA2'] = emp_insurance_A;
                        else if (emp_insurance_B.length) emp_insurance['IT_DATA3'] = emp_insurance_B;

                        if (emp_insurance.length) $.extend(tableParams, emp_insurance);
                    }
                }
                tableParams['IT_ATTACH'] = $u.fileUI.getFineUploader().getCopiedFileInfos();

                function confirmCreateStatement() {
                    $nst.is_data_tableParams_os_docno($u.programSetting.getValue('setCreateStatementFunction'), paramMap, tableParams, function (os_docNo) {
                        var callbackFn = null;
                        if (useReload) callbackFn = $u.pageReload;
                        if ($u.page.getPageParams()['isEditStatement']) {
                            callbackFn = $u.navigateByProgramId($u.page.getPageParams()['PROGRAM_ID']);
                        }
                        if (params['afterWhenCreateStatement']) params['afterWhenCreateStatement'](os_docNo);
                        else $efi.dialog.afterCreateStatementDialog.open(os_docNo, callbackFn);
                    });
                }
                $efi.createStatement.confirmBeforeCreateStatement(paramMap, tableParams, function () {
                    if ($u.gridWrapper.getGrid().getGridHeader('CPUDT') && gridData.length === 1) {
                        if (gridData[0]['CPUDT'] !== $u.get('BLDAT').getValue()) {
                            setTimeout(function () {
                                $('.unidocu-button.dialogBlack.ui-button.ui-corner-all.ui-widget').text('진행');
                            }, 30);
                            unidocuConfirm($mls.getByCode("M_CPUDT_BLDAT_diff"), function() {
                                confirmCreateStatement();
                            });
                        } else confirmCreateStatement();
                    } else confirmCreateStatement();
                });
            }

            if ($efi.addDataHandler.hasDataAll()) {
                unidocuConfirm("추가데이터 없이 계속 진행하시겠습니까?", function () {
                    callFunction();
                })
            } else {
                callFunction();
            }
        };

        $efi.addDataHandler.handleClickADD_DATA = function (rowIndex) {
            if (!$efi.addDataHandler.hasADD_DATA(rowIndex)) return;
            var programId = $u.page.getPROGRAM_ID();
            var addDataKey = $efi.addDataHandler.getGrid().$V('HKONT', rowIndex);
            var hkont_txt;
            if ($efi.addDataHandler.getGrid().getGridHeader('HKONT')['serverType'] === 'combo') hkont_txt = $efi.addDataHandler.getGrid().getCachedCodeMap('HKONT')[addDataKey]['HKONT_TXT'];
            else hkont_txt = $efi.addDataHandler.getGrid().$V('HKONT_TXT', rowIndex);
            $efi.dialog.addDataDialog.open(programId, addDataKey, rowIndex, $efi.addDataHandler.getGrid().$H('ADD_DATA', rowIndex), hkont_txt);
            if ($efi.addDataHandler.getGrid().$V('FLAG', rowIndex) === 'X') $sment.clothingCost();
        };

        $efi.addDataHandler.handleADD_DATAKeyChange = function (rowIndex) {
            if (!$efi.addDataHandler.useADD_DATA()) return;
            if ($efi.addDataHandler.hasADD_DATA(rowIndex)) $efi.addDataHandler.getGrid().$V('ADD_DATA', rowIndex, $mls.getByCode('M_ADD_DATA_INPUT_NULL'));
            else {
                $efi.addDataHandler.getGrid().$V('ADD_DATA', rowIndex, '');
                if ($u.gridWrapper.getGrid().getGridHeader('ADD_DATA_JSON')) $u.gridWrapper.getGrid().$V('ADD_DATA_JSON', rowIndex, '');
            }
            $efi.addDataHandler.getGrid().$H('ADD_DATA', rowIndex, '');
        };

        $efi.createStatement.afterMultiCellChange = function (startColumnKey, startRowIndex, endColumnKey, endRowIndex, isBlockPaste, gridData) {
            const programId = $u.page.getPROGRAM_ID();
            const gridObj = $u.gridWrapper.getGrid();
            const activeColumnKey = gridObj.getActiveColumnKey();

            if ($sment.useAccountSubstitutionProgramId()) { // 계정대체 메뉴 커스텀
                for (i = startRowIndex, len = endRowIndex; i <= len; i++) {
                    if (isBlockPaste) {
                        if (activeColumnKey === 'LIFNR') $sment.setF4DataInSingleCell(activeColumnKey, i);
                        if (activeColumnKey === 'PARTNER') $sment.setF4DataInSingleCell(activeColumnKey, i);
                        if ($u.util.contains(activeColumnKey, ['HKONT', 'WRBTR', 'SHKZG', 'MWSKZ', 'PROJK', 'CST_NUM', 'SGTXT', 'AUFNR'])) {
                            let jsonObj = '';
                            if (activeColumnKey === 'HKONT') jsonObj = $u.f4Data.getCodeDataWithParams('HKONT', {HKONT: gridObj.$V('HKONT', i)})[0];
                            gridObj.triggerChangeCell(activeColumnKey, i, '', '', jsonObj);
                        }
                    } else {
                        $sment.setF4DataInSingleCell('LIFNR', i);
                    }

                    $efi.createStatement.changeGridAlert(activeColumnKey, i);
                    $efi.createStatement.koart_newko.onKOARTChange(activeColumnKey, i);
                }
            } else if ($u.util.contains(programId, ['UD_0802_010'])) { // 차량비용등록 메뉴의 WBS 때문에 커스텀함
                for (i = startRowIndex, len = endRowIndex; i <= len; i++) {
                    if (isBlockPaste) {
                        if (activeColumnKey === 'PROJK') $sment.setF4DataInSingleCell(activeColumnKey, i);
                    } else {
                        $sment.setF4DataInSingleCell('PROJK', i);
                    }
                }
            } else {
                $efi.createStatement.koart_newko.fillNEWKO_TXT();
                var i, len;
                for (i = 0, len = $u.gridWrapper.getGrid().getJSONData().length; i < len; i++) $efi.addDataHandler.handleADD_DATAKeyChange(i);
                var headerList = gridObj.getGridHeaders().filter(function(data){
                    return data['key'] !== 'SELECTED' && !data['key'].includes('_') && data['width'];
                })
                $.each(headerList, function(index, item){
                    var codeData = [];
                    var codeKey = gridObj.getGridHeader(item['key']).f4CodeKey ? gridObj.getGridHeader(item['key']).f4CodeKey : item['key'];
                    if($u.util.contains(item['serverType'], ['combo', 'popup'])){
                        if ($sment.useTaxAndNonDeductionProgramId()) codeData = $sment.getCodeDataWithParams(codeKey);
                        else codeData = $u.f4Data.getCachedCodeData(codeKey);

                    }
                    for (i = startRowIndex, len = endRowIndex; i <= len; i++) {
                        // if(!gridObj.$V(item['key'], i)) return;
                        var jsonObj = codeData.length > 0 ? codeData.filter(function(data){return data[codeKey] === gridObj.$V(item['key'], i)})[0] : {};
                        gridObj.triggerChangeCell(item['key'], i, '', gridObj.$V(item['key'],i), jsonObj, 'afterMultiCellChange');
                        if(item['key'] === 'HKONT') $sment.setVATFromHKONTFlag(i, jsonObj);
                    }
                })
                if ($u.buttons.getCustomHandler('customAfterMultiCellChange')) $u.buttons.runCustomHandler('customAfterMultiCellChange', startColumnKey, startRowIndex, endColumnKey, endRowIndex);
            }

            $sment.excelUpload_setAUFNRnHKONT_byWBS(gridData);
        };

        $efi.createStatement.handleChangeCell = function (columnKey, rowIndex, oldValue, newValue, jsonObj, flag) {
            var gridObj = $u.gridWrapper.getGrid();
            if (columnKey === 'WRBTR' || columnKey === 'SHKZG' || columnKey === 'MWSKZ') $efi.createStatementCommon.changeWRBTRExpense(columnKey);
            if (columnKey === 'KURSF' || columnKey === 'WRBTR2' || columnKey === 'WAERS'){
                var wrbtr = $efi.createStatementCommon.calculateWRBTRbyKURSF(rowIndex);
                gridObj.$V('WRBTR', rowIndex, wrbtr);
                gridObj.triggerChangeCell('WRBTR', rowIndex, gridObj.$V('WRBTR', rowIndex), wrbtr);
            }
            if (columnKey === 'KOSTL') {
                var kostl = gridObj.$V(columnKey, rowIndex);
                if (kostl) {
                    if (jsonObj && jsonObj['AUFNR']) gridObj.$V('AUFNR', rowIndex, jsonObj['AUFNR']);
                    if (jsonObj && jsonObj['AUFNR_TXT']) gridObj.$V('AUFNR_TXT', rowIndex, jsonObj['AUFNR_TXT']);
                }
            }
            if (columnKey === 'PROJK') {
                $sment.ATI_TARGET_CLEAR(rowIndex, flag);
                $nst.is_data_ot_data('ZUNIEFI_U1200', {}, function(ot_data) {
                    $sment.gridWBS_callRFC(rowIndex, ot_data);
                })

            }
            if (columnKey === 'HKONT') {
                $efi.addDataHandler.handleADD_DATAKeyChange(rowIndex);
                // if (/UD_0201_001|UD_0201_011/.test($u.page.getPROGRAM_ID())) $efi.setMWSKZ_By_HKONT_F4(columnKey, rowIndex, jsonObj);
                $sment.handleHKONT(rowIndex, jsonObj, flag);
                $sment.check_kostlFlag(rowIndex);
                $sment.CST_NUM_CONTROL('clothesHKONT', columnKey, rowIndex, jsonObj, flag);
            }
            if (columnKey === 'ATI_TARGET') $sment.changeATI_TARGET(gridObj, columnKey, rowIndex);
            if (columnKey === 'SGTXT') {
                var sgtxt = gridObj.$V('SGTXT', rowIndex);
                if (sgtxt.length > 50) gridObj.$V('SGTXT', rowIndex, sgtxt.substr(0, 50));
            }
            if (columnKey === 'AUFNR') {
                const currentHKONT = gridObj.$V('HKONT', rowIndex);
                if (currentHKONT) $sment.validateAndClear('HKONT', rowIndex, {HKONT: currentHKONT});
            }
            if (columnKey === 'CST_NUM') {
                $sment.CST_NUM_CONTROL('', columnKey, rowIndex, jsonObj, flag);
            }

            $efi.createStatement.setGridBudget(columnKey, rowIndex);
            $efi.createStatement.changeGridAlert(columnKey, rowIndex, jsonObj);
            $efi.createStatement.koart_newko.onKOARTChange(columnKey, rowIndex);
        };

        $efi.createStatement.handleClickCell = function (columnKey, rowIndex) {
            const gridObj = $u.gridWrapper.getGrid();

            if (columnKey === 'ADD_DATA') $efi.addDataHandler.handleClickADD_DATA(rowIndex);
            if (columnKey === 'ATCOD_@') {
                if (gridObj._rg.getValue(rowIndex, 'ATCOD_@__IMAGE') === '0') return;
                $sment.settlementDialog.open();
                var $guide = $('#guide-file-attach-content');
                $nst.is_data_nsReturn('ZUNIEFI_U1100', {FLAG: 'Y'}, function(nsReturn) {
                    $sment.setGuideDocument(nsReturn.getStringReturn("O_EVI_SEQ"), $guide, staticProperties.user['ROLE'].split(','));
                });
            }
            if (columnKey === 'PROJK_@') {
                if (gridObj._rg.getValue(rowIndex, 'PROJK_@__IMAGE') === '0') return;
                $sment.WBSSearchDialog();
            }

            if (columnKey === 'AKONT') {
                if ($u.util.contains($u.page.getPROGRAM_ID(), ['UD_0202_021Z', 'UD_0202_021Z_1', 'UD_0202_021Y', 'UD_0202_021Y_1'])) {
                    const kunnrValue = gridObj.$V('KUNNR', rowIndex);
                    const lifnrValue = gridObj.$V('LIFNR', rowIndex);

                    if (kunnrValue) {
                        gridObj.setDynamicComboOptions("AKONT", kunnrValue + '_D');
                    } else if (lifnrValue) {
                        gridObj.setDynamicComboOptions("AKONT", lifnrValue);
                    }
                }
            }
        };

        $efi.UD_0302_000EventHandler.gridCellClick = function (columnKey, rowIndex) {
            var gridObj = $u.gridWrapper.getGrid();
            var gridJSONDataByRowIndex = gridObj.getJSONDataByRowIndex(rowIndex);
            if (columnKey === 'BELNR') $efi.popup.openStatementViewWithParamMap(gridJSONDataByRowIndex);
            if (columnKey === 'GRONO') {
                if (gridObj.$V(columnKey, rowIndex) === '') return;
                gridObj.$V('SELECTED', rowIndex, 1);
                gridObj.handleGroupCheck('SELECTED', 'GRONO', rowIndex, 1);
                $nst.is_data_nsReturn('ZUNIECM_4510', gridJSONDataByRowIndex, function (nsReturn) {
                    $nst.is_data_nsReturn('GWApproval', {ApprovalURL: nsReturn.getStringReturn("O_URL")}, function(nsReturn) {
                        $sment.openApprovalPopup(nsReturn.getStringReturn('RESULT'));
                    });
                });
            }
            if (columnKey === 'EVIKB_@') $efi.evikbClickHandler(gridJSONDataByRowIndex);
            if (columnKey === 'EVIKB_ADD') {
                if (gridObj._rg.getValue(rowIndex, 'EVIKB_ADD__IMAGE') !== '0') {
                    var $dialog = $u.dialog.fineUploaderDialog.open(gridJSONDataByRowIndex['EVI_SEQ'], false, function () {
                        var originEVI_SEQ = gridObj.$V('EVI_SEQ', rowIndex);
                        var fileCount = $dialog.data('fineUploader').getFileCount();
                        var curEVI_SEQ = fileCount === 0 ? '' : $dialog.data('fineUploader').getFileGroupId();

                        if (originEVI_SEQ !== curEVI_SEQ) $nst.is_data_returnMessage('ZUNIEFI_4230',
                            $.extend({}, gridJSONDataByRowIndex, {'EVI_SEQ': curEVI_SEQ}),
                            function () {
                                gridObj.$V('EVI_SEQ', rowIndex, curEVI_SEQ);
                                if (fileCount > 0) gridObj.showImage('EVIKB_@', rowIndex);
                                else $nst.is_data_ot_data('ZUNIECM_5013', gridJSONDataByRowIndex, function (ot_data) {
                                    if (ot_data.length === 0) gridObj.hideImage('EVIKB_@', rowIndex);
                                    else gridObj.showImage('EVIKB_@', rowIndex);
                                });
                            });
                    });
                }
            }
            if (columnKey === 'A_FLG_@') {
                if (gridObj.$V('A_FLG_@', rowIndex) === '/images/btn/btn_view.gif') $sment.showEmp_imsurance_readOnly(rowIndex);
            }
        };

        $efi.createStatementCommon.changeMWSKZ = function () {
            const PROGRAM_ID = $u.page.getPROGRAM_ID();

            if ($u.util.contains(PROGRAM_ID, ['UD_0202_021Z', 'UD_0202_021Z_1', 'UD_0202_021Y', 'UD_0202_021Y_1'])) return;


            var gridObj = $u.gridWrapper.getGrid();
            var oldValue = $u.get('MWSKZ').getOldValue();
            var currentValue = $u.get('MWSKZ').getValue();
            $u.get('MWSKZ').setOldValue(currentValue);

            var optionText = $u.get('MWSKZ').getOptionsText(currentValue);
            var filtered = gridObj.$F(oldValue, 'MWSKZ').concat(gridObj.$F('', 'MWSKZ'));
            $.each(filtered, function (index, rowIndex) {
                gridObj.$V('MWSKZ', rowIndex, currentValue);
                if (gridObj.getGridHeader('MWSKZ_TXT')) gridObj.$V('MWSKZ_TXT', rowIndex, optionText);
            });
            if (!/^0104|0204$/.test($u.page.getPageParams()['TYPE_CODE'])) {
                $efi.createStatementCommon.changeWRBTRExpense();
            }
            $efi.mwskzNonDeduction.alertChangeFormCombo();

            $sment.setCodeMTaxType();
            $sment.CalculateWRBTR_PAY();

            if (/^UD_0202_021$|UD_0202_021_2$|UD_0208_021$|^UD_SM_6000$/.test($u.page.getPROGRAM_ID())) {
                if (!$u.get('LIFNR').getValue()) return;
                var $witht = $u.get('LIFNR').getDialogRowData()['WITHT'];
                if ($witht !== 'X') return;
                var $u_WT_WITHCD = $u.get('WT_WITHCD');
                if (currentValue) {
                    $u_WT_WITHCD.setEmptyValue();
                    $u_WT_WITHCD.setReadOnly(true);
                } else $u_WT_WITHCD.setReadOnly(false);
            }
        }

        $efi.createStatementCommon.changeWRBTRExpense = function (columnKey) {
            var gridObj = $u.gridWrapper.getGrid();
            if (!gridObj.getGridHeader('WRBTR')) return;
            var $u_wrbtr = $u.get('WRBTR');
            var gridWRBTR;
            const programId = $u.page.getPROGRAM_ID();

            if (columnKey === 'MWSKZ') {
                if ($sment.isTypeCode0104()) return;
                if (gridObj.getRowCount() === 1) {
                    if (!$u.util.contains($u.page.getPROGRAM_ID(), ['UD_0202_021Z', 'UD_0202_021Z_1', 'UD_0202_021Y', 'UD_0202_021Y_1'])) {
                    $u.get('MWSKZ').setValue(gridObj.$V('MWSKZ',0));
                    $u.get('MWSKZ').setOldValue($u.get('MWSKZ').getValue());
                    $sment.setCodeMTaxType();
                    }
                }
            }
            gridObj.setNumberNegative('WRBTR', 'false');

            if ($u.util.contains(columnKey,['addRow','MWSKZ','SHKZG']) && gridObj.$V('WRBTR',gridObj.getActiveRowIndex()) === '' && gridObj.getRowCount() !== 1) return;
            // 고지서 세금계산서일경우 세금금액(WMWST)값 계산 X
            if ($u.get('WMWST') && programId !== 'UD_0202_021B') $u.get('WMWST').setValue($efi.createStatementCommon.getGridWMWSTSum());
            var calculatedWRBTR = $efi.createStatementCommon.getExpenseCalculatedWRBTR();
            if ($u.page.getPROGRAM_ID() === 'UD_0204_100' && $u.get('PAYGB').getValue() === 'B') {
                const gridObj2 = $u.gridWrapper.getGrid('unidocu-grid2');
                const WRBTR = $u.get('WRBTR').getValue();
                let grid2DIV_AMTSum = gridObj2.getSELECTEDJSONData().reduce((sum, gridItem) => sum + (Number(gridItem['DIV_AMT']) || 0), 0);
                if (WRBTR > grid2DIV_AMTSum) {
                    $u.get('WRBTR').setValue('0');
                    $u.get('AMOUNT').setValue('0');
                    $u.get('WRBTR_PAYGB').setValue(grid2DIV_AMTSum);
                    throw "반환금액이 잔액 합산을 초과하였습니다.";
                }
                $u.get('AMOUNT').setValue($u.get('WRBTR').getValue());
                $u.get('WRBTR_PAYGB').setValue($u.get('WRBTR').getValue());
            } else {
                $u_wrbtr.setValue(calculatedWRBTR);
            }
            if ($u.get('WRBTR_PAY')) $u.get('WRBTR_PAY').setValue(calculatedWRBTR);
            if ($u.util.contains(columnKey, ['WRBTR', 'SHKZG'])) $efi.createStatement.calculateWithcdTax();

            var form_wmwst = null;
            var formWRBTR = $u_wrbtr.getValue();

            if (gridObj.getRowCount() === 1 && $u.programSetting.getValue('증빙정보 승인금액 자동 계산사용') === 'true' && columnKey !== 'WRBTR') {
                gridWRBTR = formWRBTR / (1 + $efi.createStatementCommon.getTaxRateByMWSKZ(gridObj.$V('MWSKZ', 0)));

                if ($efi.createStatementCommon.hasFormVAT()) gridObj.$V('WRBTR', 0, $efi.precisionRoundByWAERS(gridWRBTR, $u.getValues()['WAERS']));
                else gridObj.$V('WRBTR', 0, calculatedWRBTR);
            }

            // 고지서 세금계산서일경우 세금금액(WMWST)값 계산 X
            if ($u.get('WMWST')) {
                if ($u.util.contains(programId, ['UD_0202_021Z', 'UD_0202_021Z_1', 'UD_0202_021Y', 'UD_0202_021Y_1'])) {
                    form_wmwst = $efi.createStatementCommon.getGridWMWSTSum();
                } else if (programId !== 'UD_0202_021B') {
                if ($efi.createStatementCommon.useAutoCalcEviAmount('wmwstReadOnly')()) {
                    form_wmwst = Math.abs($u.get('WMWST_READ_ONLY').getValue());
                } else if (gridObj.getRowCount() === 1) {
                    gridWRBTR = formWRBTR / (1 + $efi.createStatementCommon.getTaxRateByMWSKZ(gridObj.$V('MWSKZ', 0)));
                    if($efi.createStatementCommon.hasFormVAT()) form_wmwst = formWRBTR - $efi.precisionRoundByWAERS(gridWRBTR, $u.getValues()['WAERS']);
                    else form_wmwst = 0;
                } else {
                    form_wmwst = $efi.createStatementCommon.getGridWMWSTSum();
                }
                }
            }

            if ($efi.createStatementCommon.useAutoCalcEviAmount('oneCaseUseCalcEviAmount')()) {
                if (gridObj.getRowCount() === 1) {
                    var chargetotal = Math.abs($u.get('CHARGETOTAL').getValue());
                    if ($efi.createStatementCommon.hasFormVAT()) gridObj.$V('WRBTR', 0, chargetotal);
                    else gridObj.$V('WRBTR', 0, calculatedWRBTR);

                    if ($u.get('WMWST')) {
                        if ($efi.createStatementCommon.hasFormVAT()) form_wmwst = Math.abs($u.get('WMWST_READ_ONLY').getValue());
                        else form_wmwst = 0;
                    }
                }
            }

            // 고지서 세금계산서일경우 세금금액(WMWST)값 계산 X
            if ($u.get('WMWST') && programId !== 'UD_0202_021B') $u.get('WMWST').setValue(Math.abs(form_wmwst));

            $efi.createStatementCommon.setAmountDisplay($efi.createStatementCommon.getCalculatedDisplayAmount());
        };

        $efi.createStatementCommon.changeWMWSTExpense = function () {
            $u.get('WRBTR').setValue($efi.createStatementCommon.getExpenseCalculatedWRBTR());
            if ($u.get('WRBTR_PAY')) $u.get('WRBTR_PAY').setValue($efi.createStatementCommon.getExpenseCalculatedWRBTR());
            $efi.createStatementCommon.setAmountDisplay($efi.createStatementCommon.getCalculatedDisplayAmount());
        };

        $efi.createStatement.bindEvent.onZTERM_BUDATChange = function () {
            var $u_ZFBDT = $u.get('ZFBDT');
            var $u_ZTERM = $u.get('ZTERM');
            var $u_B_ZFBDT = $u.get('B_ZFBDT');
            var $u_ZFBDT = $u.get('ZFBDT');
            var nsReturn = $nst.is_data_nsReturn('ZUNIEFI_4003', $u.getValues('header-invoicer-content,vendor-info'));

            const returnType = nsReturn.getReturnType();
            const returnMessage = nsReturn.getReturnMessage();
            if (returnType === 'W') {
                $u_ZTERM.setValue('');
                $u_ZFBDT.setValue('');
                throw returnMessage+'\n[ZUNIEFI_4003]';
            }

            var os_data = nsReturn.getExportMap('OS_DATA');
            var ot_data = nsReturn.getTableReturn('OT_DATA');
            var zlsch = os_data['ZLSCH'];
            var zfbdt = os_data['ZFBDT'];
            var zlspr = os_data['ZLSPR'];
            var b_zfbdt = os_data['B_ZFBDT'];

            if ($u.get('ZLSCH') && zlsch) $u.get('ZLSCH').setValue(zlsch);
            if ($u.get('ZLSPR')) $u.get('ZLSPR').setValue(zlspr);

            if ($u_ZFBDT && zfbdt) $u_ZFBDT.setValue(zfbdt);
            if ($u.get('ZLSCH')) $u.get('ZLSCH').triggerChange();

            if ($u_ZFBDT && $u_ZTERM) {
                var programId = $u.page.getPROGRAM_ID();
                $efi.createStatement.bindEvent.ZTERM_ZTAGGMap[programId] = $u.f4Data.getCodeMapWithParams('ZTERM', 'ZTAGG');
                var zterm = $u_ZTERM.getValue();
                var ztermReadOnly = false;
                if ($efi.createStatement.bindEvent.ZTERM_ZTAGGMap[programId][zterm] !== 'X') ztermReadOnly = true;
                $u_ZFBDT.setReadOnly(ztermReadOnly);
            }

            if($u.get('ZTERM')) {
                if (!$u.get('ZLSCH') || !$u.get('ZFBDT')) throw $mls.getByCode("M_UD_0201_011_ZLSCH_ZFBDTNotExists");
            }

            if($u_ZFBDT && $u_B_ZFBDT && zfbdt){
                if(os_data['CFLAG'] === 'Y' && zfbdt !== '0000-00-00'){
                    let selectableDate = ot_data.map(item => item.M_DATE).concat(zfbdt);
                    $u_ZFBDT.setSelectableDate(selectableDate, zfbdt);
                    $u_ZFBDT.setRequired(true); // Y인 경우 필수 처리 로직 추가
                }else{
                    $u_ZFBDT.setSelectableDate([], '');
                    $u_ZFBDT.setRequired(false); // 필수 처리 해제
                }

                $u_B_ZFBDT.setValue(b_zfbdt ? b_zfbdt : '');
            }
        };

        $efi.setMWSKZ_By_HKONT_F4 = function (columnKey, rowIndex, jsonObj) {
            var gridObj = $u.gridWrapper.getGrid();
            var $u_MWSKZ = $u.get('MWSKZ');

            function callFunction() {
                if (jsonObj['MWSKZ']) {
                    gridObj.$V('MWSKZ', rowIndex, jsonObj['MWSKZ']);
                    $u_MWSKZ.setValue(jsonObj['MWSKZ']);
                }

                var mwskzData = gridObj.getJSONData().filter(function (value) {
                    return $efi.f4.getFLAG_by_MWSKZ(value['MWSKZ']) === 'X' && $efi.mwskzNonDeduction.isNonDeduction(value['MWSKZ']);
                });

                if (mwskzData.length !== 0) $u.get('MWSKZ').setValue(mwskzData[0]['MWSKZ']);
                $u_MWSKZ.$el.change();
            }
            if ($u_MWSKZ && jsonObj) callFunction();
        };

        $efi.dialog.addDataDialog.confirmCallback = function (rowIndex, addDataKey, $dialog) {
            var formId = 'dialog-search-form';
            if ($u.programSetting.getValue('setADD_DATAOnTheWeb') === "true") formId = 'ADD_DATA_INFO';
            $u.validateRequired(formId);
            $sment.addData_advanceCostValidation(rowIndex);
            var gridObj = $u.gridWrapper.getGrid();
            var values = $u.getValues(formId);
            var addDataJSON = [];
            var hasDataOrOptionInput = false;
            var optionlList = $efi.statementInitialData.getAddDataOptionalList();
            var hasValue = false;
            $.each(values, function (key, value) {
                if (value || $u.util.contains(addDataKey, optionlList)) hasDataOrOptionInput = true;
                if (value) hasValue = true;
            });
            if (!hasDataOrOptionInput) throw $mls.getByCode('M_shouldInputAddData');

            $.each($u.getNames(formId), function (index, item) {
                var params = $u.get(item).params;
                var value_text = '';
                if (params.type === 'Uni_CodePopup' || params.type === 'Uni_CodeCombo') value_text = $u.get(params.name).getTextValue();

                addDataJSON.push({KEY: params.name, VALUE: $u.get(params.name).getValue(), HEADER_TEXT: params.thText, VALUE_TEXT: value_text});
            });

            if (hasValue) {
                gridObj.$H('ADD_DATA', rowIndex, JSON.stringify(values));
                gridObj.$V('ADD_DATA', rowIndex, $mls.getByCode('M_ADD_DATA_INPUT'));
                if (gridObj.getGridHeader('ADD_DATA_JSON')) gridObj.$V('ADD_DATA_JSON', rowIndex, JSON.stringify(addDataJSON));
            } else {
                gridObj.$H('ADD_DATA', rowIndex, '');
                gridObj.$V('ADD_DATA', rowIndex, $mls.getByCode('M_ADD_DATA_INPUT_NULL'));
                if (gridObj.getGridHeader('ADD_DATA_JSON')) gridObj.$V('ADD_DATA_JSON', rowIndex, '');
            }

            $dialog.dialog('close');
            return values;
        }

        $efi.createStatement.validateCreateStatement = function () {
            if ($u.get('MWSKZ')) $efi.mwskzNonDeduction.validationChangeFormCombo();
            var gridObj = $u.gridWrapper.getGrid();
            const PROGRAMID_SPECIAL = ['UD_0202_021Z', 'UD_0202_021Z_1', 'UD_0202_021Y','UD_0202_021Y_1'];
            const PROGRAM_ID = $u.page.getPROGRAM_ID();

            if (PROGRAM_ID === 'UD_0204_100') {
                if ($u.get('PAYGB').getValue() === 'B') return;
            }

            $sment.validateEmptyArray_ARTISTDATA(gridObj);
            $u.validateRequired('header-invoicer-content');
            $u.validateRequired('vendor-info');
            // gridObj.validateGridRequired();
            gridObj.validateColorRequired(); // color 기준으로 그리드 필수값 체크
            $efi.KOSTL_HKONT_Relation.validateKOSTL_HKONT_Relation();
            $efi.addDataHandler.validateAddData();
            if (gridObj.getGridHeader('HKONT')) {
                if (!$sment.useAccountSubstitutionProgramId() && PROGRAM_ID !== 'UD_0201_001C') {// 법인카드(건별)-개인사용분, 계정대체 메뉴는 제외
                    if ($u.util.contains(PROGRAM_ID, PROGRAMID_SPECIAL)) $efi.createStatement.validateKUNNR_LIFNR_HKONT();
                    else $efi.createStatement.validateHKONT_LIFNR();
                }
            }
            if ($u.get('difference_amount') && $u.get('difference_amount').getValue() !== 0) throw $mls.getByCode('M_debitCreditAmountsAreNotEquals');
            if ($u.programSetting.getValue('isAttachmentRequired') === 'true' && $('.file-count').html() === '0') throw '[증빙]을 첨부해 주세요';
        };

        $efi.createStatement.bindEvent.bindVendorCodeChange = function () {
            var vendorCodeInput = $efi.statementInitialData.getVendorCodeInput();
            if (!vendorCodeInput) return;
            vendorCodeInput.$el.change(function () {
                var paramMap = $u.getValues('statement-information-content,header-invoicer-content,vendor-info');
                var vendorCode = vendorCodeInput.getValue();
                if (!vendorCode) return;

                var namedServiceId = 'ZUNIEFI_4001';
                if (vendorCodeInput.getName() === 'KUNNR') namedServiceId = 'ZUNIEFI_4004';
                $nst.is_data_ot_data(namedServiceId, paramMap, function (ot_data) {
                    if (ot_data.length === 0) return;
                    if ($u.hasTable('statement-information-content')) $u.setValues('statement-information-content', ot_data[0]);
                    if ($u.hasTable('header-invoicer-content')) $u.setValues('header-invoicer-content', ot_data[0]);
                    if ($u.hasTable('vendor-info')) $u.setValues('vendor-info', ot_data[0]);

                    var comboCodeQueryParams = {};
                    comboCodeQueryParams[vendorCodeInput.getName()] = vendorCode;

                    if ($u.get('BVTYP')) $u.get('BVTYP').setOptions($u.f4Data.getCodeComboOption($u.get('BVTYP').params['codeKey'], comboCodeQueryParams), ot_data[0]['BVTYP']);
                    if ($u.get('ZLSCH')) $u.get('ZLSCH').setOptions($u.f4Data.getCodeComboOption($u.get('ZLSCH').params['codeKey'], comboCodeQueryParams), ot_data[0]['ZLSCH']);
                    if ($u.get('EMPFB')) {
                        if ($u.get('EMPFB').setOptions) $u.get('EMPFB').setOptions($u.f4Data.getCodeComboOption($u.get('EMPFB').params['codeKey'], comboCodeQueryParams));
                        else if ($u.get('EMPFB').setQueryParams) $u.get('EMPFB').setQueryParams(comboCodeQueryParams)
                    }
                    if ($u.get('AKONT')) $u.get('AKONT').setOptions($u.f4Data.getCodeComboOption($u.get('AKONT').params['codeKey'], comboCodeQueryParams), ot_data[0]['AKONT']);
                    if ($u.get('GL_ALIAS')) {
                        $u.gridWrapper.getGrid().checkAll('SELECTED');
                        $u.get('GL_ALIAS').setValue(ot_data[0]['GL_ALIAS']);
                        $efi.createStatement.bindEvent.triggerGL_ALIAS_Change();
                    }
                    if ($u.get('ZTERM')) {
                        const f4data_ZTERM = $u.f4Data.getCodeComboOption('ZTERM', {ZTERM: ot_data[0]['ZTERM']});
                        if (f4data_ZTERM.length === 1) { // 입금등록(고객-고객) 메뉴 제외
                            $u.get('ZTERM').setValue({code: f4data_ZTERM[0]['value'], text: f4data_ZTERM[0]['text']})
                        } else {
                            $u.get('ZTERM').setValue('');
                        }
                    }

                    if (/UD_0201_011|UD_0202_021|UD_0202_021_2|UD_0202_001_A|UD_0204_100|UD_0208_021|UD_SM_6000/.test($u.page.getPROGRAM_ID())) $sment.comboInputBVTYP();

                    $efi.createStatement.bindEvent.triggerMWSKZChange();
                    $efi.createStatement.bindEvent.triggerZTERM_BUDATChange();
                    if($u.buttons.getCustomHandler('afterVendorCodeChange')) $u.buttons.runCustomHandler('afterVendorCodeChange', ot_data);
                });
            });
        };

        // $sment
        window.$sment = {};

        // 계정대체 메뉴
        $sment.useAccountSubstitutionProgramId = () => {
            return $u.util.contains($u.page.getPROGRAM_ID(), ['UD_0201_031', 'UD_SM_3000', 'UD_0208_030']);
        }

        // 의상비 메뉴
        $sment.useCSTProgramId = () => {
            return $u.util.contains($u.page.getPROGRAM_ID(), ['UD_SM_3000', 'UD_SM_5000', 'UD_SM_6000']);
        }

        // number format 기본값 셋팅 (#,### => ####)
        $sment.setDefaultNumberFormat = (columnKeyArray) => {
            const gridObj = $u.gridWrapper.getGrid();
            for (let i = 0; i < columnKeyArray.length; i++) {
                gridObj.setNumberFormat(columnKeyArray[i], '')
            }
        }

        $sment.validateAndClear = (columnKey, rowIndex, param) => {
            const gridObj = $u.gridWrapper.getGrid();
            const f4Data = $u.f4Data.getCodeDataWithParams(columnKey, param);
            if (f4Data.length === 0) {
                gridObj.$V(columnKey, rowIndex, '');
                gridObj.$V(`${columnKey}_TXT`, rowIndex, '');
            }
        }

        $sment.useGridAUNFRPopupProgramId = () => {
            const programIdArr = ['UD_0201_001', 'UD_0201_000C', 'UD_0202_001', 'UD_0201_011', 'UD_0202_021', 'UD_0202_021_2', 'UD_0202_021B', 'UD_SM_6000',
                                                'UD_0202_021Z', 'UD_0202_021Y', 'UD_0204_100', 'UD_0208_001', 'UD_0208_000C', 'UD_0208_011', 'UD_0208_021',
                                                'UD_0208_030', 'UD_SM_2000', 'UD_0201_031', 'UD_SM_3000', 'UD_SM_4000', 'UD_0230_001'];
            return $u.util.contains($u.page.getPROGRAM_ID(), programIdArr);
        }

        $sment.useTaxAndNonDeductionProgramId = () => {
            return $u.util.contains($u.page.getPROGRAM_ID(), ['UD_0202_021', 'UD_0201_011', 'UD_SM_6000']);
        }

        // f4 조회 함수에 커스텀이 많이 되서 GridCodeMap 를 초기에 세팅해서 사용하게함.
        $sment.setGridCodeMap = (columnKey, params) => {
            const gridObj = $u.gridWrapper.getGrid();
            if (!gridObj['gridCodeMap']) gridObj['gridCodeMap'] = {};
            const gridCodeMap = gridObj['gridCodeMap'];

            if (!gridCodeMap[columnKey]) {
                const codeMap = {};
                const gridCodeMap = gridObj['gridCodeMap'];
                gridCodeMap[columnKey] = {};
                $.each($sment.getCodeDataWithParams(columnKey, params), function (index, code) {
                    codeMap[code[columnKey]] = code;
                });
                gridCodeMap[columnKey] = codeMap;
            }
        }

        $sment.moveToCarDoc = (paramMap, grono) => {
            $nst.is_data_nsReturn('ZUNIEFI_U841', paramMap, nsReturn => {
                const mode = grono ? 'readOnly' : 'edit';
                const params = {mode, nsReturn};
                $u.navigateByProgramId('UD_0803_010', params);
            });
        }

        $sment.isCarRole = () => {
            const userRoles = staticProperties.user.ROLE.split(',');
            const carRoles = ['CAR_01', 'CAR_02', 'CAR_03'];

            return carRoles.some(carRole => userRoles.includes(carRole));
        }

        /**
         * F4Data 조회량이 많아 엑셀, 멀티붙여넣기 등에 속도 이슈 발생 시에
         * 하나씩 호출할 수 있게 만듬...
         */
        $sment.setF4DataInSingleCell = (columnKey, rowIndex) => {
            const gridObj = $u.gridWrapper.getGrid();

            if (gridObj.$V(columnKey, rowIndex)) {
                const f4CodeKey = gridObj.getGridHeader(columnKey).f4CodeKey || columnKey;
                const IT_DATA = {};
                if (f4CodeKey === 'PROJK2') {
                    IT_DATA['POSID'] = gridObj.$V(columnKey, rowIndex);
                } else if (f4CodeKey === 'LIFNR_ART') {
                    IT_DATA['LIFNR'] = gridObj.$V(columnKey, rowIndex);
                } else {
                    IT_DATA[f4CodeKey] = gridObj.$V(columnKey, rowIndex)
                }
                const f4Data = $u.f4Data.getCodeDataWithParams(f4CodeKey, IT_DATA);
                if (f4Data.length > 0) {
                    const codeTextKey = `${columnKey}_TXT`;
                    let f4CodeTextKey = codeTextKey;
                    if (f4CodeKey === 'PROJK2') f4CodeTextKey = 'WBS_TXT';
                    if (f4CodeKey === 'LIFNR_ART') f4CodeTextKey = 'LIFNR_TXT';
                    gridObj.$V(codeTextKey, rowIndex, f4Data[0][f4CodeTextKey]);
                }
                else gridObj.makePopupCellEmpty(columnKey, rowIndex);
            } else {
                gridObj.makePopupCellEmpty(columnKey, rowIndex);
            }
        }

        $sment.makeReadOnlyHeaderALL = () => {
            let getKeys = Object.keys($u.getValues());

            for (let i = 0; i < getKeys.length; i++) {
                if ($u.get(getKeys[i])) $u.get(getKeys[i]).setReadOnly(true);
            }
        }

        $sment.makeReadOnlyGridALL = (...args) => {
            for (let i = 0; i < args.length; i++) {
                const gridObj = args[i];
                const gridHeaders = gridObj.getGridHeaders();

                gridObj.setColumnHide('SELECTED');

                gridHeaders.forEach(function (header, index) {
                    if (gridObj.isPopupCodeColumn(header.key)) gridObj.setColumnHide(header.key + '_');
                    gridObj.makeColumnReadOnly(header.key);
                    gridObj.setColumnBgColor(header.key, gridObj.rg.style._readOnlyBgColor);
                });
            }
        }
        /**
         * '20240326' -> '화'
         * 날짜로 요일 가져오는 함수
         */
        $sment.getDayOfWeek = (dateString) => {
            if (!dateString) return '';

            const date = new Date(dateString.slice(0, 4), dateString.slice(4, 6) - 1, dateString.slice(6, 8));
            const dayOfWeek = date.getDay();
            return ["일", "월", "화", "수", "목", "금", "토"][dayOfWeek];
        }

        $sment.headerSetEmptyValue = (headerId) => {
            if ($u.get(headerId)) $u.get(headerId).setEmptyValue();
        }

        $sment.dialog = {};
        $sment.dialog.searchStatementDialog = {};
        $sment.dialog.searchStatementDialog.open = (searchFunction, callback) => {
            const formId = 'dialog-search-form';

            if (!callback) callback = function() {};
            const $dialog = $u.dialog.dialogLayout001({
                "subGroup": 'SERACH_STATEMENT_DIALOG',
                "dialogTitle": '전표현황',
                "dialogWidth": 1200,
                "dialogSearchButton": function () {
                    const params = $u.getValues(formId);
                    $.each(params, function(key){
                        if(/__DIALOG/.test(key)) params[key.replace('__DIALOG', '')] = params[key];
                    });
                    $nst.is_data_ot_data(searchFunction, params, function (ot_data) {
                        dialogGrid.setJSONData(ot_data);
                    });
                },
                "dialogButtons": [
                    $u.baseDialog.getButton($mls.getByCode('DLB_cancel'), function () {
                        $dialog.dialog('close');
                    }),
                    $u.baseDialog.getButton($mls.getByCode('DLB_confirm'), function () {
                        dialogGrid.asserts.rowSelected();
                        callback(dialogGrid.getSELECTEDJSONData());
                        $dialog.dialog('close');
                    }),
                ]
            });
            const dialogGrid = $u.gridWrapper.getGrid('dialog-search-grid');
            dialogGrid.onCellClick(function (columnKey, rowIndex) {
                if (columnKey === 'BELNR') {
                    $efi.popup.openStatementViewWithParamMap({
                        BELNR: dialogGrid.$V('BELNR', rowIndex),
                        BUKRS: dialogGrid.$V('BUKRS', rowIndex),
                        GJAHR: dialogGrid.$V('GJAHR', rowIndex)
                    });
                }
            });
            dialogGrid.setHeaderCheckBox('SELECTED', true);
            $('#dialog-search-form').find('.panel-search-button').click();
        }
        $sment.dialog.copy_belnr = {};
        $sment.dialog.copy_belnr.open = () => {
            var targetProgramId = {
                'UD_0202_021': 'UD_0202_021_2',
                'UD_0202_021_2': 'UD_0202_021',
            }

            var $dialog = $u.dialog.dialogLayout001({
                "subGroup": 'UD_0202_001_DIALOG',
                "dialogTitle": '전표현황',
                "draggable": true,
                "resizable": true,
                "dialogWidth": 1200,
                "dialogButtons": [
                    $u.baseDialog.getButton($mls.getByCode('DLB_confirm'), function () {
                        $sment.dialog.copy_belnr_setGridData($dialog);
                    }),
                    $u.baseDialog.getButton($mls.getByCode('DLB_copyStatement'), function() {
                        dialogGrid.asserts.rowSelected();
                        var selectedData = dialogGrid.getSELECTEDJSONData()[0];
                        var dialogData = $.extend({}, {dialogData: {BELNR: selectedData['BELNR'], GJAHR:selectedData['GJAHR'], BUKRS: selectedData['BUKRS']}});

                        $u.navigateByProgramId(targetProgramId[$u.page.getPROGRAM_ID()], dialogData);
                    }),
                    $u.baseDialog.getButton($mls.getByCode('DLB_copyMinusStatement'), function() {
                        dialogGrid.asserts.rowSelected();
                        var selectedData = dialogGrid.getSELECTEDJSONData()[0];
                        var dialogData = $.extend({}, {dialogData: {BELNR: selectedData['BELNR'], GJAHR:selectedData['GJAHR'], BUKRS: selectedData['BUKRS']}});
                        $u.navigateByProgramId(targetProgramId[$u.page.getPROGRAM_ID()], dialogData);
                    })
                ]
            });

            var evikb_type = {
                "UD_0201_010": 'FI_02',
                "UD_0202_021": 'FI_04',
                "UD_0202_021_2": 'FI_04'
            };

            $u.get('EVIKB__DIALOG').setValue(evikb_type[$u.page.getPROGRAM_ID()]);
            var $dialog_confirm_button = $('.unidocu-button.ui-button.ui-corner-all.ui-widget:contains(' + $mls.getByCode('DLB_confirm') + ')');                // 확인 버튼
            var $dialog_copy_button = $('.unidocu-button.ui-button.ui-corner-all.ui-widget:contains(' + $mls.getByCode('DLB_copyStatement') + ')');             // 비용정산 버튼
            var $dialog_copy_minus_button = $('.unidocu-button.ui-button.ui-corner-all.ui-widget:contains(' + $mls.getByCode('DLB_copyMinusStatement') + ')');  // 반대분개 버튼
            $('#dialog-search-form').find('.panel-search-button').click();
            var dialogGrid = $u.gridWrapper.getGrid('dialog-search-grid');
            $dialog_confirm_button.hide();
            dialogGrid.setColumnHide('SELECTED', true);
            if($u.util.contains($u.page.getPROGRAM_ID(), ['UD_0201_010', 'UD_0202_021', 'UD_0202_021_2'])) {
                $dialog_confirm_button.show();
                dialogGrid.setColumnHide('SELECTED', false);
                dialogGrid.setCheckBarAsRadio('SELECTED');
                dialogGrid.onCellClick(function (columnKey, rowIndex) {
                    var gridJSONDataByRowIndex = dialogGrid.getJSONDataByRowIndex(rowIndex);
                    if (columnKey === 'BELNR') {
                        $efi.popup.openStatementViewWithParamMap({
                            BELNR: dialogGrid.$V('BELNR', rowIndex),
                            BUKRS: dialogGrid.$V('BUKRS', rowIndex),
                            GJAHR: dialogGrid.$V('GJAHR', rowIndex)
                        });
                    }
                    if (columnKey === 'GRONO') {
                        if (dialogGrid.$V(columnKey, rowIndex) === '') return;
                        dialogGrid.$V('SELECTED', rowIndex, 1);
                        dialogGrid.handleGroupCheck('SELECTED', 'GRONO', rowIndex, 1);
                        $nst.is_data_nsReturn('ZUNIECM_4510', gridJSONDataByRowIndex, function (nsReturn) {
                            $efi.UD_0302_000EventHandler.openApprovalPopup(nsReturn.getStringReturn("O_URL"));
                        });
                    }
                    if (columnKey === 'EVIKB_@') $efi.evikbClickHandler(gridJSONDataByRowIndex);
                });
            }
            if ($u.util.contains($u.page.getPROGRAM_ID(), ['UD_0202_021', 'UD_0201_010'])) $dialog_copy_button.hide();
            if ($u.util.contains($u.page.getPROGRAM_ID(), ['UD_0202_021_2', 'UD_0201_010'])) $dialog_copy_minus_button.hide();
        };

        $sment.dialog.copy_belnr_setGridData = function($dialog) {
            var gridObj = $u.gridWrapper.getGrid();
            var dialogGrid = $u.gridWrapper.getGrid('dialog-search-grid');
            dialogGrid.asserts.rowSelected();
            var selectedData = dialogGrid.getSELECTEDJSONData()[0];
            var dialogData = $.extend({}, {BELNR: selectedData['BELNR'], GJAHR:selectedData['GJAHR'], BUKRS: selectedData['BUKRS']});
            $nst.is_data_nsReturn('ZUNIEFI_U900', dialogData, function(nsReturn) {
                var os_head = nsReturn.getExportMap('OS_HEAD');
                var os_vend = nsReturn.getExportMap('OS_VEND');
                var ot_data = nsReturn.getTableReturn('OT_DATA');
                var f4QueryParams = {}
                $u.setValues($.extend({}, os_head, os_vend));
                if(ot_data.length === 0) return;
                else {
                    if ($u.page.getPROGRAM_ID() === 'UD_0202_021_2') ot_data[0]['SHKZG'] = 'H';
                    else ot_data[0]['SHKZG'] = 'S';
                    gridObj.setJSONData(ot_data);
                }
                if ($u.get('LIFNR')) f4QueryParams = {LIFNR: $u.get('LIFNR').getValue()};
                if ($u.get('BVTYP')) $u.get('BVTYP').setOptions($u.f4Data.getCodeComboOption($u.get('BVTYP').params['codeKey'], f4QueryParams), os_vend['BVTYP']);
                $efi.createStatementCommon.changeWRBTRExpense();
            });
            $dialog.dialog('close');
        };
        $sment.dialog.carBatchApplyDialog = {};
        $sment.dialog.carBatchApplyDialog.open = () => {
            const gridObj = $u.gridWrapper.getGrid();

            const $dialog = $u.dialog.dialogLayout001({
                "subGroup": 'CAR_BATCH_APPLY_DIALOG',
                "dialogTitle": $mls.getByCode('DLT_carBatchApplyDialog'),
                "ignoreGrid": true,
                "dialogButtons": [
                    $u.baseDialog.getButton($mls.getByCode('DLB_confirm'), ()=> {
                        $u.validateRequired('dialog-search-form');
                        const IS_DATA = {PAYTYPE : $u.get('PAYTYPE__DIALOG').getValue()};
                        const IT_DATA = gridObj.getSELECTEDJSONData()
                        $nst.is_data_it_data_returnMessage('ZUNIEFI_U834', IS_DATA, IT_DATA, returnMessage => {
                            unidocuAlert(returnMessage, $u.buttons.triggerFormTableButtonClick);
                        });
                        $dialog.dialog('close');
                    })
                ]
            });
        }

        $sment.getCodeDataWithParams = function (popupKey, params, callback) {
            var importParam = {FOBJ: popupKey};
            $.extend(importParam, params);
            var it_data = [];
            $.each(importParam, function (key, value) {
                it_data.push({KEY: key, VALUE: value});
            });
            if (callback) {
                $nst.is_data_it_data_nsReturn('ZUNIECM_3001', importParam, it_data, function (nsReturn) {
                    callback(nsReturnToCodeData(nsReturn, popupKey))
                });
            } else {
                return nsReturnToCodeData($nst.is_data_it_data_nsReturn('ZUNIECM_3001', importParam, it_data), popupKey);
            }
        };

        // 아티스트 정산
        $sment.settlementDialog = {};
        $sment.settlementDialog.open = function (flag) {
            var gridObj = $u.gridWrapper.getGrid();

            const currentRowIndex = gridObj.getActiveRowIndex();
            const currentHKONT = gridObj.$V('HKONT', currentRowIndex);
            let HAS_SPLIT_FLAG;
            if (currentHKONT) {
                HAS_SPLIT_FLAG = $u.f4Data.getCodeMapWithParams('HKONT', 'SPLIT_FLAG', {HKONT: currentHKONT})[currentHKONT] === 'X';
                if ($u.util.contains($u.page.getPROGRAM_ID(), ['UD_0201_000C'])) {
                    HAS_SPLIT_FLAG = false;
                } else {
                    if (HAS_SPLIT_FLAG && (!gridObj.$V('WRBTR', currentRowIndex) || gridObj.$V('WRBTR', currentRowIndex) === '0')) throw `${currentRowIndex + 1} 번째 행의 공급가액을 먼저 입력 해주세요.`;
                }
            }

            var templateString = '';
            templateString += '<div>';
            templateString += '<div id="guide-file-attach-wrapper" style="padding-bottom: 10px;"> <div id="guide-file-attach-content"></div> </div>';
            templateString += '<div class="unidocu-form-table-wrapper" id="f4-search-condition" data-sub-group="settlementDialog"></div>';
            templateString += '<table>';
            templateString += '<tr>';
            templateString += '<td style="width: 47%; min-width: 550px;">';
            templateString += '<div class="btn_area uni-form-table-button-area" id="settlementDialog-buttons" data-sub-group="setArtistDialog" style="margin-bottom: 5px;"></div>';
            templateString += '<div id="dialog-search-grid" class="unidocu-grid" data-sub-id="GRIDHEADER" data-sub-group="settlementDialog" style="height: 300px;"></div></td>';
            templateString += '<td style="width: 6%;">';
            templateString += '<div class="btn_area uni-form-table-button-area" id="uni-buttons3"></div></td>';
            templateString += '<td style="padding-left: 10px;">';
            templateString += '<div class="btn_area uni-form-table-button-area" id="settlementDialog-buttons2" data-sub-group="setArtistDialog" style="margin-bottom: 5px;"></div>';
            templateString += '<div id="dialog-search-grid2" class="unidocu-grid" data-sub-id="GRIDHEADER2" data-sub-group="settlementDialog" style="height: 300px; margin: 10px 0;"></div></td>';
            templateString += '</tr>';
            templateString += '</table>';
            templateString += '</div>';
            var $dialog = $(templateString);
            $u.renderUIComponents($dialog);

            var dialogGrid = $u.gridWrapper.getGrid('dialog-search-grid');
            var dialogGrid2 = $u.gridWrapper.getGrid('dialog-search-grid2');
            dialogGrid.setHeaderCheckBox('SELECTED', true);
            dialogGrid2.setHeaderCheckBox('SELECTED', true);

            if (flag !== 'artistBatchApplyByDialog') { // 아티스트 일괄적용이 아닌 경우
                if (gridObj.$V('ARTISTDATA', gridObj.getActiveRowIndex())) {
                    var artistData = gridObj.$V('ARTISTDATA', gridObj.getActiveRowIndex());
                    dialogGrid2.setJSONData(JSON.parse(artistData));
                }
            }

            $u.get('MODE').$el.change(function() {
                const MODE = $u.get('MODE').getValue();
                let atiWord = $u.get('ATI_WORD');

                dialogGrid.clearGridData();
                if ($u.get('MODE').getValue() === '2') dialogGrid.setColumnHide('AGNAM', true);
                else dialogGrid.setColumnHide('AGNAM', false);

                if (MODE === '3') {
                    atiWord.setReadOnly(true);
                    atiWord.setValue(gridObj.$V('PROJK', gridObj.getActiveRowIndex()));
                } else {
                    atiWord.setReadOnly(false);
                    atiWord.setValue('');
                }

                $u.get('ATI_WORD').$el.find('input').focus();
            }).change();

            $u.get('FAVOR').$el.change(function () {
                if ($u.get('FAVOR').getValue() === 'X') {
                    $('#f4DeleteFavorite').show();
                    $('#f4SaveFavorite').hide();
                } else {
                    $('#f4DeleteFavorite').hide();
                    $('#f4SaveFavorite').show();
                }

                $nst.is_data_ot_data('ZUNIEFI_U2000', $u.getValues('f4-search-condition'), function (ot_data) {
                    dialogGrid.setJSONData(ot_data)
                });
            }).change();

            var selectedIndex;
            dialogGrid.onChangeCell(function(columnKey, rowIndex) {
                if (columnKey === 'SELECTED') {
                    var jsonData = dialogGrid.getSELECTEDJSONData().map(function (data) {
                        return data['ATCOD'];
                    });
                    var setCollection = new Set(jsonData);
                    var isDuplicate = setCollection.size < jsonData.length;
                    if (isDuplicate) {
                        dialogGrid.$V('SELECTED', rowIndex, '');
                        throw $mls.getByCode('M_artistDuplicateCheck');
                    } else {
                        selectedIndex = dialogGrid.getSelectedRowIndexes(columnKey);
                    }
                }
            });

            dialogGrid.onCellDblClick(function(columnKey, rowIndex) {
                var jsonData = dialogGrid2.getJSONData().map(function (data) {
                    return data['ATCOD'];
                });
                var selectedData = [dialogGrid.getJSONDataByRowIndex(rowIndex)].filter(function (data) {
                    return !$u.util.contains(data['ATCOD'],  jsonData);
                });
                $.each(selectedData, function (_, data) {
                    delete data['SELECTED'];
                    dialogGrid2.addRowByJSONData(data);
                });
            });

            dialogGrid.onChangeHeaderCheckBox(function () {
                var jsonData = dialogGrid.getSELECTEDJSONData().map(function (data) {
                    return data['ATCOD'];
                });
                var setCollection = new Set(jsonData);
                var isDuplicate = setCollection.size < jsonData.length;
                if (isDuplicate) {
                    dialogGrid.unCheckAll();
                    if (selectedIndex) {
                        if (selectedIndex.length > 0) {
                            $.each(selectedIndex, function (_, index) {
                                dialogGrid.$V('SELECTED', index, '1');
                            });
                        }
                    }
                    dialogGrid._rg.gridView.setAllCheck(false);
                    throw $mls.getByCode('M_artistDuplicateCheck');
                }
            });

            dialogGrid2.onCellDblClick(function(columnKey, rowIndex) {
                dialogGrid2.deleteRowByRowIndexes([rowIndex]);
            });

            $u.buttons.addHandler({
                "search": function() {
                    $u.validateRequired('f4-search-condition');
                    $nst.is_data_ot_data('ZUNIEFI_U2000', $u.getValues('f4-search-condition'), function(ot_data) {
                        dialogGrid.setJSONData(ot_data)
                    });
                },
                "ADD": function() {

                    let selectedData = dialogGrid.getSELECTEDJSONData();
                    let resultData = dialogGrid2.getJSONData();

                    // 중복된 ATCOD 값을 가진 객체를 제거하는 함수
                    function removeDuplicates(arr) {
                        return arr.filter((obj, index, self) =>
                            index === self.findIndex((o) => o.ATCOD === obj.ATCOD)
                        );
                    }

                    // grid1, grid2를 합쳐 중복된 ATCOD을 제거한 배열
                    let combinedArray = removeDuplicates([...selectedData, ...resultData]);

                    $.each(combinedArray, function (_, data) {
                        delete data['SELECTED'];
                        // dialogGrid2.addRowByJSONData(data);
                    });
                    dialogGrid2.setJSONData(combinedArray);
                },
                "DELETE": function() {
                    dialogGrid2.deleteSelectedRows();
                },
                "f4SaveFavorite": function () {
                    dialogGrid.asserts.rowSelected();
                    $nst.tableParams_nsReturn('ZUNIEFI_U940', {IT_DATA2: dialogGrid.getSELECTEDJSONData()});
                },
                "f4DeleteFavorite": function () {
                    dialogGrid.asserts.rowSelected();

                    $nst.is_data_tableParams_os_docno('ZUNIEFI_U940', {FLAG: 'X'}, {IT_DATA2: dialogGrid.getSELECTEDJSONData()}, function () {
                        $nst.is_data_ot_data('ZUNIEFI_U2000', $u.getValues('f4-search-condition'), function (ot_data) {
                            dialogGrid.setJSONData(ot_data)
                        });
                    });
                }
            });

            var dialogButtons = [
                $u.baseDialog.getButton($mls.getByCode('DLB_cancel'), function () {
                    $dialog.dialog('close');
                }),
                $u.baseDialog.getButton($mls.getByCode('DLB_confirm'), function () {
                    var aucod = [];
                    var aunam = [];
                    var atcod = [];
                    var atnam = [];

                    dialogGrid2.loopRowIndex(function (rowIndex) {
                        if (!$u.util.contains(dialogGrid2.getJSONDataByRowIndex(rowIndex)['AUCOD'], aucod)) aucod.push(dialogGrid2.getJSONDataByRowIndex(rowIndex)['AUCOD']);
                        if (!$u.util.contains(dialogGrid2.getJSONDataByRowIndex(rowIndex)['AUNAM'], aunam)) aunam.push(dialogGrid2.getJSONDataByRowIndex(rowIndex)['AUNAM']);
                        if (!$u.util.contains(dialogGrid2.getJSONDataByRowIndex(rowIndex)['ATCOD'], atcod)) atcod.push(dialogGrid2.getJSONDataByRowIndex(rowIndex)['ATCOD']);
                        if (!$u.util.contains(dialogGrid2.getJSONDataByRowIndex(rowIndex)['ATNAM'], atnam)) atnam.push(dialogGrid2.getJSONDataByRowIndex(rowIndex)['ATNAM']);
                    });
                    if (flag === 'artistBatchApplyByDialog') { //아티스트 일괄적용
                        $u.get('ARTISTDATA__DIALOG').setValue(JSON.stringify(dialogGrid2.getJSONData()));
                        $u.get('AUCOD__DIALOG').setValue(aucod);
                        $u.get('AUNAM__DIALOG').setValue(aunam);
                        $u.get('ATCOD__DIALOG').setValue(atcod);
                        $u.get('ATNAM__DIALOG').setValue(atnam);
                    } else {
                        gridObj.$V('ARTISTDATA', gridObj.getActiveRowIndex(), JSON.stringify(dialogGrid2.getJSONData()));
                        gridObj.$V('AUCOD', gridObj.getActiveRowIndex(), aucod);
                        gridObj.$V('AUNAM', gridObj.getActiveRowIndex(), aunam);
                        gridObj.$V('ATCOD', gridObj.getActiveRowIndex(), atcod);
                        gridObj.$V('ATNAM', gridObj.getActiveRowIndex(), atnam);
                    }
                    $dialog.dialog('close');

                    if (HAS_SPLIT_FLAG) {
                        const stringArtistData = gridObj.$V('ARTISTDATA', currentRowIndex);
                        const artistData = JSON.parse(stringArtistData);

                        if (artistData.length > 0) {
                            // 공급가액을 균등 분배
                            const totalAmount = gridObj.$V('WRBTR', currentRowIndex);
                            const splitAmount = Math.floor(totalAmount / artistData.length);
                            const remainder = totalAmount % artistData.length;

                            // 마지막 행은 균등분배 + 나머지
                            artistData.forEach((artist, index) => artist['WRBTR'] = index === artistData.length - 1 ? splitAmount + remainder : splitAmount);

                            // 복사 시 첫 행은 삭제가 아닌 데이터 변경이 필요하므로 반복문을 1 부터 시작
                            for (let i = 1; i < artistData.length; i++) $u.buttons.runHandler('addCopyRow', artistData[i]);

                            const artistItem = artistData[0];
                            const fields = ['AUCOD', 'AUNAM', 'ATCOD', 'ATNAM', 'WRBTR'];

                            fields.forEach(field => gridObj.$V(field, currentRowIndex, artistItem[field]));

                            delete artistItem['WRBTR'];
                            gridObj.$V('ARTISTDATA', currentRowIndex, JSON.stringify([artistItem]));
                            gridObj.triggerChangeCell('WRBTR', currentRowIndex);
                        }
                    }
                }, 'unidocu-button dialogBlack')
            ];
            $u.baseDialog.openModalDialog($dialog, {
                width: 1300,
                title: '아티스트 정산',
                draggable: true,
                resizable: true,
                buttons: dialogButtons,
                close: function () {
                    $dialog.remove();
                }
            });
            $('#ADD').css("margin-bottom", "10px");
            var $el = $u.buttons.getEl('guideDownload').css("margin-right", '6px');
            $('#f4-search-condition .panel-search-button').before($el[0]);
            $('#guideDownload').click(function () {
                $sment.artistGuide();
            });
            $u.get('ATI_WORD').$el.find('input').focus();
            $('#f4DeleteFavorite').hide();

            if (flag === 'artistBatchApplyByDialog') {
                const PROJK = gridObj.getSELECTEDJSONData()[0]['PROJK'];
                let projk_ARTCN = '';
                const ati_target = $u.get('ATI_TARGET__DIALOG').getValue();

                $nst.is_data_ot_data('ZUNIEFI_U1200', {POSID: PROJK}, function (ot_data) {
                    for (let i = 0; i < ot_data.length; i++) {
                        if (ot_data[i]['POSID'] === PROJK) projk_ARTCN = ot_data[i]['ARTCN'];
                    }
                    $sment.artistDialog_setting(PROJK, projk_ARTCN, ati_target);
                })
            } else if (flag !== 'changeATI_TARGET') {
                $sment.changeATI_TARGET(gridObj, 'ATI_TARGET', currentRowIndex, true);
            }
        };

        // 스페이스 바 , 다이얼로그 오픈
        $sment.DialogOpenOnKeyUp = function() {
            var gridObj = $u.gridWrapper.getGrid();
            gridObj._rg.gridView.onKeyUp = function (grid, key) {
                if (gridObj.getActiveColumnKey() === 'PROJK_@' && key === 32) $sment.WBSSearchDialog(); // WBS
                if (gridObj.getActiveColumnKey() === 'ATCOD_@' && key === 32) { // 아티스트 정산
                    $sment.settlementDialog.open();
                    var $guide = $('#guide-file-attach-content');
                    $nst.is_data_nsReturn('ZUNIEFI_U1100', {FLAG: 'Y'}, function(nsReturn) {
                        $sment.setGuideDocument(nsReturn.getStringReturn("O_EVI_SEQ"), $guide, staticProperties.user['ROLE'].split(','));
                    });
                }
            };
        }

        /**
         * 날짜 문자열을 Date 객체로 변환
         * @param {string} dateString - YYYYMMDD 날짜 문자열
         * @returns {Date} 변환된 Date 객체
         */
        $sment.parseDate = (dateString) => {
            const year = parseInt(dateString.slice(0, 4), 10);
            const month = parseInt(dateString.slice(4, 6), 10) - 1; // 월은 0부터 시작
            const day = parseInt(dateString.slice(6, 8), 10);
            return new Date(year, month, day);
        }

        /**
         * 두 날짜의 차이를 일 단위로 계산합니다.
         * @param {Date} date1 - 시작 날짜
         * @param {Date} date2 - 종료 날짜
         * @returns {number} 날짜 차이 (일 단위)
         */
        $sment.calculateDateDifference = (date1, date2) => {
            const diffInMilliseconds = date2 - date1;
            return diffInMilliseconds / (1000 * 60 * 60 * 24);
        }

        /**
         * 해당 년월에 해당 하는 끝 날짜를 리턴
         * @param {String} dateString - 날짜 문자열 YYYYMMDD
         * @returns {number} 해당 년월의 마지막 날짜
         */
        $sment.daysInMonth = (dateString) => {
            const year = parseInt(dateString.substring(0, 4), 10);
            const month = parseInt(dateString.substring(4, 6), 10);
            return new Date(year, month, 0).getDate();
        };

        // 예술인 고용보험
        $sment.empInsuranceDialog = {};
        $sment.empInsuranceDialog.open = function () {
            var $lifnr = $u.get('LIFNR');
            var ktokk = '';
            var add_line = '';
            if ($lifnr && $lifnr.getValue()) {
                if (/UD_0201_011/.test($u.page.getPROGRAM_ID())) {
                    var lifnr_f4 = $u.f4Data.getCodeDataWithParams('LIFNR', {LIFNR: $lifnr.getValue()})[0];
                    if (!lifnr_f4 || !lifnr_f4['WITHT_K3']) throw $mls.getByCode('M_EmpInsurance_LIFNR');
                    else {
                        ktokk = lifnr_f4['KTOKK'];
                        add_line = lifnr_f4['ADD_LINE'];
                    }
                } else {
                    if (!$lifnr.getDialogRowData() || !$lifnr.getDialogRowData()['WITHT_K3']) throw $mls.getByCode('M_EmpInsurance_LIFNR');
                    else {
                        ktokk = $lifnr.getDialogRowData()['KTOKK'];
                        add_line = $lifnr.getDialogRowData()['ADD_LINE'];
                    }
                }
            }
            if (!ktokk) throw $mls.getByCode('M_InputLIFNR');
            if (!$u.util.contains(ktokk, $u.programSetting.getValue('TargetEmpInsurance'))) throw $mls.getByCode('M_EmpInsurance_LIFNR');

            // ZKOR, ZFOR, ZSUB 업체 예술인 고용보험
            // ZART, ZKPR 개인 예술인 고용보험
            const isCompany = $u.util.contains(ktokk, ['ZKOR', 'ZFOR', 'ZSUB']);

            var templateString = '';
            templateString += '<div class="multi-calendar">';
            templateString += '<div id="guide-file-attach-wrapper"> <div id="guide-file-attach-content"></div> </div>';
            templateString += '<div id="dialog-empInsurance-form" class="unidocu-form-table-wrapper"></div>';
            templateString += '<div class="btn_area uni-form-table-button-area" id="uni-buttons2"></div>';
            if (isCompany) {
                templateString += '<div id="dialog-search-grid" class="unidocu-grid" data-sub-id="GRIDHEADER" data-sub-group="empInsuranceDialog" style="height: 340px; margin: 10px 0;"></div>';
                templateString += '<div id="dialog-search-grid2" class="unidocu-grid" data-sub-id="GRIDHEADER" data-sub-group="empInsuranceDialog2" style="height: 340px; margin: 10px 0;"></div>';
            } else {
                templateString += '<div id="dialog-search-grid" class="unidocu-grid" data-sub-id="GRIDHEADER" data-sub-group="UD_0202_001_empInsuranceDialog" style="height: 340px; margin: 10px 0;"></div>';
                templateString += '<div id="dialog-search-grid2" class="unidocu-grid" data-sub-id="GRIDHEADER" data-sub-group="UD_0202_001_empInsuranceDialog2" style="height: 340px; margin: 10px 0;"></div>';
            }
            templateString += '</div>';
            var $dialog = $(templateString);
            $u.renderUIComponents($dialog);

            function validateContractDurations(gridData) {
                gridData.forEach((gridItem, rowIndex) => {
                    const contractStartDate = $sment.parseDate(gridItem.CONTRACT_FR);
                    const contractEndDate = $sment.parseDate(gridItem.CONTRACT_TO);
                    const daysDifference = $sment.calculateDateDifference(contractStartDate, contractEndDate);
                    // 구분이 장기일 경우 계약기간 한달 미만은 입력 불가
                    const lastDayOfMonth = $sment.daysInMonth(gridItem.CONTRACT_FR);

                    if (daysDifference < lastDayOfMonth) {
                        seletedGrid.setCellFocus('CONTRACT_FR', rowIndex);
                        throw '계약기간 한달 미만은 단기로 입력하시기 바랍니다.';
                    };
                });
            }

            var dialogGrid = $u.gridWrapper.getGrid('dialog-search-grid');
            var dialogGrid2 = $u.gridWrapper.getGrid('dialog-search-grid2');
            dialogGrid.setSummaryVisible(true, 'footer');
            dialogGrid2.setSummaryVisible(true, 'footer');
            dialogGrid.setSortEnable(false);
            dialogGrid2.setSortEnable(false);

            var seletedGrid = dialogGrid;
            $u.get('SELECT').$el.change(function() {
                if ($u.get('SELECT').getValue() === 'A') {
                    seletedGrid.clearGridData();
                    $(dialogGrid).show();
                    $(dialogGrid2).hide();
                    seletedGrid = dialogGrid;
                } else {
                    seletedGrid.clearGridData();
                    $(dialogGrid).hide();
                    $(dialogGrid2).show();
                    seletedGrid = dialogGrid2;
                }
                if (seletedGrid.getGridHeader('WORK_DAYS')) $.extend(seletedGrid.getGridHeader('WORK_DAYS'),  {required: true});

                seletedGrid.onCellClick(function (columnKey, rowIndex) {
                   if (columnKey === 'CALENDAR') {
                       if (!seletedGrid.$V('SPMON', rowIndex)) {
                           seletedGrid.setCellFocus('SPMON', rowIndex);
                           throw $mls.getByCode('M_empInsuranceDialog_month');
                       }
                       window.addEventListener('message', (function () {
                           var handler = function (event) {
                               var reg = /[\[\]\-"]/gi;
                               var dateArr = [];
                               var date;
                               $.each(event.data, function(index, item) {
                                   date = item.substring(8,10);
                                   dateArr.push(date);
                                   dateArr.sort();
                               });
                               seletedGrid.$V('WORK_DAYS', rowIndex, JSON.stringify(dateArr).replace(reg,''));
                               window.removeEventListener('message', handler);
                           };
                           return handler;
                       })());
                       $sment.multicalendarOpen(rowIndex, seletedGrid.$V('SPMON', rowIndex), seletedGrid.$V('WORK_DAYS', rowIndex));
                   }
                });

                seletedGrid.onChangeCell(function (columnKey, rowIndex) {
                    if (/ATI_NAME/.test(columnKey)) {
                        $sment._isASCIIGridSearchWord(seletedGrid, columnKey, rowIndex, seletedGrid.$V(columnKey, rowIndex));
                    }
                    if (/ATI_REG_NO/.test(columnKey)) {
                        if (!$sment._isNumberSearchWord(seletedGrid.$V(columnKey, rowIndex), columnKey)) {
                            seletedGrid.$V(columnKey, rowIndex, '');
                            if ($('.unidocu-alert').length < 1) unidocuAlert($mls.getByCode('M_inputOnlyNumber'));
                        } else if (seletedGrid.$V(columnKey, rowIndex).length < 13) {
                            seletedGrid.$V(columnKey, rowIndex, '');

                            if ($('.unidocu-alert').length < 1) unidocuAlert($u.util.formatString($mls.getByCode('M_inputDigitCheck'), {
                                rowIndex: 13
                            }));
                        } else {
                            $sment.empInsurance_controlReadonly(seletedGrid, rowIndex);
                        }
                    }
                    if (/STAY_RIGHT/.test(columnKey)) {
                        $sment.empInsurance_controlReadonly(seletedGrid, rowIndex);
                    }
                    if (columnKey === 'COUNTRY_CODE') {
                        if (seletedGrid.$V(columnKey, rowIndex) === '100') {
                            seletedGrid.$V('STAY_RIGHT', rowIndex, '');
                            seletedGrid.makeCellReadOnly('STAY_RIGHT', rowIndex);
                            $.extend(seletedGrid.getGridHeader('STAY_RIGHT'),  {required: false});
                        } else {
                            seletedGrid.makeCellEditable('STAY_RIGHT', rowIndex);
                            $.extend(seletedGrid.getGridHeader('STAY_RIGHT'),  {required: true});
                        }
                    }
                    if (columnKey === 'TOTAL_AMT') {
                        seletedGrid.$V('TARGET_AMT', rowIndex, seletedGrid.$V('TOTAL_AMT', rowIndex) * 0.75);
                    }
                });

                $u.buttons.addHandler({
                    "dialogaddRow": function() {
                        seletedGrid.addRow();
                    },
                    "dialogdeleteRow": function() {
                        seletedGrid.deleteSelectedRows();
                    }
                });

                if (!add_line || add_line !== 'X'){
                    if (seletedGrid.getRowCount() === 0) seletedGrid.addRow();
                }
            }).change();

            var dialogButtons = [
                $u.baseDialog.getButton($mls.getByCode('DLB_cancel'), function () {
                    const jsonData = seletedGrid.getJSONData();
                    const LIFNR_VALUE = $u.get('LIFNR').getValue();
                    const KTOKK_VALUE = $u.f4Data.getCodeDataWithParams('LIFNR', {LIFNR: LIFNR_VALUE})[0]['KTOKK'];

                    if ($u.util.contains(KTOKK_VALUE, ['ZKOR', 'ZFOR', 'ZSUB'])) {
                        if (jsonData.length > 0) {
                            let regnoArray = [];
                            for (let i = 0; i < jsonData.length; i++) {
                                regnoArray.push({
                                    SEQ: i+1,
                                    REGNO: jsonData[i]['ATI_REG_NO']
                                });
                            }

                            $nst.it_data_nsReturn('ZUNIEFI_U931', regnoArray, function (nsReturn) {
                                const OT_DATA = nsReturn.getTableReturn('OT_DATA');
                                const returnMessage = nsReturn.getReturnMessage();
                                const returnType = nsReturn.getReturnType();
                                if (returnType === 'W') {
                                    unidocuConfirm(returnMessage+"\n 창을 닫으면 해당 라인이 삭제됩니다.", function () {
                                        const indexes = OT_DATA
                                            .map((row, idx) => row['FLAG'] === 'E' ? idx : -1)
                                            .filter(idx => idx !== -1);

                                        const newJsonData = jsonData.filter((_, idx) => !indexes.includes(idx));
                                        let tableParams = {IT_DATA2: newJsonData};

                                        if ($u.get('SELECT').getValue() === 'B') {
                                            tableParams = {IT_DATA3: newJsonData};
                                        }
                                        $u.buttons.addCustomHandler({
                                            getEmpInsurance: function() {
                                                return tableParams;
                                            }
                                        });
                                        $sment.empInsuranceDialog_clickBtn($dialog);
                                    })
                                } else {
                                    $dialog.dialog("close");
                                }
                            })
                        } else {
                            $dialog.dialog("close");
                        }
                    } else {
                        $dialog.dialog("close");
                    }

                }),
                $u.baseDialog.getButton($mls.getByCode('DLB_confirm'), function () {
                    seletedGrid.validateGridRequired();
                    var jsonData = seletedGrid.getJSONData();
                    var tableParams = {IT_DATA2: jsonData};
                    const LIFNR_VALUE = $u.get('LIFNR').getValue();
                    const KTOKK_VALUE = $u.f4Data.getCodeDataWithParams('LIFNR', {LIFNR: LIFNR_VALUE})[0]['KTOKK'];

                    if ($u.get('SELECT').getValue() === 'B') {
                        validateContractDurations(jsonData);
                        tableParams = {IT_DATA3: jsonData};
                    }
                    if (jsonData.length === 0) tableParams = {};

                    if ($u.util.contains(KTOKK_VALUE, ['ZKOR', 'ZFOR', 'ZSUB'])) {
                        if (jsonData.length > 0) {
                            let regnoArray = [];
                            for (let i = 0; i < jsonData.length; i++) {
                                regnoArray.push({
                                    SEQ: i+1,
                                    REGNO: jsonData[i]['ATI_REG_NO']
                                });
                            }

                            $nst.it_data_nsReturn('ZUNIEFI_U931', regnoArray, function (nsReturn) {
                                const returnMessage = nsReturn.getReturnMessage();
                                const returnType = nsReturn.getReturnType();
                                if (returnType === 'W') {
                                    unidocuAlert(returnMessage);
                                } else {
                                    $sment.empInsuranceDialog_clickBtn($dialog);
                                }
                            })
                        } else {
                            $sment.empInsuranceDialog_clickBtn($dialog);
                        }
                    } else {
                        $sment.empInsuranceDialog_clickBtn($dialog);
                    }

                    $u.buttons.addCustomHandler({
                        getEmpInsurance: function() {
                            return tableParams;
                        },
                        clearEmpInsurance: function() {
                            tableParams = {};
                        }
                    });
                }, 'unidocu-button dialogBlack')
            ];
            $u.baseDialog.openModalDialog($dialog, {
                width: 1000,
                title: '예술인 고용보험',
                draggable: true,
                resizable: true,
                buttons: dialogButtons,
                close: function () {
                    $dialog.remove();
                }
            });

            document.querySelectorAll('.ui-dialog-titlebar-close').forEach(function(button) {
                button.remove();
            });

            if (!add_line || add_line !== 'X'){
                $('#dialogaddRow').hide();
                $('#dialogdeleteRow').hide();
            }

            if ($u.buttons.getCustomHandler('getEmpInsurance')) {
                var empInsurance = $u.buttons.runCustomHandler('getEmpInsurance');
                if (empInsurance['IT_DATA2']) { // 단기
                    $u.get('SELECT').setValue('A');
                    $u.get('SELECT').triggerChange();
                    seletedGrid.setJSONData(empInsurance['IT_DATA2']);
                } else if (empInsurance['IT_DATA3']) { // 장기
                    $u.get('SELECT').setValue('B');
                    $u.get('SELECT').triggerChange();
                    seletedGrid.setJSONData(empInsurance['IT_DATA3']);
                } else {
                    if (seletedGrid.getRowCount() === 0) seletedGrid.addRow();
                }
                if (!/^ZART$|^ZKPR$/.test(ktokk)) {
                    seletedGrid.loopRowIndex(function(rowIndex) {
                        $sment.empInsurance_controlReadonly(seletedGrid, rowIndex);
                    });
                }
            }

            /**
             * 임시전표수정 화면 최초 진입 시 예술인고용보험 팝업 셋팅
             * editstatementInitialLoad: 임시전표수정 화면 최초 진입 후,
             *                           예술인고용보험 팝업창 확인(DLB_confirm) 버튼 누르기 전까진 param 값으로 팝업창 셋팅
             * */
            if (!$u.page.getCustomParam()['editstatementInitialLoad'] && $u.page.getPageParams()['isEditStatement']) {

                const { emp_insurance_A, emp_insurance_B } = $u.page.getPageParams();
                const handleEmpInsurance = (type, data) => {
                    $u.get('SELECT').setValue(type);
                    $u.get('SELECT').triggerChange();
                    seletedGrid.setJSONData(data);
                }

                if (emp_insurance_A.length) handleEmpInsurance('A', emp_insurance_A);
                else if (emp_insurance_B.length) handleEmpInsurance('B', emp_insurance_B);

                if (!/^ZART$|^ZKPR$/.test(ktokk)) {
                    seletedGrid.loopRowIndex(function(rowIndex) {
                        $sment.empInsurance_controlReadonly(seletedGrid, rowIndex);
                    });
                }
            }

            seletedGrid.onBlockPaste(function (startColumnKey, startRowIndex, endColumnKey, endRowIndex) {
                var i, len;
                var headerList = seletedGrid.getGridHeaders().filter(function(data){
                    return data['key'] !== 'SELECTED' && !data['key'].includes('_TXT');
                });
                $.each(headerList, function(index, item){
                    for (i = startRowIndex, len = endRowIndex; i <= len; i++) {
                        var jsonObj;
                        if($u.util.contains(item['serverType'], ['combo', 'popup'])){
                            var params = {};
                            params[item['key']] = seletedGrid.$V(item['key'], i);
                            if (item['f4CodeKey']) jsonObj = $u.f4Data.getCachedCodeData(item['f4CodeKey'], params)[0];
                            else jsonObj = $u.f4Data.getCachedCodeData(item['key'], params)[0];
                        }
                        if (seletedGrid.$V(item['key'], i)) seletedGrid.triggerChangeCell(item['key'], i, '', seletedGrid.$V(item['key'],i), jsonObj);
                    }
                })
            });
        };

        // 가이드 문서 첨부
        $sment.setGuideDocument = function(guideFileKey, $guide, userROLE) {
            var guideReadOnly = true;
            var dialogFile = $u.fineUploader.renderFineuploader($guide);
            dialogFile.setFileGroupId(guideFileKey);
            dialogFile.setContentsVisible(true);
            dialogFile.showAsList();
            if ($u.util.contains('NOTICE', userROLE)) guideReadOnly = false;
            dialogFile.setReadOnly(guideReadOnly);
            $('#guide-file-attach-wrapper .qq-upload-list-selector').css('height', '5px');
        };

        // 예술인 고용보험 - 주민등록번호 입력 값 제한
        $sment._isNumberSearchWord = function (searchWord, columnKey) {
            return !/[^0-9]/.test(searchWord);
        };

        // 아스키코드 입력 불가 체크 (폼 영역)
        $sment._isASCIISearchWord = function (field, searchWord) {
            var stringReturns = $nst.is_data_stringReturns('ASCII', {DATA : searchWord});
            if (stringReturns['result'] === 'fail') {
                field.setEmptyValue();
                throw $mls.getByCode("M_InvalidCharIncluded");
            }
        };

        // 아스키코드 입력 불가 체크 (그리드 영역)
        $sment._isASCIIGridSearchWord = function (seletedGrid, columnKey, rowIndex, searchWord) {
            var stringReturns = $nst.is_data_stringReturns('ASCII', {DATA : searchWord});
            if (stringReturns['result'] === 'fail') {
                seletedGrid.$V(columnKey, rowIndex, '');
                if ($('.unidocu-alert').length < 1) unidocuAlert($mls.getByCode("M_InvalidCharIncluded"));
            }
        };

        // 예술인 고용보험 - 멀티 선택 캘린더
        $sment.multicalendarOpen = function (rowIndex, month, date) {
            try {
                $u.popup.openByProgramId('SM_002', 400, 650, {rowIndex: rowIndex, MONTH: month, DATE: date});
            } catch (e) {
                if (/액세스가 거부되었습니다/.test(e.message)) throw $mls.getByCode('M_UD_0302_000_approvalPopupAccessError');
                else throw e;
            }
        };

        // 아티스트 정산대상 값에 따른 디폴트 세팅
        // [아티스트] 팝업창 클릭 시 isPopup = true, [정산대상:비대상] 선택 시 !isPopup = true
        $sment.changeATI_TARGET = function (gridObj, columnKey, rowIndex, isPopup) {
            const ati_target = gridObj.$V('ATI_TARGET', rowIndex);
            const PROJK = gridObj.$V('PROJK', rowIndex);
            let projk_ARTCN = '';

            if (ati_target) {
                if (PROJK) {
                    $nst.is_data_ot_data('ZUNIEFI_U1200', {POSID: PROJK}, function (ot_data) {
                        for (let i = 0; i < ot_data.length; i++) {
                            if (ot_data[i]['POSID'] === PROJK) projk_ARTCN = ot_data[i]['ARTCN'];
                        }

                        if (!isPopup) { // '정산대상' 컬럼 선택 시
                            if (ati_target === 'N' && projk_ARTCN === 'C') {
                                let f4data = $u.f4Data.getCodeDataWithParams('ATI_TARGET', {}).filter(function (data) {
                                    return data['CDNUM'] === 'N';
                                });
                                $.each(['AGCOD', 'AGNAM', 'ATCOD', 'ATNAM', 'AUCOD', 'AUNAM'], function (index, item) {
                                    if (gridObj.getGridHeader(item)) {
                                        f4data.filter(function (data) {
                                            delete data['CDNUM'];
                                            delete data['NTEXT'];
                                            gridObj.$V(item, rowIndex, data[item]);
                                        });
                                    }
                                });
                                gridObj.$V('ARTISTDATA', rowIndex, JSON.stringify(f4data))
                            } else {
                                const GRID_ARTIST_COLUMN = ['AGCOD', 'AGNAM', 'ATCOD', 'ATNAM', 'AUCOD', 'AUNAM', 'ARTISTDATA'];
                                for (let i = 0; i < GRID_ARTIST_COLUMN.length; i++) {
                                    gridObj.$V(GRID_ARTIST_COLUMN[i], rowIndex, '')
                                }
                                $sment.settlementDialog.open('changeATI_TARGET');
                                $sment.artistDialog_setting(PROJK, projk_ARTCN, ati_target);
                            }
                        } else { //[아티스트] 팝업창 클릭 시
                            $sment.artistDialog_setting(PROJK, projk_ARTCN, ati_target);
                        }
                    })
                }

            }
        }

        $sment.artistDialog_setting = function (PROJK, projk_ARTCN) {
            const dialogGrid = $u.gridWrapper.getGrid('dialog-search-grid');

            if (projk_ARTCN === 'C') {
                $u.get('ATI_WORD').setValue(PROJK);
                $u.get('MODE').setValue('3');
                $nst.is_data_ot_data('ZUNIEFI_U2000', $u.getValues('f4-search-condition'), function (ot_data) {
                    dialogGrid.setJSONData(ot_data)
                });
            } else {
                $nst.is_data_ot_data('ZUNIEFI_U2000', {MODE: '3', ATI_WORD: PROJK}, function (ot_data) {
                    $u.get('MODE').setValue('3');

                    if (projk_ARTCN === 'A') {
                        $u.get('ATI_WORD').setValue(PROJK);
                        $('#f4-search-condition').find('.panel-search-button').hide();
                        $u.makeReadOnlyForm('f4-search-condition');
                        $u.get('FAVOR').setReadOnly(false);

                        dialogGrid.setJSONData(ot_data);
                    } else if (projk_ARTCN === 'B') {
                        $u.get('ATI_WORD').setValue(PROJK);
                        dialogGrid.setJSONData(ot_data);
                    }
                });
            }

            $u.get('ATI_WORD').setReadOnly(true);
        }

        // 전표작성:공통 엑셀 업로드 시, 아티스트 정산 데이터 제거
        $sment.removeARTISTDATA = function(gridObj) {
            if (/ART_01/.test(staticProperties.user['ROLE'])) {
                // 신규 차량메뉴에서는 제외하기로함
                if ($u.util.contains($u.page.getPROGRAM_ID(), ['UD_0208_001', 'UD_0208_011', 'UD_0208_021', 'UD_0208_030', 'UD_0802_010'])) return;
                $sment.makeArtistData(gridObj.getJSONData());
                return;
            }
            gridObj.loopRowIndex(function(rowIndex) {
                $.each(['AGCOD', 'AGNAM', 'ATCOD', 'ATNAM', 'AUCOD', 'AUNAM', 'ARTISTDATA'], function(_, item) {
                    if ($u.gridWrapper.getGrid().getGridHeader(item)) gridObj.$V(item, rowIndex, '');
                });
            });
        }

        // 계정코드 F4 변경
        $sment.handleHKONT = function(rowIndex, jsonObj, flag) {
            var gridObj = $u.gridWrapper.getGrid();
            if (jsonObj && jsonObj['WEB_EVENT']) gridObj.$V('FLAG', rowIndex, jsonObj['WEB_EVENT']);
            else gridObj.$V('FLAG', rowIndex, '');

            if (jsonObj && jsonObj['SPLIT_FLAG']) $sment.artistDataEmpty(rowIndex);

            $sment.setVATFromHKONTFlag(rowIndex, jsonObj);
            $sment.setCARNOFromHKONTFlag(rowIndex, jsonObj);
            $sment.handleTaxAndNonDeduction(rowIndex, jsonObj, flag);
            $sment.setMWSKZ_By_HKONT_F4(rowIndex, jsonObj);
        }

        $sment.artistDataEmpty = (rowIndex) => {
            const gridObj = $u.gridWrapper.getGrid();
            const artistColumnArr = ['AGCOD', 'AGNAM', 'AUCOD', 'AUNAM', 'ATCOD', 'ATNAM', 'ARTISTDATA'];

            artistColumnArr.forEach(columnKey => {
               if (gridObj.getGridHeader(columnKey)) gridObj.$V(columnKey, rowIndex, '');
            });
        }

        // 차량 비용 메뉴에서 CAR_FLAG 에 따라 차량번호 컬럼 활성화
        $sment.setCARNOFromHKONTFlag = (rowIndex, jsonObj) => {
            if (!$u.util.contains($u.page.getPROGRAM_ID(), ['UD_0208_001', 'UD_0208_000C', 'UD_0208_011', 'UD_0208_021', 'UD_0208_030'])) return;
            const gridObj = $u.gridWrapper.getGrid();

            if (jsonObj && jsonObj['CAR_FLAG'] === 'Y') {
                gridObj.makeCellRequired('CARNO', rowIndex);
            } else {
                gridObj.makeCellReadOnly('CARNO', rowIndex);
                gridObj.$V('CARNO', rowIndex, '');
                gridObj.$V('CARNO_TXT', rowIndex, '');
            }
        }

        // 계정코드 분장비인경우 과세구분, 불공사유 제어
        $sment.handleTaxAndNonDeduction = (rowIndex, jsonObj, flag) => {
            if (!$sment.useTaxAndNonDeductionProgramId()) return;

            const gridObj = $u.gridWrapper.getGrid();
            const { NON_CODE = '', NON_FLAG = '' } = jsonObj || {};

            gridObj.$V('NON_CODE', rowIndex, NON_CODE);
            gridObj.$V('NON_FLAG', rowIndex, NON_FLAG);
            $sment.setTaxAndNonDeduction(flag);
        }

        $sment.setTaxAndNonDeduction = (flag) => {
            if (!$sment.useTaxAndNonDeductionProgramId()) return;

            const gridObj = $u.gridWrapper.getGrid();
            const hasNonFlagItem = gridObj.getJSONData().find(gridItem => gridItem['NON_FLAG'] !== '');
            const { MWSKZ } = $u.page.getPageParams();

            if (hasNonFlagItem && MWSKZ !== 'X2') {
                const { NON_FLAG, NON_CODE } = hasNonFlagItem;

                gridObj.loopRowIndex((gridRowIndex) => {
                    gridObj.$V('MWSKZ', gridRowIndex, NON_FLAG);
                    gridObj.makeCellReadOnly('MWSKZ', gridRowIndex);
                });

                $u.get('MWSKZ').setReadOnly(true).setValue(NON_FLAG).triggerChange();
                $u.get('CODE_M').setReadOnly(true).setValue(NON_CODE);
            } else {
                if (flag === 'afterMultiCellChange') return;
                gridObj.loopRowIndex((gridRowIndex) => {
                    gridObj.makeCellEditable('MWSKZ', gridRowIndex);
                    if (MWSKZ) gridObj.$V('MWSKZ', gridRowIndex, MWSKZ);
                });

                if (MWSKZ) $u.get('MWSKZ').setReadOnly(false).setValue(MWSKZ).triggerChange();
                else $u.get('MWSKZ').setReadOnly(false).triggerChange();
            }
        }

        // [고지서]전자(세금)계산서 전용 KOSTL, PROJK, CPUDT 값 초기화 및 필수 해제
        $sment.setVATFromHKONTFlag = function(rowIndex, jsonObj){
            if($u.page.getPROGRAM_ID() !== 'UD_0202_021B') return;
            var gridObj = $u.gridWrapper.getGrid();

            if(jsonObj && jsonObj.MWSKZ2 === 'X'){
                ['PROJK', 'KOSTL', 'CPUDT'].map((item) => {
                    gridObj.makeCellEditable(item, rowIndex);
                    gridObj.$V(item, rowIndex, '');
                    if(gridObj.getGridHeader(item + '_TXT')){
                        gridObj.$V(item + '_TXT', rowIndex, '');
                    }
                });

                gridObj.$V('FWBAS', rowIndex, '');
                gridObj.makeCellEditable('FWBAS', rowIndex);
                gridObj.makeCellRequired('FWBAS', rowIndex);

                // MWSKZ2가 X인 경우 계정코드 MWSKZ 값 자동 매핑
                gridObj.$V('MWSKZ', rowIndex, jsonObj.MWSKZ);
                gridObj.triggerChangeCell('MWSKZ', rowIndex);

                // ATI_TARGET, ATI_CATEG_TXT
                // 정산대상 이후 컬럼 모두 readOnly
                ['ATI_TARGET', 'ATI_CATEG', 'AGCOD', 'AGNAM', 'AUCOD', 'AUNAM', 'ATCOD', 'ATNAM', 'ARTISTDATA'].map((item) => {
                    gridObj.$V(item, rowIndex, '');
                    gridObj.makeCellReadOnly(item, rowIndex);
                    if(gridObj.getGridHeader(item + '_TXT')){
                        gridObj.$V(item + '_TXT', rowIndex, '');
                    }
                });

                console.debug("jsonObj", jsonObj);
            }else{
                ['PROJK', 'CPUDT', 'ATI_TARGET', 'ATI_CATEG'].map((item) => {
                    gridObj.makeCellRequired(item, rowIndex);
                });

                gridObj.$V('FWBAS', rowIndex, '');
                gridObj.makeCellReadOnly('FWBAS', rowIndex);
            }
        }

        // 공급업체 F4 변경
        $sment.handleLIFNR = (function () {
            var oldData;
            return function () {
                if ($u.get('LIFNR') && $u.get('WT_WITHCD')) {
                    oldData = '';
                    $u.get('LIFNR').$el.change(function() {
                        $.each(['WT_WITHCD', 'SWSTE', 'JWSTE', 'SWSTE_K3'], function(_, item) {
                            if($u.get(item)){
                                $u.get(item).setEmptyValue();
                                $u.get(item).setReadOnly(true);
                            }
                        });
                        if ($u.get('WRBTR_PAY')) $u.get('WRBTR_PAY').setValue($efi.createStatementCommon.getExpenseCalculatedWRBTR());
                        var newData = $u.get('LIFNR').getDialogRowData();
                        if (newData && newData['WITHT']) {
                            if (newData['WITHT'] === 'X') {
                                $u.get('WT_WITHCD').setReadOnly(false);
                            }
                        } else {
                            $u.get('MWSKZ').setReadOnly(false);
                            $u.gridWrapper.getGrid().loopRowIndex(function(rowIndex) {
                                $u.gridWrapper.getGrid().makeCellEditable('MWSKZ', rowIndex);
                            });
                        }

                        if (newData && (newData['KTOKK'] !== oldData)) {
                            if ($u.buttons.getCustomHandler('getEmpInsurance')) {
                                if (!$.isEmptyObject($u.buttons.runCustomHandler('getEmpInsurance')))
                                    $u.buttons.runCustomHandler('clearEmpInsurance');
                            }
                        }
                        oldData = newData ? newData['KTOKK'] : '';
                    }).change();
                }
            }
        })();

        // 원천세 F4 변경
        $sment.handleWT_WITHCD = function () {
            if (!/^UD_0202_021|UD_0202_001_A$|^UD_0208_021$|^UD_SM_6000$/.test($u.page.getPROGRAM_ID())) return;
            var gridObj = $u.gridWrapper.getGrid();
            if ($u.get('WT_WITHCD')) {
                $u.get('WT_WITHCD').$el.change(function() {
                    var witht_k3 = $u.get('LIFNR').getDialogRowData()['WITHT_K3'];
                    if (witht_k3 && /B1|C1/.test($u.get('WT_WITHCD').getValue()) && /^UD_0202_021$|^UD_0202_021_2$|^UD_0208_021$|^UD_SM_6000$/.test($u.page.getPROGRAM_ID())) {
                        unidocuConfirm($mls.getByCode('M_check_empInsuranceDialog'), function() {
                            $u.buttons.runHandler('emp_Insurance');
                        });
                    }
                    if ($u.get('WT_WITHCD').getValue()) {
                        $u.get('MWSKZ').setEmptyValue();
                        $u.get('MWSKZ').setReadOnly(true);
                        $u.get('WMWST').setReadOnly(true);
                        gridObj.loopRowIndex(function(rowIndex) {
                            gridObj.$V('MWSKZ', rowIndex, '');
                            gridObj.makeCellReadOnly('MWSKZ', rowIndex);
                        });
                        if (/A1/.test($u.get('WT_WITHCD').getValue())) $u.get('EXPENSE').setReadOnly(false);
                        else $u.get('EXPENSE').setReadOnly(true);
                        if (/(D1|E1)/.test($u.get('WT_WITHCD').getValue())) {
                            $u.get('SWSTE').setReadOnly(false);
                            $u.get('JWSTE').setReadOnly(false);
                        } else {
                            $u.get('SWSTE').setReadOnly(true);
                            $u.get('JWSTE').setReadOnly(true);
                        }
                    } else {
                        $.each(['SWSTE', 'JWSTE', 'SWSTE_K3', 'EXPENSE'], function(_, item) {
                            if($u.get(item)){
                                $u.get(item).setEmptyValue();
                                $u.get(item).setReadOnly(true);
                            }
                        });
                        $u.get('MWSKZ').setReadOnly(false);
                        $u.get('WMWST').setReadOnly(false);
                        gridObj.loopRowIndex(function(rowIndex) {
                            gridObj.makeCellEditable('MWSKZ', rowIndex);
                        });
                    }
                    $efi.createStatementCommon.changeWRBTRExpense();
                });
            }
        };

        // 지급금액 계산
        $sment.CalculateWRBTR_PAY = function() {
            const programId = $u.page.getPROGRAM_ID();
            const returnProgramId = ['UD_0202_021Z', 'UD_0202_021Z_1', 'UD_0202_021Y', 'UD_0202_021Y_1'];// 메뉴: 고객-거래처(거래처or고객)
            if (!/UD_0202_021|UD_0202_021_2|UD_0202_001_A|UD_0208_021|UD_SM_6000/.test(programId)) return;
            if ($u.util.contains(programId, returnProgramId)) return;

            var swste = $u.get('SWSTE').getValue();
            var jwste = $u.get('JWSTE').getValue();
            var swste_k3 = $u.get('SWSTE_K3') ? $u.get('SWSTE_K3').getValue() : 0;
            var sum = swste + jwste + swste_k3;
            if ($u.get('WRBTR_PAY')) $u.get('WRBTR_PAY').setValue($u.get('WRBTR').getValue() - sum);
            $u.page.setCustomParam('WRBTR_PAY', $u.get('WRBTR_PAY').getValue());
        }

        // 원천세 계산
        $efi.createStatement.calculateWithcdTax = function () {
            var $u_WT_WITHCD = $u.get('WT_WITHCD');
            if ($u_WT_WITHCD) {
                var params = $.extend($u.getValues('header-invoicer-content'), {K3_CHECK: 'X'});
                if ($u.get('CHARGETOTAL')) params['CTOTAL'] = $u.get('CHARGETOTAL').getValue();
                if ($u_WT_WITHCD.getValue() !== '') {
                    if ($u.buttons.getCustomHandler('getEmpInsurance')) {
                        if ($.isEmptyObject($u.buttons.runCustomHandler('getEmpInsurance'))) $.extend(params, {K3_CHECK: ''});
                        if ($u.page.getPageParams()['isEditStatement']) {
                            if ($u.page.getCustomParam('finishEditScreenSetup')) {
                                $nst.is_data_os_data('ZUNIEFI_4520', params, function (os_data) {
                                    $u.setValues(os_data);
                                    $u.page.setCustomParam('SWSTE', $u.get('SWSTE').getValue());
                                    $u.page.setCustomParam('JWSTE', $u.get('JWSTE').getValue());
                                    $sment.CalculateWRBTR_PAY();
                                });
                            }
                        } else {
                            $nst.is_data_os_data('ZUNIEFI_4520', params, function (os_data) {
                                $u.setValues(os_data);
                                $u.page.setCustomParam('SWSTE', $u.get('SWSTE').getValue());
                                $u.page.setCustomParam('JWSTE', $u.get('JWSTE').getValue());
                                $sment.CalculateWRBTR_PAY();
                            });
                        }
                    } else {
                        $u.buttons.addCustomHandler({
                            getEmpInsurance: function () {
                                return {};
                            }
                        });
                        $efi.createStatement.calculateWithcdTax();
                    }
                } else {
                    if ($u.buttons.getCustomHandler('getEmpInsurance')) {
                        if ($.isEmptyObject($u.buttons.runCustomHandler('getEmpInsurance'))) $.extend(params, {K3_CHECK: ''});
                        if ($u.page.getPageParams()['isEditStatement']) {
                            if ($u.page.getCustomParam('finishEditScreenSetup')) {
                                $nst.is_data_os_data('ZUNIEFI_4520', params, function (os_data) {
                                    $u.setValues(os_data);
                                    $sment.CalculateWRBTR_PAY();
                                });
                            }
                        } else {
                            $nst.is_data_os_data('ZUNIEFI_4520', params, function (os_data) {
                                $u.setValues(os_data);
                                $sment.CalculateWRBTR_PAY();
                            });
                        }
                    } else {
                        $u.buttons.addCustomHandler({
                            getEmpInsurance: function () {
                                return {};
                            }
                        });
                        $efi.createStatement.calculateWithcdTax();
                    }
                }
            }
        }

        $sment.setSWSTE_K3 = function(params) {
            if(!$u.util.contains($u.page.getPROGRAM_ID(), ['UD_0202_021', 'UD_0202_021_2', 'UD_0201_011', 'UD_0208_021', 'UD_SM_6000'])) return;
            if($u.get('SWSTE_K3') && params.K3_CHECK === 'X'){
                $u.get('SWSTE_K3').setReadOnly(!(params.K3_CHECK === 'X'));
            }
        }

        // 아티스트 정산 필수 체크
        $sment.settlementValidate = function () {
            var gridObj = $u.gridWrapper.getGrid();
            if (gridObj.getGridHeader('ATCOD')) $.extend(gridObj.getGridHeader('ATCOD'),  {required: true});
        };

        // 의상비 계정, 추가데이터 필수 처리
        $sment.clothingCost = function () {
            $u.get('ADD_0001').$el.change(function() {
                $.each(['ADD_0002', 'ADD_0003', 'ADD_0004', 'ADD_0005'], function(index, item) {
                    if ($u.get('ADD_0001').getValue() === 'Y') {
                        $u.get(item).setRequired(true);
                        $u.get(item).setReadOnly(false);
                    } else if ($u.get('ADD_0001').getValue() === 'N') {
                        $u.get(item).setRequired(false);
                        $u.get(item).setReadOnly(true);
                        $u.get(item).setEmptyValue();
                    } else {
                        $u.get(item).setRequired(false);
                        $u.get(item).setReadOnly(false);
                        $u.get(item).setEmptyValue();
                    }
                });
            }).change();

            $u.get('ADD_0002').$el.change(function() {
                $sment._isASCIISearchWord($u.get('ADD_0002'), $u.get('ADD_0002').getValue());
            });
            $u.get('ADD_0003').$el.change(function() {
                $sment._isASCIISearchWord($u.get('ADD_0003'), $u.get('ADD_0003').getValue());
            });
        };

        // 선급비용 계정
        $sment.addData_advanceCostValidation = function (rowIndex) {
            if ($u.gridWrapper.getGrid().$V('FLAG', rowIndex) === 'Y') {
                if ($u.util.date.getDiffDays($u.get('ADD_0002').getValue(), $u.get('ADD_0001').getValue()) < 0) {
                    throw $mls.getByCode('M_addData_advanceCost_FROM');
                }
            }
        }

        // 예술인 고용보험 - 국가/체류자격코드 컬럼 제어
        $sment.empInsurance_controlReadonly = function(seletedGrid, rowIndex) {
            if ($u.util.contains(seletedGrid.$V('ATI_REG_NO', rowIndex).charAt(6), ['1', '2', '3', '4'])) {
                seletedGrid.$V('COUNTRY_CODE_TXT', rowIndex, '');
                $.each(['COUNTRY_CODE', 'STAY_RIGHT'], function(_, item) {
                    seletedGrid.$V(item, rowIndex, '');
                    seletedGrid.makeCellReadOnly(item, rowIndex);
                    $.extend(seletedGrid.getGridHeader(item),  {required: false});
                });
            } else {
                $.each(['COUNTRY_CODE', 'STAY_RIGHT'], function(_, item) {
                    seletedGrid.makeCellEditable(item, rowIndex);
                    $.extend(seletedGrid.getGridHeader(item),  {required: true});
                });
            }
        };

        // 전체 아티스트 목록 엑셀 다운로드
        $sment.artistGuide = function() {
            var ot_data = $nst.is_data_ot_data('ZUNIEFI_U2000', {ALL_LIST: 'X'});
            require(['xlsx'], function(xlsx){
                try {
                    $.each(ot_data, function(index, item) {
                        item['회사코드'] = item['BUKRS'];
                        item['아티스트그룹'] = item['AGCOD'];
                        item['아티스트그룹명'] = item['AGNAM'];
                        item['아티스트유닛'] = item['AUCOD'];
                        item['아티스트유닛명'] = item['AUNAM'];
                        item['아티스트'] = item['ATCOD'];
                        item['아티스트명'] = item['ATNAM'];
                        delete item['BUKRS'];
                        delete item['AGCOD'];
                        delete item['AGNAM'];
                        delete item['AUCOD'];
                        delete item['AUNAM'];
                        delete item['ATCOD'];
                        delete item['ATNAM'];
                    });

                    var wb = xlsx.utils.book_new(); var ws = xlsx.utils.aoa_to_sheet(
                        [Object.keys(ot_data[0])]
                            .concat(ot_data.map(function(data){return Object.values(data)}))
                    );
                    xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
                    xlsx.writeFile(wb, "아티스트 목록.xlsx", {bookType: "xlsx"});
                } catch (e) {
                    return e;
                }
            });
        }

        // AP대량전표 화면 validation
        $sment.UD_SM_2000Validate = function () {
            var gridObj = $u.gridWrapper.getGrid();
            $.each($u.programSetting.getValue('setGridValidation'), function(_, item) {
                if (gridObj.getGridHeader(item)) $.extend(gridObj.getGridHeader(item),  {required: true});
            });
        };

        // 법인카드(대량) 일괄적용 - 계정코드 F4에 파라미터 전달 관련
        $sment.batchApplyDialogClear = function() {
            var HKONTList = [];
            var F4Params = $u.f4Data.getCodeDataWithParams('HKONT', {PROJK: $u.get('PROJK__DIALOG').getValue()});
            $.each(F4Params, function(rowIndex, data) {
                HKONTList.push(data['HKONT']);
            });
            if (!$u.util.contains($u.get('HKONT__DIALOG').getValue(), HKONTList)) {
                $u.get('HKONT__DIALOG').setEmptyValue();
            }
        }

        // WBS 다이얼로그
        $sment.WBSSearchDialog = function (flag) {
            var templateString = '';
            templateString += '<div>';
            templateString += '<div id="dialog-WBSSearchDialog-form" class="unidocu-form-table-wrapper" data-sub-group="wbsDialog"></div>';
            templateString += '<div class="btn_area uni-form-table-button-area" id="dialog-WBSSearchDialog-buttons" data-sub-group="wbsDialog"></div>';
            templateString += '<div id="WBSSearchDialog-grid" class="unidocu-grid" data-sub-id="GRIDHEADER" data-sub-group="WBSSearchDialog" style="height: 340px; margin: 10px 0;"></div>';
            templateString += '</div>';
            var $dialog = $(templateString);
            $u.renderUIComponents($dialog);

            var gridObj = $u.gridWrapper.getGrid('');
            var dialogGrid = $u.gridWrapper.getGrid('WBSSearchDialog-grid');

            const f4CodeDialogAUNFROpen = () => {
                const isMassStatement = flag === 'X';

                const currentRowIndex = gridObj.getActiveRowIndex();
                const currentPROJK = gridObj.$V('PROJK', currentRowIndex);

                if (isMassStatement) {
                    $u.get('AUFNR__DIALOG').setValue({code: '', text: ''});
                } else {
                    gridObj.$V('AUFNR', currentRowIndex, '');
                    gridObj.$V('AUFNR_TXT', currentRowIndex, '');
                }

                $u.dialog.f4CodeDialog.open({
                    popupKey : isMassStatement ? 'AUFNR__DIALOG' : 'AUFNR',
                    readonlyInfo : { key : 'PROJK', value : currentPROJK },
                    codePopupCallBack: function (code, name) {
                        if (isMassStatement) {
                            $u.get('AUFNR__DIALOG').setValue({code, text: name});
                        } else {
                            gridObj.$V('AUFNR', currentRowIndex, code);
                            gridObj.$V('AUFNR_TXT', currentRowIndex, name);
                            const currentHKONT = gridObj.$V('HKONT', currentRowIndex);
                            if (currentHKONT) $sment.validateAndClear('HKONT', currentRowIndex, {HKONT : currentHKONT});
                        }
                    }
                });
            }

            var dialogButtons = [
                $u.baseDialog.getButton($mls.getByCode('DLB_cancel'), function () {
                    $dialog.dialog('close');
                }),
                $u.baseDialog.getButton($mls.getByCode('DLB_confirm'), function () {
                    dialogGrid.asserts.rowSelected();
                    dialogGrid.asserts.selectedExactOneRow();

                    var selectedData = dialogGrid.getSELECTEDJSONData()[0];
                    if (flag === 'X') { // 법인카드 대량
                        $u.get('dialog-search-form', 'PROJK__DIALOG').setValue(selectedData['POSID']);
                        $u.get('dialog-search-form', 'PROJK_TXT__DIALOG').setValue(selectedData['POST2'] + ' \/ ' + selectedData['POST1']);
                        $sment.DialogHKONT_CONTROL($u.get('PROJK__DIALOG').getValue());
                        $sment.DialogKOSTL_CONTROL($u.get('PROJK__DIALOG').getValue());
                    } else if (flag === 'Y') { // 예산관리
                        $u.get('form-table2', 'ZPSPNR_F').setValue(selectedData['POSID']);
                        $u.get('form-table2', 'ZPSPNR_F_TXT').setValue(selectedData['POST2']);
                        $sment.HeaderHKONT_CONTROL(selectedData['POSID']);
                    } else if (flag === 'N') { // 부서예산조회
                        $u.get('search-condition', 'PSPNR').setValue(selectedData['POSID']);
                        $u.get('search-condition', 'PSPNR_TXT').setValue(selectedData['POST2']);
                    } else { // 비용항목
                        var activeRowIndex = gridObj.getActiveRowIndex();
                        gridObj.$V('PROJK', activeRowIndex, selectedData['POSID']);
                        gridObj.$V('PROJK_TXT', activeRowIndex, selectedData['POST2'] + ' \/ ' + selectedData['POST1']);
                        $sment.gridHKONT_CONTROL(selectedData['POSID'], activeRowIndex);
                        $sment.gridKOSTL_CONTROL(selectedData['POSID'], activeRowIndex);
                    }

                    $dialog.dialog("close");
                    f4CodeDialogAUNFROpen();
                }, 'unidocu-button dialogBlack')
            ];

            $u.baseDialog.openModalDialog($dialog, {
                width: 1200,
                title: 'WBS',
                draggable: true,
                resizable: true,
                buttons: dialogButtons,
                close: function () {
                    $dialog.remove();
                }
            });
            $u.get('PROJ_TXT').$el.find('input').focus();

            dialogGrid.onCellClick(function (columnKey, rowIndex) {
                if (columnKey === 'POSID') {
                    if (flag === 'X') { // 법인카드 대량
                        $u.get('dialog-search-form', 'PROJK__DIALOG').setValue(dialogGrid.$V('POSID', rowIndex));
                        $u.get('dialog-search-form', 'PROJK_TXT__DIALOG').setValue(dialogGrid.$V('POST2', rowIndex) + ' \/ ' + dialogGrid.$V('POST1', rowIndex));
                        $sment.DialogHKONT_CONTROL($u.get('PROJK__DIALOG').getValue());
                        $sment.DialogKOSTL_CONTROL($u.get('PROJK__DIALOG').getValue());
                    } else if (flag === 'Y') { // 예산관리
                        $u.get('form-table2', 'ZPSPNR_F').setValue(dialogGrid.$V('POSID', rowIndex));
                        $u.get('form-table2', 'ZPSPNR_F_TXT').setValue(dialogGrid.$V('POST2', rowIndex));
                        $sment.HeaderHKONT_CONTROL($u.get('ZPSPNR_F').getValue());
                    } else if (flag === 'N') { // 부서예산조회
                        $u.get('search-condition', 'PSPNR').setValue(dialogGrid.$V('POSID', rowIndex));
                        $u.get('search-condition', 'PSPNR_TXT').setValue(dialogGrid.$V('POST2', rowIndex));
                    } else { // 비용항목
                        gridObj.$V('PROJK', gridObj.getActiveRowIndex(), dialogGrid.$V('POSID', rowIndex));
                        gridObj.$V('PROJK_TXT', gridObj.getActiveRowIndex(), dialogGrid.$V('POST2', rowIndex) + ' \/ ' + dialogGrid.$V('POST1', rowIndex));
                        $sment.gridHKONT_CONTROL(dialogGrid.$V('POSID', rowIndex), gridObj.getActiveRowIndex());
                        $sment.gridKOSTL_CONTROL(dialogGrid.$V('POSID', rowIndex), gridObj.getActiveRowIndex());
                    }

                    $dialog.dialog('close');
                    f4CodeDialogAUNFROpen();
                }
            });

            $u.get('FAVOR').$el.change(function () {
                if ($u.get('FAVOR').getValue() === 'X') {
                    $('#f4DeleteFavorite').show();
                    $('#f4SaveFavorite').hide();
                } else {
                    $('#f4DeleteFavorite').hide();
                    $('#f4SaveFavorite').show();
                }

                $nst.is_data_ot_data('ZUNIEFI_U1200', $u.getValues('dialog-WBSSearchDialog-form'), function(ot_data) {
                    dialogGrid.setJSONData(ot_data);
                });
            }).change();

            $u.buttons.addHandler({
                "WBSSearch": function() {
                    $nst.is_data_ot_data('ZUNIEFI_U1200', $u.getValues('dialog-WBSSearchDialog-form'), function(ot_data) {
                        dialogGrid.setJSONData(ot_data);
                    });
                },
                "f4SaveFavorite": function () {
                    dialogGrid.asserts.rowSelected();
                    $nst.tableParams_nsReturn('ZUNIEFI_U940', {IT_DATA1: dialogGrid.getSELECTEDJSONData()});
                },
                "f4DeleteFavorite": function () {
                    dialogGrid.asserts.rowSelected();

                    $nst.is_data_tableParams_os_docno('ZUNIEFI_U940', {FLAG : 'X'}, {IT_DATA1: dialogGrid.getSELECTEDJSONData()}, function () {
                        $nst.is_data_ot_data('ZUNIEFI_U1200', $u.getValues('dialog-WBSSearchDialog-form'), function(ot_data) {
                            dialogGrid.setJSONData(ot_data);
                        });
                    });
                }
            });
        }

        // WBS 코드 입력 시, 자동 입력 (헤더)
        $sment.WBS_callRFC = function(columnKey, flag) {
            var targetColumn = columnKey+'_TXT';
            if (columnKey === 'PROJK__DIALOG') targetColumn = 'PROJK_TXT__DIALOG';
            $nst.is_data_ot_data('ZUNIEFI_U1200', {POSID : $u.get(columnKey).getValue()}, function(ot_data) {
                if (ot_data.length > 0) {
                    const findItem = ot_data.find(OT_ITEM => OT_ITEM['POSID'] === $u.get(columnKey).getValue());
                    if (findItem) {
                        const { POSID, POST2 } = findItem;
                        $u.get(columnKey).setValue(POSID);
                        $u.get(targetColumn).setValue(POST2 + ' \/ ' + POSID);
                        $sment.HeaderHKONT_CONTROL(POSID, flag);
                        $sment.HeaderKOSTL_CONTROL(POSID, flag);
                    }
                } else {
                    $u.get(columnKey).setEmptyValue();
                    $u.get(targetColumn).setEmptyValue();
                }
            });
        }

        // WBS 코드 입력 시, 자동 입력 (그리드)
        $sment.gridWBS_callRFC = function(rowIndex, otdata) {
            var gridObj = $u.gridWrapper.getGrid();
            let gridWbsData = gridObj.$V('PROJK', rowIndex);

            // WBS 코드 입력에 따라 내부오더 값이 다름
            if (gridObj.getGridHeader('AUFNR')) {
                const currentAUFNR = gridObj.$V('AUFNR', rowIndex);
                if (currentAUFNR) $sment.validateAndClear('AUFNR', rowIndex,  {PROJK: gridWbsData});
            }

            if (/^UD_0201_011A$|^UD_0202_001_A$/.test($u.page.getPROGRAM_ID()) || gridWbsData === '') return;
            if (!otdata || !otdata.length) {
                $nst.is_data_ot_data('ZUNIEFI_U1200', {POSID : gridWbsData}, function(ZUNIEFI_U1200_ot_data) {
                    if (ZUNIEFI_U1200_ot_data.length > 0) {
                        const findItem = ZUNIEFI_U1200_ot_data.find(OT_ITEM => OT_ITEM['POSID'] === gridWbsData);
                        if (findItem) {
                            const { POSID, POST2 } = findItem;
                            gridObj.$V('PROJK', rowIndex, POSID);
                            gridObj.$V('PROJK_TXT', rowIndex, POST2 + ' \/ ' + POSID);
                            $sment.gridHKONT_CONTROL(POSID, rowIndex);
                            $sment.gridKOSTL_CONTROL(POSID, rowIndex);
                        }
                    } else {
                        gridObj.$V('PROJK', rowIndex, '');
                        gridObj.$V('PROJK_TXT', rowIndex, '');
                    }
                });
            }else{
                let wbsData;
                if (otdata.length) wbsData = otdata.find(item => {return item['POSID'] === gridWbsData});
                if(wbsData){
                    gridObj.$V('PROJK', rowIndex, wbsData['POSID']);
                    gridObj.$V('PROJK_TXT', rowIndex, wbsData['POST2'] + ' \/ ' + wbsData['POST1']);
                    $sment.gridHKONT_CONTROL(wbsData['POSID'], rowIndex);
                    $sment.gridKOSTL_CONTROL(wbsData['POSID'], rowIndex);
                }else{
                    gridObj.$V('PROJK', rowIndex, '');
                    gridObj.$V('PROJK_TXT', rowIndex, '');
                }
            }
        }

        // WBS에 따른 계정 제어 (일괄적용 다이얼로그)
        $sment.DialogHKONT_CONTROL = function(projk) {
            var HKONTList = [];
            var F4Params = $u.f4Data.getCodeDataWithParams('HKONT', {PROJK: projk});
            if (projk) {
                $.each(F4Params, function(_, data) {
                    HKONTList.push(data['HKONT']);
                });
                if (!$u.util.contains($u.get('HKONT__DIALOG').getValue(), HKONTList)) {
                    $u.get('HKONT__DIALOG').setEmptyValue();
                }
            } else $u.get('PROJK_TXT__DIALOG').setEmptyValue();
        }

        // WBS에 따른 계정 제어 (헤더)
        $sment.HeaderHKONT_CONTROL = function(projk, flag) {
            var HKONTList = [];
            var F4Params = $u.f4Data.getCodeDataWithParams('HKONT', {PROJK: projk});
            if (projk) {
                $.each(F4Params, function(_, data) {
                    HKONTList.push(data['HKONT']);
                });
                var $hkont = $u.get('HKONT__DIALOG');
                if (flag === 'X') { // 법인카드 대량
                    if (!$u.util.contains($hkont.getValue(), HKONTList)) $hkont.setEmptyValue();
                } else if (flag === 'Y') { // 예산관리
                    $hkont = $u.get('ZSAKNR_F');
                    if (!$u.util.contains($hkont.getValue(), HKONTList)) $hkont.setEmptyValue();
                }
            } else {
                if (flag === 'X') { // 법인카드 대량
                    $u.get('PROJK__DIALOG').setEmptyValue();
                    $u.get('PROJK_TXT__DIALOG').setEmptyValue();
                } else if (flag === 'Y') { // 예산관리
                    $u.get('ZPSPNR_F').setEmptyValue();
                    $u.get('ZPSPNR_F_TXT').setEmptyValue();
                }
            }
        }

        // WBS에 따른 계정 제어 (그리드)
        $sment.gridHKONT_CONTROL = function(projk, rowIndex) {
            var gridObj = $u.gridWrapper.getGrid();
            let hkontData = gridObj.$V('HKONT', rowIndex);
            if(hkontData){
                //내부오더가 입력이 안 되어서 그런 거 같음
                var F4Params = $u.f4Data.getCodeDataWithParams('HKONT', {PROJK: projk, HKONT : hkontData});
                if (projk) {
                    if (F4Params.length < 1) {
                        gridObj.$V('HKONT', rowIndex, '');
                        gridObj.$V('HKONT_TXT', rowIndex, '');
                    }
                    $efi.addDataHandler.handleADD_DATAKeyChange(rowIndex);
                } else gridObj.$V('PROJK_TXT', rowIndex, '');
            }
        }

        // WBS에 따른 코스트센터 제어 (일괄적용 다이얼로그)
        $sment.DialogKOSTL_CONTROL = function(projk) {
            var KOSTLList = [];
            var F4Params = $u.f4Data.getCodeDataWithParams('KOSTL', {PROJK: projk});
            if (projk) {
                $.each(F4Params, function(_, data) {
                    KOSTLList.push(data['KOSTL']);
                });
                if (!$u.util.contains($u.get('KOSTL__DIALOG').getValue(), KOSTLList)) {
                    $u.get('KOSTL__DIALOG').setEmptyValue();
                }
            } else $u.get('PROJK_TXT__DIALOG').setEmptyValue();
        }

        // WBS에 따른 계정 제어 (헤더)
        $sment.HeaderKOSTL_CONTROL = function(projk, flag) {
            var KOSTLList = [];
            var F4Params = $u.f4Data.getCodeDataWithParams('KOSTL', {PROJK: projk});
            if (projk) {
                $.each(F4Params, function(_, data) {
                    KOSTLList.push(data['KOSTL']);
                });

                var $kostl = $u.get('KOSTL__DIALOG');
                if (flag === 'X') { // 법인카드 대량
                    if (!$u.util.contains($kostl.getValue(), KOSTLList)) $kostl.setEmptyValue();
                } else if (flag === 'Y') { // 예산관리
                    $kostl = $u.get('ZKOSTL_F');
                    if (!$u.util.contains($kostl.getValue(), KOSTLList)) $kostl.setEmptyValue();
                }
            } else {
                if (flag === 'X') { // 법인카드 대량
                    $u.get('PROJK__DIALOG').setEmptyValue();
                    $u.get('PROJK_TXT__DIALOG').setEmptyValue();
                } else if (flag === 'Y') { // 예산관리
                    $u.get('ZPSPNR_F').setEmptyValue();
                    $u.get('ZPSPNR_F_TXT').setEmptyValue();
                }
            }
        }

        // WBS에 따른 코스트센터 제어 (그리드)
        $sment.gridKOSTL_CONTROL = function(projk, rowIndex) {
            var gridObj = $u.gridWrapper.getGrid();
            let kostlData = gridObj.$V('KOSTL', rowIndex);

            if(kostlData){
                var F4Params = $u.f4Data.getCodeDataWithParams('KOSTL', {PROJK: projk, KOSTL : kostlData});
                if (projk) {
                    if (F4Params.length < 1) {
                        gridObj.$V('KOSTL', rowIndex, '');
                        gridObj.$V('KOSTL_TXT', rowIndex, '');
                    }
                } else gridObj.$V('PROJK_TXT', rowIndex, '');
            }
        }

        // 예산 관리 - 날짜 범위
        $sment.minusMonth = function(offset) {
            var date = $u.util.date._parseDate($u.util.date.getCurrentDateAsDataFormat());
            date.setMonth(date.getMonth() - offset);
            return $u.util.date.getDateAsDataFormat(date);
        }

        // 공급업체에 따른 지급계좌 입력
        $sment.comboInputBVTYP = function() {
            var $bvtyp = $u.get('BVTYP');
            if ($bvtyp) {
                if ($bvtyp['params']['options'].length === 1) $bvtyp.setValue($bvtyp['params']['options'][0]['BVTYP']);
                else $bvtyp.setEmptyValue();
            }
        };

        // 그룹웨어 창 호출
        $sment.openApprovalPopup = function (o_url) {
            try {
                var popup = $u.popup.openPopup(o_url, 'eaccounting',1650, 1200);
                $efi.UD_0302_000EventHandler.handleApprovalPopupClose(popup);
            } catch (e) {
                if (/액세스가 거부되었습니다/.test(e.message)) throw $mls.getByCode('M_UD_0302_000_approvalPopupAccessError');
                else throw e;
            }
        };

        // 헤더영역 - 금액 입력 시 numberformat 적용
        $sment.NumberFormatKeyup = function() {
            $.each(['WMWST', 'WRBTR', 'EXPENSE'], function(_, item) {
                if ($u.get(item)) {
                    $u.get(item).$el.keyup(function () {
                        var waers = $u.get('WAERS');
                        if (waers && waers.getValue() === 'KRW') $u.get(item).setValue(
                            $u.unidocuCurrency.getFormattedValue(waers.getValue(), $u.get(item).getValue())
                        );
                    });
                }
            });
        }

        // GL대체(의상비) 필수체크
        $sment.validateCellRequired = function(rowIndex) {
            if (!/^UD_SM_3000$/.test($u.page.getPROGRAM_ID())) return;
            var gridObj = $u.gridWrapper.getGrid();
            var colums = ['CST_NUM', 'CST_BUY_DATE', 'CST_BRAND_NAME', 'CST_ITEM_NAME', 'CST_ITEM_CODE', 'CST_WEAR', 'PARTNER'];
            $.each(colums, function(_, item) {
                if (gridObj.isCellEditable(item, rowIndex)) gridObj.validateCellRequired(item, rowIndex);
            });
        }

        $sment.isTypeCode0104 = function () {
            return /^UD_0201_011B$/.test($u.page.getPROGRAM_ID()) && /^0104$/.test($u.page.getPageParams()['TYPE_CODE']);
        }

        // KRW 선택시 소수점 삭제함
        $sment.removeDecimalPlaces = function (rowIndex) {
            if ($u.util.contains($u.page.getPROGRAM_ID(), ['UD_0202_021', 'UD_0202_021_2', 'UD_0208_021', 'UD_SM_6000']) && $u.get('WAERS').getValue() === 'KRW'){
                var gridObj = $u.gridWrapper.getGrid();
                var wrbtr = gridObj.$V('WRBTR', rowIndex);
                gridObj.$V('WRBTR', rowIndex, Number(wrbtr).toFixed(0));
            }
        }

        // 전표처리 리스트 팝업창 출력
        $sment.popupOpenBELNR_TXTList = function (paramMap) {

            var I_INV_SEQ = paramMap.INV_SEQ;
            //it_data_nsReturn => 오류
            $nst.is_data_ot_data('ZUNIEFI_U805', {I_INV_SEQ: I_INV_SEQ}, function (OT_DATA) {
                var template = '';
                template += '<div>';
                template += '<div id="dialog-BELNR-List" class="unidocu-grid" data-sub-id="GRIDHEADER" data-sub-group="UD_0601_030_BELNR_TXT_List" style="height: 300px; margin: 10px 0;"></div>';
                template += '</div>';

                var $dialog = $(template);
                $u.renderUIComponents($dialog);

                $u.baseDialog.openModalDialog($dialog, {
                    subGroup: 'UD_0601_030_BELNR_TXT_List',
                    title: '전표 리스트',
                    width: 440,
                    draggable: true,
                });

                var dialogGrid =  $u.gridWrapper.getGrid('dialog-BELNR-List');
                dialogGrid.setJSONData(OT_DATA);

                // 전표번호 클릭 시
                dialogGrid.onCellClick(function (columnKey, rowIndex) {
                    if (columnKey === 'BELNR') {
                        paramMap.BELNR = dialogGrid.$V('BELNR',rowIndex);
                        $efi.popup.openStatementViewWithParamMap(paramMap);
                    }
                });
            });
        }

        $sment.setGridExcelUpload = function(rowIndex, data, otdata) {
            const setArr = ['HKONT', 'KOSTL'];
            let gridObj = $u.gridWrapper.getGrid();

            let wbsData;
            if (otdata.length) wbsData = otdata.find(item => {return item['POSID'] === data.PROJK});

            if(wbsData){
                gridObj.$V('PROJK', rowIndex, wbsData['POSID']);
                gridObj.$V('PROJK_TXT', rowIndex, wbsData['POST2'] + ' \/ ' + wbsData['POST1']);
            }else{
                gridObj.$V('PROJK', rowIndex, '');
                gridObj.$V('PROJK_TXT', rowIndex, '');
            }

            const projk = data.PROJK;

            for(let i = 0; i < setArr.length; i++){
                if(data[setArr[i]] !== ''){
                    const key = setArr[i];
                    const keyTxt = setArr[i] + '_TXT';
                    let param = {};
                    param[key] = data[setArr[i]];
                    param['PROJK'] = projk;
                    let f4Data = $sment.getCodeDataWithParams(setArr[i], param);
                    if (projk) {
                        if (f4Data.length < 1) {
                            gridObj.$V(key, rowIndex, '');
                            gridObj.$V(keyTxt, rowIndex, '');
                        }else{
                            const value = f4Data[0];
                            gridObj.$V(key, rowIndex, value[key]);
                            gridObj.$V(keyTxt, rowIndex, value[keyTxt]);
                        }

                        if(setArr[i] === 'HKONT' && $u.page.getPROGRAM_ID() === 'UD_SM_3000'){
                            ['CST_NUM', 'PARTNER'].map((item) => {
                                if (f4Data[0] && f4Data[0].WEB_EVENT === 'X') {
                                    gridObj.makeCellEditable(item, rowIndex);
                                    gridObj.setCellBgColor(item, rowIndex, '255|252|209');
                                    gridObj.makeCellRequired(item, rowIndex);
                                    gridObj.$V('CST_NUM', rowIndex, data['CST_NUM']);
                                } else {
                                    gridObj.makeCellReadOnly(item, rowIndex);
                                    gridObj.$V(item, rowIndex, '');
                                }
                            });
                            $u.buttons.runCustomHandler('CST_NUM_CONTROL', 'CST_NUM', rowIndex);
                        }
                    }

                    if(f4Data.length > 1 && setArr[i] === 'HKONT'){
                        $sment.setVATFromHKONTFlag(rowIndex, f4Data[0]);
                    }
                }
            }
        }

        $sment.makeArtistData = function (gridData) {
            var gridObj = $u.gridWrapper.getGrid();
            $.each(gridData, function(index, item) {
                if (item['AGCOD'].split(',').length > 1 || item['AUCOD'].split(',').length > 1) {
                    gridObj.clearGridData();
                    throw '아티스트 그룹/유닛이 2개 이상인 데이터가 존재합니다.\n 엑셀 파일을 확인하세요.';
                }
                var artistList = [];
                var agcod = (item['AGCOD'] && item['AGCOD'].trim()) ? item['AGCOD'].split(',') : '';
                var agnam = (item['AGNAM'] && item['AGNAM'].trim()) ? item['AGNAM'].split(',') : '';
                var aucod = (item['AUCOD'] && item['AUCOD'].trim()) ? item['AUCOD'].split(',') : '';
                var acnam = (item['AUNAM'] && item['AUNAM'].trim()) ? item['AUNAM'].split(',') : '';
                var atcod = (item['ATCOD'] && item['ATCOD'].trim()) ? item['ATCOD'].split(',') : '';
                var atnam = (item['ATNAM'] && item['ATNAM'].trim()) ? item['ATNAM'].split(',') : '';

                if (atcod.length === 0) {
                    artistList.push({AGCOD: agcod[0], AGNAM: agnam[0], AUCOD: aucod[0], AUNAM: acnam[0], ATCOD: atcod[0], ATNAM: atnam[0]});
                } else {
                    for (var i = 0; i < atcod.length; i++) {
                        artistList.push({AGCOD: agcod[0], AGNAM: agnam[0], AUCOD: aucod[0], AUNAM: acnam[0], ATCOD: atcod[i], ATNAM: atnam[i]});
                    }
                }
                if (gridObj.getGridHeader('ARTISTDATA')) {
                    const jsonArtistList = JSON.stringify(artistList);
                    const artistListData = jsonArtistList === '[{}]' ? '[]' : jsonArtistList;
                    gridObj.$V('ARTISTDATA', index, artistListData);
                }
            });
        }

        $sment.UD_0302_000_validate_form = function() {
            let selectedGFLAG = $u.gridWrapper.getGrid().getSELECTEDJSONData().map(item => item.GFLAG);
            console.debug("selectedGFLAG", selectedGFLAG);
            if(selectedGFLAG.length > 0 && new Set(selectedGFLAG).size !== 1){
                throw '[그룹 선택 실패] 동일한 양식의 전표로만 함께 선택 가능 합니다.';
            }
        }


        $sment.setCodeMTaxType = function() {
            if($u.get('MWSKZ') && $u.get('MWSKZ').getValue() && $u.get('CODE_M')){
                const taxType = $u.f4Data.getCodeMapWithParams('MWSKZ', 'TAX_TYPE', $efi.f4.getParameter());
                const taxTypeChk = taxType[$u.get('MWSKZ').getValue()] === 'N';
                console.debug("taxType", taxType);
                if(taxType[$u.get('MWSKZ').getValue()]){
                    $u.get('CODE_M').setReadOnly(!taxTypeChk);
                    $u.get('CODE_M').setRequired(taxTypeChk);
                    if(!taxTypeChk) {
                        $u.get('CODE_M').setValue('');
                    }
                }
            }
        }

        $sment.setSTCD2WithLIFNR = function(rowIndex, lifnr) {
            if(!lifnr) return;
            let f4_lifnr = $sment.getCodeDataWithParams('LIFNR', {LIFNR : lifnr});
            let gridObj = $u.gridWrapper.getGrid();

            if(f4_lifnr && f4_lifnr.length > 0){
                gridObj.$V('STCD2', rowIndex, f4_lifnr[0].STCD2);
            }
        }

        $sment.sendMailAPI = function(url, data) {
            $u.progressBar.show();
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                },
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(data => {
                    console.debug('서버 응답:', data);
                    unidocuAlert('메일 발송이 완료되었습니다.');
                    $u.progressBar.hide();
                })
                .catch(error => {
                    unidocuAlert('메일 발송이 실패하였습니다.');
                    console.error('오류 발생:', error);
                    $u.progressBar.hide();
                });
        }

        /**
         * ARTISTDATA 의 [] 값만 처리 하던 로직에서
         * ARTISTDATA 값의 NAM 필드가 비어있을 경우 Throw 처리를 추가함
         */
        $sment.validateEmptyArray_ARTISTDATA  = function (gridObj) {
            if (!gridObj.getGridHeader('ARTISTDATA')) return;

            let gridRowIndexes = Array.from({ length: gridObj.getRowCount() }, (_, i) => i);
            if ($u.page.getPROGRAM_ID() === 'UD_0201_000C') gridRowIndexes = gridObj.getSelectedRowIndexes();

            gridRowIndexes.forEach(rowIndex => {
                const currentARTISTDATA = gridObj.$V('ARTISTDATA', rowIndex);
                if (!currentARTISTDATA) return;
                if (currentARTISTDATA === '[]') gridObj.$V('ARTISTDATA', rowIndex, '');
                else {
                    const artistDataArr = JSON.parse(currentARTISTDATA);
                    artistDataArr.forEach(item => {
                        for (const key in item) {
                            if (key.includes('NAM') && !item[key]) throw `${rowIndex +1} 번째 행의 아티스트 명이 정상적이지 않습니다. <br> 확인 바랍니다.`;
                        }
                    });
                }
            });
        };

        $sment.check_kostlFlag = (rowIndex) => {
            var programId = $u.page.getPROGRAM_ID();
            if (!$u.util.contains(programId, ['UD_0230_001'])) return;

            var gridObj = $u.gridWrapper.getGrid();
            var hkont = gridObj.$V('HKONT', rowIndex);
            var hkontCodeData = $u.f4Data.getCodeDataWithParams('HKONT', {HKONT: hkont})[0];
            var kostlFlag = hkontCodeData && hkontCodeData['KOSTL_FLAG'] === 'X';

            if (kostlFlag) {
                gridObj.$V('KOSTL', rowIndex, '');
                gridObj.$V('KOSTL_TXT', rowIndex, '');
                gridObj.triggerChangeCell('KOSTL', rowIndex);
                gridObj.makeCellReadOnly('KOSTL', rowIndex);
            } else {
                gridObj.makeCellEditable('KOSTL', rowIndex);
            }
        };
        /** 계정코드 선택 시
         * 계정코드 내 OT_DATA-F0005 세금코드가 있는 경우, 해당 세금코드로 헤더/비용라인 과세구분 설정
         * 단, 비용라인에 불공제(V2)가 하나라도 있을 경우 과세구분 V2 고정
         * */
        $sment.setMWSKZ_By_HKONT_F4 = (rowIndex, jsonObj) => {
            const PROGRAM_ID = $u.page.getPROGRAM_ID();
            const PAGE_PARAMS = $u.page.getPageParams();

            if (PROGRAM_ID !== 'UD_0201_001') return;
            if (Number($u.get('BUDAT').getValue()) < 20250401 || Number($u.get('BLDAT').getValue()) < 20250401) return;
            if (PAGE_PARAMS['E_FLAG'] === 'X') return;
            if (Number(PAGE_PARAMS['TAX']) === 0) return;

            const gridObj = $u.gridWrapper.getGrid();

            let hasV2 = false;
            let mwskz_f0005 = '';

            if (jsonObj && jsonObj['MWSKZ']) {
                gridObj.$V('F0005', rowIndex, jsonObj['MWSKZ']);
                gridObj.$V('MWSKZ', rowIndex, jsonObj['MWSKZ']);
            } else if (gridObj.$V('HKONT', rowIndex) === '') {
                gridObj.$V('F0005', rowIndex, '');
                gridObj.$V('MWSKZ', rowIndex, '');
            } else {
                gridObj.$V('F0005', rowIndex, '');
                gridObj.$V('MWSKZ', rowIndex, PAGE_PARAMS['MWSKZ']);
            }

            const GET_JSON_DATA = gridObj.getJSONData();

            for (let i = 0; i < GET_JSON_DATA.length; i++) {
                if (GET_JSON_DATA[i]['HKONT'] === '') {
                    continue;
                } else if (GET_JSON_DATA[i]['F0005'] === 'V2') {
                    hasV2 = true;
                } else if (GET_JSON_DATA[i]['F0005']) {
                    mwskz_f0005 = GET_JSON_DATA[i]['F0005'];
                }
            }

            if (hasV2) $u.get('MWSKZ').setValue('V2');
            else if (mwskz_f0005) $u.get('MWSKZ').setValue(mwskz_f0005);
            else $u.get('MWSKZ').setValue(PAGE_PARAMS['MWSKZ']);

            const MWSKZ = $u.get('MWSKZ').getValue();

            for (let i = 0; i < GET_JSON_DATA.length; i++) {
                gridObj.$V('MWSKZ', i, MWSKZ);
            }

            $u.get('MWSKZ').triggerChange();
        }

        $sment.deleteRow_setMWSKZ_By_HKONT_F4 = () => {
            const PROGRAM_ID = $u.page.getPROGRAM_ID();
            const PAGE_PARAMS = $u.page.getPageParams();

            if (PROGRAM_ID !== 'UD_0201_001') return;
            if (Number($u.get('BUDAT').getValue()) < 20250401 || Number($u.get('BLDAT').getValue()) < 20250401) return;
            if (PAGE_PARAMS['E_FLAG'] === 'X') return;
            if (Number(PAGE_PARAMS['TAX']) === 0) return;

            const gridObj = $u.gridWrapper.getGrid();

            let hasV2 = false;
            let mwskz_f0005 = '';

            const GET_JSON_DATA = gridObj.getJSONData();

            for (let i = 0; i < GET_JSON_DATA.length; i++) {
                if (GET_JSON_DATA[i]['HKONT'] === '') {
                    continue;
                } else if (GET_JSON_DATA[i]['F0005'] === 'V2') {
                    hasV2 = true;
                } else if (GET_JSON_DATA[i]['F0005']) {
                    mwskz_f0005 = GET_JSON_DATA[i]['F0005'];
                }
            }

            if (hasV2) $u.get('MWSKZ').setValue('V2');
            else if (mwskz_f0005) $u.get('MWSKZ').setValue(mwskz_f0005);
            else $u.get('MWSKZ').setValue(PAGE_PARAMS['MWSKZ']);

            const MWSKZ = $u.get('MWSKZ').getValue();

            for (let i = 0; i < GET_JSON_DATA.length; i++) {
                gridObj.$V('MWSKZ', i, MWSKZ);
            }

            $u.get('MWSKZ').triggerChange();
        }

        /** 메뉴: 고객-거래처(***)
         * 엑셀 업로드 시, 컬럼 체크 => triggerChangeCell(); */
        $sment.checkColumns_addCopyRows_OR_excelupload = (index, data, excelUpload) => {
            const PROGRAM_ID = $u.page.getPROGRAM_ID();
            const PROGRAMID_SPECIAL = ['UD_0202_021Z', 'UD_0202_021Z_1', 'UD_0202_021Y', 'UD_0202_021Y_1'];
            const FIELDS = ['KUNNR', 'LIFNR', 'HKONT'];
            const RESET_FIELDS = ['KUNNR', 'KUNNR_TXT', 'LIFNR', 'LIFNR_TXT', 'HKONT', 'HKONT_TXT'];
            if (!$u.util.contains(PROGRAM_ID, PROGRAMID_SPECIAL)) return data;

            const gridObj = $u.gridWrapper.getGrid();
            const fieldKeys_K_L_H = FIELDS.filter(key => data[key] !== '' && data[key] !== undefined);
            const fieldKeys_A_S = ['AKONT', 'SPECIAL'].filter(key => key === 'SPECIAL' ? data[key] === '1' : data[key] !== '' && data[key] !== undefined);

            if (fieldKeys_K_L_H.length === 1) {
                gridObj.triggerChangeCell(fieldKeys_K_L_H[0], index);
                if (fieldKeys_A_S.length === 1) {
                    if (fieldKeys_A_S[0] === 'SPECIAL') {
                        gridObj.triggerChangeCell(fieldKeys_A_S[0], index);
                    }
                    if (fieldKeys_A_S[0] === 'AKONT') {
                        gridObj._rg.setValues(index, {AKONT: data[fieldKeys_A_S[0]]});
                        gridObj.triggerChangeCell(fieldKeys_A_S[0], index);
                    }
                } else if (fieldKeys_A_S.length === 2) {
                    gridObj._rg.setValues(index, {AKONT: ''});
                    gridObj.$V('SPECIAL', index, 0);
                    gridObj.triggerChangeCell('SPECIAL', index);
                }
                if (fieldKeys_K_L_H[0] === 'HKONT') {
                    const xbilk = $u.f4Data.getCodeDataWithParams('HKONT', {HKONT: gridObj.$V('HKONT', index)})[0]['XBILK'];
                    $sment.fieldsByGLStatus('HKONT', index, {XBILK: xbilk});
                }
            } else {
                if (excelUpload) {
                    for (let i = 0; i < RESET_FIELDS.length; i++) {
                        data[RESET_FIELDS[i]] = '';
                        gridObj.$V(RESET_FIELDS[i], index, '');
                    }
                    gridObj._rg.setValues(index, {AKONT: ''});
                    gridObj.$V('SPECIAL', index, '0');
                }
            }

            if (excelUpload) {
                gridObj.setCellFocus('HKONT',0);
                gridObj.triggerCellClick('AKONT', 0);
                return data;
            }

        }

        /** 임시전표 수정 공통 이벤트 핸들링 - 법카 단건, 전자(세금)계산서, 종이세금계산서, 마이너스전표, 계정대체, 기타매출 */
        $sment.setEditPage_bstatIsV = (callBack) => {
            const PAGE_PARAMS = $u.page.getPageParams();
            if (!PAGE_PARAMS['isEditStatement']) return;

            const {editGridData} = PAGE_PARAMS;
            const EVI_SEQ = PAGE_PARAMS['EVI_SEQ']; // 첨부파일
            const gridObj = $u.gridWrapper.getGrid();

            $u.setPageTitle(`${$u.getPageTitle()} (수정)`);

            // 증빙정보 증빙링크
            $("#statement-information-content img").remove();
            if ($u.get('APPR_NO')) $u.get('APPR_NO').$el.append($efi.get$evidenceIcon({CRD_SEQ : PAGE_PARAMS['CRD_SEQ']}));
            if ($u.get('ISSUE_ID')) $u.get('ISSUE_ID').$el.append($efi.get$evidenceIcon({INV_SEQ : PAGE_PARAMS['INV_SEQ']}));

            //첨부파일 로드
            if (EVI_SEQ) $u.fileUI.load(EVI_SEQ);

            //헤더 셋팅
            const GET_VALUES = $u.getValues();
            for (let key in GET_VALUES) {
                if (!$u.get(key)) continue;
                if (PAGE_PARAMS[key]) {
                    if ($u.get(key).params.type === 'Uni_CodePopup') $u.get(key).setValue({code: PAGE_PARAMS[key], text: PAGE_PARAMS[key+`_TXT`]});
                    else $u.get(key).setValue(PAGE_PARAMS[key]);
                }
            }

            //헤더 불공사유 readOnly 처리
            $sment.setCodeMTaxType();

            //[마이너스 전표] 버튼 숨김처리
            $('#minusCreateStatement').hide();

            //지급조건 클리어(sap에서 빈 값으로 뿌려줌)
            if ($u.get('ZTERM')) $efi.createStatement.bindEvent.onZTERM_BUDATChange();

            // 거래처, 고객에 따른 콤보값 셋팅
            if ($u.get('AKONT') && $u.get('LIFNR')) setVendorCodeChange('LIFNR', 'AKONT');
            if ($u.get('AKONT') && $u.get('KUNNR')) setVendorCodeChange('KUNNR', 'AKONT');
            if ($u.get('BVTYP') && $u.get('LIFNR')) setVendorCodeChange('LIFNR', 'BVTYP');

            function setVendorCodeChange(vendorCodeKey, setCodeKey) {
                const comboCodeQueryParams = {};
                comboCodeQueryParams[vendorCodeKey] = PAGE_PARAMS[vendorCodeKey];
                $u.get(setCodeKey).setOptions($u.f4Data.getCodeComboOption($u.get(setCodeKey).params['codeKey'], comboCodeQueryParams));
                $u.get(setCodeKey).setValue(PAGE_PARAMS[setCodeKey]);
            }

            //거래처 getDialogRowData 셋팅
            if ($u.get('LIFNR') && PAGE_PARAMS['LIFNR']) {
                const LIFNR_DialogRowData = $u.f4Data.getCodeDataWithParams('LIFNR', {LIFNR: PAGE_PARAMS['LIFNR']})[0];
                $u.get('LIFNR').$el.find('input').data('dialogRowData', LIFNR_DialogRowData);

                if ($u.get('WT_WITHCD') && LIFNR_DialogRowData && LIFNR_DialogRowData['WITHT'] === 'X') {
                    $u.get('WT_WITHCD').setReadOnly(false);
                }
            }

            gridObj.setJSONData(editGridData);
            gridObj.fitToWindowSize();

            //비용라인 셋팅(아티스트데이터, 추가데이터, 거래처필드활성화)
            $sment.setGrid_ARTISTDATA_ADD_DATA(editGridData, true);
            //차액, 차변합계, 대변합계
            $efi.createStatementCommon.changeWRBTRExpense('WRBTR');

            // 지급금액 계산
            if ($u.get('SWSTE') && $u.get('JWSTE')) {
                $u.page.setCustomParam('SWSTE', $u.get('SWSTE').getValue());
                $u.page.setCustomParam('JWSTE', $u.get('JWSTE').getValue());
            }
            $sment.CalculateWRBTR_PAY();

            $u.page.setCustomParam('finishEditScreenSetup', true);

            if (callBack) callBack();
        }

        /** 임시전표 수정 공통 이벤트 핸들링 - 법인카드 대량 */
        $sment.setEditPage_bstatIsV_LIST = (callBack) => {
            const PAGE_PARAMS = $u.page.getPageParams();
            const mwskzList = [];

            if (!PAGE_PARAMS['isEditStatement']) return mwskzList;

            const {editGridData} = PAGE_PARAMS;
            const gridObj = $u.gridWrapper.getGrid();

            $u.setPageTitle(`${$u.getPageTitle()} (수정)`);

            //[법인카드 대량] search-condition readOnly 처리
            const GET_VALUES = $u.getValues();
            if ($u.page.getPROGRAM_ID() === 'UD_0201_000C') {
                for (let key in GET_VALUES) {
                    if (!$u.get(key)) continue;
                    $u.get(key).setValue('');
                    $u.get(key).setReadOnly(true);
                }
            }
            $('#search-condition').find('.panel-search-button').hide();
            $('#search-condition').find('.panel-search-init-button').hide();

            gridObj.setJSONData(editGridData);
            gridObj.fitToWindowSize();

            /** 우선순위 낮은 거부터 조건문 셋팅*/
            $.each(editGridData, function (index, item) {
                gridObj.$V('MWSKZ_DEFAULT', index, item['MWSKZ']);

                if (item['F0005']) gridObj.$V('MWSKZ', index, item['F0005']);

                if (item['E_FLAG'] === 'X') {
                    gridObj.$V('MWSKZ', index, 'V2');
                    gridObj.$V('MWSKZ_DEFAULT', index, 'V2');
                }

                if (Number(item['BUDAT'].replace(/-/g, '')) < 20250401 || Number(item['APPR_DATE'].replace(/-/g, '')) < 20250401) {
                    if (Number(item['TAX']) === 0) {
                        gridObj.$V('MWSKZ', index, 'V3');
                    } else {
                        gridObj.$V('MWSKZ', index, 'V2');
                    }
                }

                gridObj.$V('_EVI_SEQ', index, '/images/btn/btn_view.gif');
                gridObj.$V('TAX_READ_ONLY', index, item['TAX']);

                mwskzList.push(item['MWSKZ']);
            });

            //비용라인 셋팅
            $sment.setGrid_ARTISTDATA_ADD_DATA(editGridData, true);

            $u.page.setCustomParam('finishEditScreenSetup', true);

            if (callBack) callBack();

            return mwskzList;
        }

        /** 비용항목 라인 ARTISTDATA/ADD_DATA 셋팅, 거래처 필드 제어 */
        $sment.setGrid_ARTISTDATA_ADD_DATA = (editGridData, isEditStatement) => {
            const gridObj = $u.gridWrapper.getGrid();

            for (let i = 0; i < editGridData.length; i++) {
                //ARTISTDATA 셋팅
                if (editGridData[i]['ATI_TARGET']) {
                    const ATCOD_ARRAY = editGridData[i]['ATCOD'].split(',');
                    const ATNAM_ARRAY = editGridData[i]['ATNAM'].split(',');
                    const AUCOD_ARRAY = editGridData[i]['AUCOD'].split(',');
                    const AGCOD_ARRAY = editGridData[i]['AGCOD'].split(',');
                    const AUNAM_ARRAY = editGridData[i]['AUNAM'].split(',');
                    const AGNAM_ARRAY = editGridData[i]['AGNAM'].split(',');

                    const setArtistdata = [];

                    for (let j = 0; j < ATCOD_ARRAY.length; j++) {
                        const mergeData = {
                            SELECTED: "0",
                            BUKRS: staticProperties['user']['BUKRS'],
                            ATCOD: ATCOD_ARRAY[j],
                            ATNAM: ATNAM_ARRAY[j],
                            AUCOD: AUCOD_ARRAY[j],
                            AGCOD: AGCOD_ARRAY[j],
                            AUNAM: AUNAM_ARRAY[j],
                            AGNAM: AGNAM_ARRAY[j],
                        };
                        setArtistdata.push(mergeData);
                    }
                    gridObj.$V('ARTISTDATA', i, JSON.stringify(setArtistdata));
                }

                //ADD_DATA 셋팅
                if (editGridData[i]['ADD_DATA_JSON']) {
                    const ADD_DATA_JSON = JSON.parse('[' + editGridData[i]['ADD_DATA_JSON'] + ']');
                    const ADD_DATA__HIDDNE = {};

                    for (let j = 0; j < ADD_DATA_JSON.length; j++) {
                        ADD_DATA__HIDDNE[ADD_DATA_JSON[j]['KEY']] = ADD_DATA_JSON[j]['VALUE'];
                        if (ADD_DATA_JSON[j]['VALUE_TEXT']) ADD_DATA__HIDDNE[ADD_DATA_JSON[j]['KEY']+'_TXT'] = ADD_DATA_JSON[j]['VALUE_TEXT'];
                    }

                    gridObj.$H('ADD_DATA', i, JSON.stringify(ADD_DATA__HIDDNE));
                }

                //GL계정에 따른 거래처 필드 활성화 제어
                if (isEditStatement && $sment.useAccountSubstitutionProgramId()) {
                    for (let i = 0; i < editGridData.length; i++) {
                        const PARAMS = $u.f4Data.getCodeDataWithParams('HKONT', {HKONT: editGridData[i]['HKONT']});
                        if (PARAMS.length) {
                            const GLTYPE = PARAMS[0]['GLTYPE'];
                            if (GLTYPE === 'X') {
                                gridObj.makeCellReadOnly('LIFNR', i);
                                gridObj.$V('LIFNR', i, '');
                                gridObj.$V('LIFNR_TXT', i, '');
                            }
                        }
                    }
                }

            }
        }

        $sment.fieldsByGLStatus = (columnKey, rowIndex, jsonObj) => {
            const REQUIRED_FIELD = ['PROJK', 'AUFNR', 'ATI_TARGET', 'ATI_CATEG'];
            const EDITABLE_FIELD = ['KOSTL'];
            const READONLY_FIELD = ['PROJK', 'AUFNR', 'KOSTL', 'ATI_TARGET', 'ATI_CATEG'];
            const EMPTY_FIELD = ['PROJK', 'PROJK_TXT', 'AUFNR', 'AUFNR_TXT', 'KOSTL', 'KOSTL_TXT', 'ATI_TARGET', 'AGCOD', 'AGNAM', 'AUCOD', 'AUNAM', 'ATCOD', 'ATNAM', 'ARTISTDATA', 'ATI_CATEG', 'ATI_CATEG_TXT'];
            const gridObj = $u.gridWrapper.getGrid();

            if (columnKey === 'KUNNR') { //비활성화
                for (var i = 0; i < EMPTY_FIELD.length; i++) {
                    gridObj.$V(EMPTY_FIELD[i], rowIndex, '');
                }
                for (var i = 0; i < READONLY_FIELD.length; i++) {
                    gridObj.makeCellReadOnly(READONLY_FIELD[i], rowIndex);
                }
                gridObj.$V('MWSKZ', rowIndex, 'AA');
                gridObj.triggerChangeCell('MWSKZ', rowIndex);
            } else if (columnKey === 'LIFNR') { //비활성화
                for (var i = 0; i < EMPTY_FIELD.length; i++) {
                    gridObj.$V(EMPTY_FIELD[i], rowIndex, '');
                }
                for (var i = 0; i < READONLY_FIELD.length; i++) {
                    gridObj.makeCellReadOnly(READONLY_FIELD[i], rowIndex);
                }
                gridObj.$V('MWSKZ', rowIndex, 'VV');
                gridObj.triggerChangeCell('MWSKZ', rowIndex);
            } else if (columnKey === 'HKONT') { //활성화
                for (var i = 0; i < REQUIRED_FIELD.length; i++) {
                    gridObj.makeCellRequired(REQUIRED_FIELD[i], rowIndex);
                }
                for (var i = 0; i < EDITABLE_FIELD.length; i++) {
                    gridObj.makeCellEditable(EDITABLE_FIELD[i], rowIndex);
                }

                //대차대조표 계정일 경우 WBS, 내부오더 필수해제
                if (jsonObj && jsonObj['XBILK'] === 'X') {
                    gridObj.makeCellEditable('PROJK', rowIndex);
                    gridObj.makeCellEditable('AUFNR', rowIndex);
                }
            }

        }

        $sment.prepareWbsSplitDialog = () => {
            const gridObj = $u.gridWrapper.getGrid();
            gridObj.asserts.selectedExactOneRow();

            const GRID_DATA = gridObj.getSELECTEDJSONData()[0];
            const PROJK = GRID_DATA['PROJK'];
            const WRBTR = GRID_DATA['WRBTR'];
            if (!PROJK) throw $mls.getByCode('M_wbsIsEmpty');
            if (!WRBTR || WRBTR === '0') throw $mls.getByCode('M_wrbtrIsEmpty');

            $nst.is_data_nsReturn('ZUNIEFI_U1700', {POSID: PROJK}, function (ZUNIEFI_U1700_nsReturn) {

                const ZUNIEFI_U1700_nsReturn_OT_DATA = ZUNIEFI_U1700_nsReturn.getTableReturns()['OT_DATA'];
                const ZUNIEFI_U1700_nsReturn_returnType = ZUNIEFI_U1700_nsReturn.getReturnType();
                const ZUNIEFI_U1700_nsReturn_O_TEXT = ZUNIEFI_U1700_nsReturn.getStringReturns()['O_TEXT'];

                if (ZUNIEFI_U1700_nsReturn_returnType === 'E') return;

                let templateString = '';
                templateString += '<div>';
                templateString += '<div id="prepareWbsSplitDialog-grid" class="unidocu-grid" data-sub-id="GRIDHEADER" data-sub-group="prepareWbsSplitDialog" style="height: 340px; margin: 10px 0;"></div>';
                templateString += '</div>';
                let $dialog = $(templateString);
                $u.renderUIComponents($dialog);

                const dialogGrid = $u.gridWrapper.getGrid('prepareWbsSplitDialog-grid');

                const dialogButtons = [
                    $u.baseDialog.getButton($mls.getByCode('DLB_cancel'), function () {
                        $dialog.dialog('close');
                    }),
                    $u.baseDialog.getButton($mls.getByCode('DLB_confirm'), function () {
                        dialogGrid.asserts.rowSelected();

                        $nst.tableParams_nsReturn('ZUNIEFI_U910', {IT_POSID: dialogGrid.getSELECTEDJSONData()}, function(nsReturn){
                            if (nsReturn.getReturnType() === 'E') return;

                            const ZUNIEFI_U910_OT_DATA = nsReturn.getTableReturns()['OT_DATA'];

                            $dialog.dialog("close");
                            $sment.wbsSplitDialog(WRBTR, ZUNIEFI_U910_OT_DATA);
                        })
                    }, 'unidocu-button dialogBlack')
                ];

                $u.baseDialog.openModalDialog($dialog, {
                    width: 1200,
                    title: "WBS 조회 ("+ZUNIEFI_U1700_nsReturn_O_TEXT+")",
                    draggable: true,
                    resizable: true,
                    buttons: dialogButtons,
                    close: function () {
                        $dialog.remove();
                    }
                });

                dialogGrid.setSortEnable(false);
                dialogGrid.setHeaderCheckBox('SELECTED', true);
                dialogGrid.setJSONData(ZUNIEFI_U1700_nsReturn_OT_DATA);
            })
        }

        $sment.wbsSplitDialog = (WRBTR, ZUNIEFI_U910_OT_DATA) => {
            const gridObj = $u.gridWrapper.getGrid();
            const wrbtr = Number(WRBTR);

            let templateString = '';
            templateString += '<div>';
            templateString += '<div id="wbsSplitDialog-buttons" class="btn_area uni-form-table-button-area"></div>';
            templateString += '<div id="wbsSplitDialog-grid" class="unidocu-grid" data-sub-id="GRIDHEADER" data-sub-group="wbsSplitDialog" style="height: 340px; margin: 10px 0;"></div>';
            templateString += '</div>';
            let $dialog = $(templateString);
            $u.renderUIComponents($dialog);

            const dialogGrid = $u.gridWrapper.getGrid('wbsSplitDialog-grid');

            const dialogButtons = [
                $u.baseDialog.getButton($mls.getByCode('DLB_cancel'), function () {
                    $dialog.dialog('close');
                }),
                $u.baseDialog.getButton($mls.getByCode('DLB_confirm'), function () {
                    dialogGrid.asserts.rowSelected();

                    const deleteRowIndex = gridObj.getSelectedRowIndexes()[0];
                    const dialogGrid_selectedData = dialogGrid.getSELECTEDJSONData();
                    let grid_selectedData = gridObj.getSELECTEDJSONData()[0];
                    let wrbtrSplitSum = 0;

                    for (let i = 0; i < dialogGrid_selectedData.length; i++) {
                        wrbtrSplitSum += Number(dialogGrid_selectedData[i]['WRBTR_SPLIT'].replace(/,/g, ''));
                        if (!dialogGrid_selectedData[i]['WRBTR_SPLIT']) throw $mls.getByCode('M_wrbtrSplit_EMPTY');
                    }

                    if (wrbtrSplitSum !== wrbtr) throw $mls.getByCode('M_wrbtrSplitSum_wrbtr_MISMATCH');

                    for (let i = 0; i < dialogGrid_selectedData.length; i++) {
                        grid_selectedData['PROJK'] = dialogGrid_selectedData[i]['POSID'];
                        grid_selectedData['PROJK_TXT'] = dialogGrid_selectedData[i]['POST1'];
                        grid_selectedData['WRBTR'] = dialogGrid_selectedData[i]['WRBTR_SPLIT'].replace(/,/g, '');

                        gridObj.addRowByJSONData(grid_selectedData);
                    }

                    gridObj.deleteRow(deleteRowIndex);

                    gridObj.triggerChangeCell('WRBTR', 0);

                    $dialog.dialog("close");
                }, 'unidocu-button dialogBlack')
            ];

            $u.baseDialog.openModalDialog($dialog, {
                width: 1200,
                title: "WBS 분할 (총금액: " + wrbtr.toLocaleString() + ")",
                draggable: true,
                resizable: true,
                buttons: dialogButtons,
                close: function () {
                    $dialog.remove();
                }
            });

            $u.buttons.addHandler({
                'SPLIT': function () {
                    const dialogGridData_length = dialogGrid.getRowCount()
                    const dialogGridData_selected = dialogGrid.getSELECTEDJSONData();
                    const dialogGridData_selected_index = dialogGrid.getSelectedRowIndexes();
                    let sum_Cntco = 0; //회차 합산
                    let max_Cntco = 0; //가장 큰 회차
                    let quotient = 0; //몫
                    let remainder = 0; //나머지
                    let isRemainder = true; //나머지 구분 값

                    //선택한 행들이 서로 동일한 회차인지 체크(동일 회차일 경우 true)
                    let isSameCNTNO = true;

                    //초기화
                    for (let i = 0; i < dialogGridData_length; i++) {
                        dialogGrid.$V('WRBTR_SPLIT', i, '');
                    }

                    if (dialogGridData_selected.length === 0) return;

                    //sum_Cntco(회차 합산), max_Cntco(가장 큰 회차) 셋팅
                    for (let i = 0; i < dialogGridData_selected.length; i++) {
                        const number_cntco = Number(dialogGridData_selected[i]['CNTCO']);
                        sum_Cntco += number_cntco;

                        if (number_cntco > max_Cntco) {
                            max_Cntco = number_cntco;
                        }

                        if (isSameCNTNO && dialogGridData_selected[0]['CNTCO'] !== dialogGridData_selected[i]['CNTCO']) {//선택한 행들이 서로 동일한 회차인지 체크
                            isSameCNTNO = false;
                        }
                    }

                    if (isSameCNTNO && 1 < dialogGridData_selected.length) {
                        quotient = Math.floor(wrbtr / dialogGridData_selected.length); //몫
                        remainder = wrbtr % dialogGridData_selected.length; //나머지

                        for (let i = 0; i < dialogGridData_selected_index.length; i++) {
                            dialogGrid.$V('WRBTR_SPLIT', dialogGridData_selected_index[i], quotient.toLocaleString());

                            if (i === 0) {
                                dialogGrid.$V('WRBTR_SPLIT', dialogGridData_selected_index[i], (quotient + remainder).toLocaleString());
                            }
                        }
                    } else {
                        quotient = Math.floor(wrbtr / sum_Cntco); //몫
                        remainder = wrbtr % sum_Cntco; //나머지

                        for (let i = 0; i < dialogGridData_selected_index.length; i++) {
                            const number_cntco = Number(dialogGrid.$V('CNTCO', dialogGridData_selected_index[i]));
                            const wrbtrSplit = number_cntco * quotient;
                            dialogGrid.$V('WRBTR_SPLIT', dialogGridData_selected_index[i], wrbtrSplit.toLocaleString());
                            if (isRemainder && number_cntco === max_Cntco) {
                                dialogGrid.$V('WRBTR_SPLIT', dialogGridData_selected_index[i], (wrbtrSplit + remainder).toLocaleString());
                                isRemainder = false;
                            }
                        }
                    }
                }
            });
            dialogGrid.setSortEnable(false);
            dialogGrid.setHeaderCheckBox('SELECTED', true);
            dialogGrid.setJSONData(ZUNIEFI_U910_OT_DATA);
        }

        // 비용라인 의상비 제어
        $sment.CST_NUM_CONTROL = (key, columnKey, rowIndex, jsonObj, flag) => {
            if (!$u.util.contains($u.page.getPROGRAM_ID(), ['UD_SM_5000', 'UD_SM_6000'])) return;

            const gridObj = $u.gridWrapper.getGrid();
            const COLUMS1 = ['CST_NUM', 'PARTNER'];
            const COLUMS2 = ['CST_BUY_DATE', 'CST_BRAND_NAME', 'CST_ITEM_NAME', 'CST_ITEM_CODE', 'CST_WEAR'];

            if (key === 'clothesHKONT') {
                for (let i = 0; i < COLUMS1.length; i++) {
                    if (jsonObj && jsonObj['WEB_EVENT'] === 'X') {
                        gridObj.makeCellEditable(COLUMS1[i], rowIndex);
                        gridObj.setCellBgColor(COLUMS1[i], rowIndex, '255|252|209');
                        gridObj.makeCellRequired(COLUMS1[i], rowIndex);
                        if (flag !== 'afterMultiCellChange') gridObj.$V('CST_NUM', rowIndex, 'N');
                    } else {
                        gridObj.makeCellReadOnly(COLUMS1[i], rowIndex);
                        gridObj.$V(COLUMS1[i], rowIndex, '');
                        gridObj.$V('PARTNER_TXT', rowIndex, '');
                    }
                }
            }

            for (let i = 0; i < COLUMS2.length; i++) {
                if (gridObj.$V('CST_NUM', rowIndex) === 'Y') {
                    gridObj.makeCellEditable(COLUMS2[i], rowIndex);
                    gridObj.setCellBgColor(COLUMS2[i], rowIndex, '255|252|209');
                    gridObj.makeCellRequired(COLUMS2[i], rowIndex);
                } else {
                    gridObj.makeCellReadOnly(COLUMS2[i], rowIndex);
                    gridObj.$V(COLUMS2[i], rowIndex, '');
                }
            }
        }


        $sment.ATI_TARGET_CLEAR = (rowIndex, flag) => {
            if (flag === 'afterMultiCellChange') return;
            const gridObj = $u.gridWrapper.getGrid();
            const ARTIST_COLUMNS = ['ATI_TARGET', 'AUCOD', 'AUNAM', 'ATCOD', 'ATNAM', 'ARTISTDATA'];
            for (let i = 0; i < ARTIST_COLUMNS.length; i++) {
                if (gridObj.getGridHeader(ARTIST_COLUMNS[i])) gridObj.$V(ARTIST_COLUMNS[i], rowIndex, '');
            }
        }

        $sment.setGrid_PARTNER_TXT = (rowIndex, data) => {
            if (!$sment.useCSTProgramId()) return;

            const gridObj = $u.gridWrapper.getGrid();
            if (gridObj.$V('PARTNER', rowIndex)) {
                const PARTNER_TXT = $u.f4Data.getCodeDataWithParams('LIFNR_ART', {LIFNR: data['PARTNER']})[0]['LIFNR_TXT'];
                gridObj.$V('PARTNER_TXT', rowIndex, PARTNER_TXT);
            } else {
                gridObj.$V('PARTNER_TXT', rowIndex, '');
            }
        }

        // 의상비 메뉴 >> 거래처 필드(계정대체 메뉴 한정), 의상비 필드 제어
        $sment.setGrid_HKONTbyGLTYPEorWEBEVENT = (rowIndex, data) => {
            if (!$sment.useCSTProgramId()) return;

            const gridObj = $u.gridWrapper.getGrid();
            const F4DATA = $sment.getCodeDataWithParams('HKONT', {HKONT: data['HKONT']});
            const EDITABLE_FIELDS = ['LIFNR'];
            const REQUIRED_FIELDS_1 = ['CST_NUM', 'PARTNER'];
            const REQUIRED_FIELDS_2 = ['CST_BUY_DATE', 'CST_BRAND_NAME', 'CST_ITEM_NAME', 'CST_ITEM_CODE', 'CST_WEAR'];
            const COMBINED_FIELDS = [...REQUIRED_FIELDS_1, ...REQUIRED_FIELDS_2];

            if (F4DATA && F4DATA.length) {
                if (F4DATA[0]['WEB_EVENT'] !== 'X') { //비활성화
                    for (let i = 0; i < COMBINED_FIELDS.length; i++) {
                        gridObj.makeCellReadOnly(COMBINED_FIELDS[i], rowIndex);
                        gridObj.$V(COMBINED_FIELDS[i], rowIndex, '');
                    }
                } else { //활성화
                    for (let i = 0; i < REQUIRED_FIELDS_1.length; i++) {
                        gridObj.makeCellRequired(REQUIRED_FIELDS_1[i], rowIndex);
                    }

                    if (data['CST_NUM'] === 'Y') {
                        for (let i = 0; i < REQUIRED_FIELDS_2.length; i++) {
                            gridObj.makeCellRequired(REQUIRED_FIELDS_2[i], rowIndex);
                        }
                    } else {
                        for (let i = 0; i < REQUIRED_FIELDS_2.length; i++) {
                            gridObj.makeCellReadOnly(REQUIRED_FIELDS_2[i], rowIndex);
                            gridObj.$V(REQUIRED_FIELDS_2[i], rowIndex, '');
                        }
                    }
                }

                if ($u.page.getPROGRAM_ID() === 'UD_SM_3000') {
                    if (F4DATA[0]['GLTYPE'] === 'X') { //거래처 비활성화
                        gridObj.makeCellReadOnly(EDITABLE_FIELDS[0], rowIndex);
                    } else { //거래처 활성화
                        gridObj.makeCellEditable(EDITABLE_FIELDS[0], rowIndex);
                    }
                }

            } else {
                gridObj.makeCellReadOnly(EDITABLE_FIELDS[0], rowIndex);
                gridObj.$V(EDITABLE_FIELDS[0], rowIndex, '');
                for (let i = 0; i < COMBINED_FIELDS.length; i++) {
                    gridObj.makeCellReadOnly(COMBINED_FIELDS[i], rowIndex);
                    gridObj.$V(COMBINED_FIELDS[i], rowIndex, '');
                }
            }
        }

        $sment.excelUpload_setAUFNRnHKONT_byWBS = (gridData) => {
            const gridObj = $u.gridWrapper.getGrid();

            if (gridData && gridData.length) {
                for (let i = 0; i < gridData.length; i++) {
                    const {PROJK, AUFNR, HKONT} = gridData[i];
                    if (PROJK) {
                        if (AUFNR) {
                            const AUFNR_F4_DATA = $u.f4Data.getCodeDataWithParams('AUFNR', {PROJK});
                            const currentF4_ITEM_AUFNR = AUFNR_F4_DATA.find(f4Item => f4Item['AUFNR'] === AUFNR);

                            if (currentF4_ITEM_AUFNR) {
                                gridObj.$V('AUFNR', i, currentF4_ITEM_AUFNR['AUFNR']);
                                gridObj.$V('AUFNR_TXT', i, currentF4_ITEM_AUFNR['AUFNR_TXT']);

                                const HKONT_F4_DATA = $u.f4Data.getCodeDataWithParams('HKONT', {
                                    PROJK,
                                    AUFNR: gridObj.$V('AUFNR', i, currentF4_ITEM_AUFNR['AUFNR'])
                                });
                                const currentF4_ITEM_HKONT = HKONT_F4_DATA.find(f4Item => f4Item['HKONT'] === HKONT);

                                if (currentF4_ITEM_HKONT) {
                                    gridObj.$V('HKONT', i, currentF4_ITEM_HKONT['HKONT']);
                                    gridObj.$V('HKONT_TXT', i, currentF4_ITEM_HKONT['HKONT_TXT']);

                                } else {
                                    gridObj.$V('HKONT', i, '');
                                    gridObj.$V('HKONT_TXT', i, '');
                                }
                            } else {
                                gridObj.$V('AUFNR', i, '');
                                gridObj.$V('AUFNR_TXT', i, '');
                                gridObj.$V('HKONT', i, '');
                                gridObj.$V('HKONT_TXT', i, '');
                            }
                        }
                    } else {
                        gridObj.$V('AUFNR', i, '');
                        gridObj.$V('AUFNR_TXT', i, '');
                        gridObj.$V('HKONT', i, '');
                        gridObj.$V('HKONT_TXT', i, '');
                    }
                }
            }
        }

        $sment.useGridObj2CheckBoxProgramIds = () => {
            const programId = $u.page.getPROGRAM_ID();
            return $u.util.contains(programId, ['UD_0204_100']);
        }

        $sment.setGridBtnImage_btn_view = (columnKey, ot_data) => {
            const gridObj = $u.gridWrapper.getGrid();

            for (let i = 0; i < ot_data.length; i++) {
                if (ot_data[i][columnKey] === 'X') gridObj.setCellEnableImage(columnKey+'_@', i)
            }

        }

        $sment.showEmp_imsurance_readOnly = (rowIndex) => {
            const gridObj = $u.gridWrapper.getGrid();
            const BELNR = gridObj.$V('BELNR', rowIndex);
            const GJAHR = gridObj.$V('GJAHR', rowIndex);

            $nst.is_data_nsReturn('ZUNIEFI_U930', {BELNR: BELNR, GJAHR: GJAHR}, function (nsReturn) {
                const OT_DATA1 = nsReturn.getTableReturn('OT_DATA1');
                const OT_DATA2 = nsReturn.getTableReturn('OT_DATA2');
                const O_TYPE = nsReturn.getStringReturns()['O_TYPE'];

                const isCompany = $u.util.contains(O_TYPE, ['ZKOR', 'ZFOR', 'ZSUB']);

                let templateString = '';
                templateString += '<div class="multi-calendar">';
                templateString += '<div id="dialog-empInsurance-form" class="unidocu-form-table-wrapper"></div>';
                // templateString += '<div class="btn_area uni-form-table-button-area" id="uni-buttons2"></div>';

                if (isCompany) {
                    templateString += '<div id="dialog-search-grid" class="unidocu-grid" data-sub-id="GRIDHEADER" data-sub-group="empInsuranceDialog_readOnly" style="height: 340px; margin: 10px 0;"></div>';
                    templateString += '<div id="dialog-search-grid2" class="unidocu-grid" data-sub-id="GRIDHEADER" data-sub-group="empInsuranceDialog_readOnly2" style="height: 340px; margin: 10px 0;"></div>';
                } else {
                    templateString += '<div id="dialog-search-grid" class="unidocu-grid" data-sub-id="GRIDHEADER" data-sub-group="empInsuranceDialog_readOnly_personal" style="height: 340px; margin: 10px 0;"></div>';
                    templateString += '<div id="dialog-search-grid2" class="unidocu-grid" data-sub-id="GRIDHEADER" data-sub-group="empInsuranceDialog_readOnly2_personal" style="height: 340px; margin: 10px 0;"></div>';
                }
                templateString += '</div>';

                const $dialog = $(templateString);
                $u.renderUIComponents($dialog);

                const dialogGrid = $u.gridWrapper.getGrid('dialog-search-grid');
                const dialogGrid2 = $u.gridWrapper.getGrid('dialog-search-grid2');
                let seletedGrid = dialogGrid;

                $u.get('SELECT').$el.change(function() {
                    if ($u.get('SELECT').getValue() === 'A') {
                        $(dialogGrid).show();
                        $(dialogGrid2).hide();
                        seletedGrid = dialogGrid;
                    } else {
                        $(dialogGrid).hide();
                        $(dialogGrid2).show();
                        seletedGrid = dialogGrid2;
                    }
                })

                var dialogButtons = [
                    $u.baseDialog.getButton($mls.getByCode('DLB_confirm'), function () {
                        $dialog.dialog('close');
                    }, 'unidocu-button dialogBlack')
                ];
                $u.baseDialog.openModalDialog($dialog, {
                    width: 1000,
                    title: '예술인 고용보험',
                    draggable: true,
                    resizable: true,
                    buttons: dialogButtons,
                    close: function () {
                        $dialog.remove();
                    }
                });

                const handleEmpInsurance = (type, data) => {
                    $u.get('SELECT').setValue(type);
                    $u.get('SELECT').triggerChange();
                    $u.get('SELECT').setReadOnly(true);

                    const GRID_HEADER = seletedGrid.getGridHeaders();

                    seletedGrid.setSummaryVisible(true, 'footer');
                    seletedGrid.setJSONData(data);

                    for (let i = 0; i < GRID_HEADER.length; i++) {
                        seletedGrid.makeColReadOnly(GRID_HEADER[i]['key']);
                    }
                }

                if (OT_DATA1.length) handleEmpInsurance('A', OT_DATA1);
                else if (OT_DATA2.length) handleEmpInsurance('B', OT_DATA2);
            })


        }

        $sment.empInsuranceDialog_clickBtn = ($dialog) => {
            $dialog.dialog("close");
            $efi.createStatement.calculateWithcdTax();
            $u.page.setCustomParam('editstatementInitialLoad', true);
        }

        $sment.artistBatchApplyDialog = () => {
            const gridObj = $u.gridWrapper.getGrid();
            gridObj.asserts.rowSelected();

            const SELECTED_DATA = gridObj.getSELECTEDJSONData();
            const splitFlag_HKONT = $u.f4Data.getCodeMapWithParams('HKONT', 'SPLIT_FLAG');
            const splitFlagXList = Object.keys(splitFlag_HKONT).filter(key => splitFlag_HKONT[key] === "X");

            for (let i = 0; i < SELECTED_DATA.length; i++) {
                if (SELECTED_DATA[0]['PROJK'] !== SELECTED_DATA[i]['PROJK']) throw '동일한 WBS만 선택 가능합니다.';
                if (SELECTED_DATA[i]['HKONT']) {
                    for (let j = 0; j < splitFlagXList.length; j++) {
                        const targetRow = i+1;
                        if (splitFlagXList[j] === SELECTED_DATA[i]['HKONT']) throw '['+targetRow+'행] 비용분할 계정은 일괄적용이 불가합니다.';
                    }
                }
            }

            if (SELECTED_DATA[0]['PROJK'] === '') throw 'WBS를 입력해 주시길 바랍니다.';

            var $dialog = $u.dialog.dialogLayout001({
                "subGroup": 'ARTIST_BATCH_APPLY_DIALOG_GL',
                "dialogTitle": $mls.getByCode('DLT_batchApplyDialog'),
                "ignoreGrid": true,
                "draggable": true,
                "dialogWidth": 700,
                "dialogButtons": [
                    $u.baseDialog.getButton($mls.getByCode('DLB_cancel'), function () {
                        $dialog.dialog('close');
                    }),
                    $u.baseDialog.getButton($mls.getByCode('DLB_confirm'), function () {
                        $u.validateRequired('dialog-search-form');
                        var values = $u.getValues('dialog-search-form');
                        $.each(values, function (key) {
                            if (/__DIALOG/.test(key)) values[key.replace('__DIALOG', '')] = values[key];
                        });

                        const getSelectedRowIndexes = gridObj.getSelectedRowIndexes();

                        for (let i = 0; i < getSelectedRowIndexes.length; i++) {
                            for (const [key, value] of Object.entries(values)) {
                                if (gridObj.getGridHeader(key)) gridObj.$V(key, getSelectedRowIndexes[i], value);
                            }
                        }
                        $dialog.dialog('close');
                    }, 'unidocu-button dialogBlack')
                ]
            });

            $u.get('ATI_TARGET__DIALOG').$el.change(function () {
                $u.get('AGCOD__DIALOG').setValue('');
                $u.get('AGNAM__DIALOG').setValue('');
                $u.get('AUCOD__DIALOG').setValue('');
                $u.get('AUNAM__DIALOG').setValue('');
                $u.get('ATCOD__DIALOG').setValue('');
                $u.get('ATNAM__DIALOG').setValue('');
                $u.get('ARTISTDATA__DIALOG').setValue('');
            })

            $u.get('ARTISTButton').$el.click(function () {
                if ($u.get('ATI_TARGET__DIALOG').getValue() === '') throw '정산대상을 선택해 주세요.';
                $sment.settlementDialog.open('artistBatchApplyByDialog');
            });
        }

    }
});
